import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, unref as _unref, mergeProps as _mergeProps, createBlock as _createBlock, normalizeStyle as _normalizeStyle, vModelText as _vModelText, withDirectives as _withDirectives, vShow as _vShow, withModifiers as _withModifiers, withKeys as _withKeys, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, vModelRadio as _vModelRadio, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "cashbook-page bankbook-test-page" }
const _hoisted_2 = {
  key: 0,
  class: "save-toast"
}
const _hoisted_3 = {
  key: 0,
  class: "cashbook-loading"
}
const _hoisted_4 = {
  key: 1,
  class: "adjust-shell"
}
const _hoisted_5 = { class: "work-header" }
const _hoisted_6 = { class: "work-top" }
const _hoisted_7 = {
  class: "wt-ym",
  "data-tour": "bb-test-ym"
}
const _hoisted_8 = { class: "wt-ym-y" }
const _hoisted_9 = { class: "wt-ym-m" }
const _hoisted_10 = ["value"]
const _hoisted_11 = {
  class: "wt-banks",
  "data-tour": "bb-test-banks"
}
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "wt-actions" }
const _hoisted_14 = {
  class: "wt-closing-slot",
  "data-tour": "bb-test-closing"
}
const _hoisted_15 = {
  key: 1,
  class: "wt-closed-badge"
}
const _hoisted_16 = {
  key: 2,
  class: "wt-closing-idle",
  title: "통장 선택·내역이 있으면 마감할 수 있습니다"
}
const _hoisted_17 = {
  class: "work-steps",
  "aria-label": "작업 단계",
  "data-tour": "bb-test-steps"
}
const _hoisted_18 = { class: "ws-body" }
const _hoisted_19 = {
  key: 0,
  class: "ws-meta"
}
const _hoisted_20 = {
  key: 1,
  class: "ws-meta done"
}
const _hoisted_21 = ["disabled", "title"]
const _hoisted_22 = { class: "ws-body" }
const _hoisted_23 = {
  key: 0,
  class: "ws-meta"
}
const _hoisted_24 = {
  key: 1,
  class: "ws-meta done"
}
const _hoisted_25 = ["disabled", "title"]
const _hoisted_26 = { class: "ws-body" }
const _hoisted_27 = {
  key: 0,
  class: "ws-meta"
}
const _hoisted_28 = {
  key: 1,
  class: "ws-meta done"
}
const _hoisted_29 = ["disabled", "title"]
const _hoisted_30 = { class: "cashbook-layout" }
const _hoisted_31 = {
  key: 0,
  class: "cashbook-sidebar"
}
const _hoisted_32 = { class: "sidebar-title-badge" }
const _hoisted_33 = {
  key: 0,
  class: "sidebar-summary",
  "data-tour": "bb-test-summary"
}
const _hoisted_34 = { class: "summary-item carryover" }
const _hoisted_35 = { class: "summary-header" }
const _hoisted_36 = { class: "value prev" }
const _hoisted_37 = { class: "summary-item income" }
const _hoisted_38 = { class: "value" }
const _hoisted_39 = { class: "summary-item expense" }
const _hoisted_40 = { class: "value" }
const _hoisted_41 = { class: "summary-header" }
const _hoisted_42 = { class: "value" }
const _hoisted_43 = ["title"]
const _hoisted_44 = { class: "lr-top" }
const _hoisted_45 = {
  key: 0,
  class: "lr-period"
}
const _hoisted_46 = {
  key: 1,
  class: "lr-badge"
}
const _hoisted_47 = {
  key: 2,
  class: "lr-badge muted"
}
const _hoisted_48 = {
  class: "lr-bar",
  "aria-hidden": "true"
}
const _hoisted_49 = { class: "lr-nums" }
const _hoisted_50 = { class: "lr-actual" }
const _hoisted_51 = { class: "lr-base" }
const _hoisted_52 = {
  key: 1,
  class: "lr-empty"
}
const _hoisted_53 = {
  key: 2,
  class: "sidebar-conditions",
  "data-tour": "bb-test-conditions"
}
const _hoisted_54 = { class: "cond-head" }
const _hoisted_55 = { class: "cond-row" }
const _hoisted_56 = { class: "cond-opts" }
const _hoisted_57 = { class: "cond-row" }
const _hoisted_58 = { class: "cond-opts" }
const _hoisted_59 = { key: 0 }
const _hoisted_60 = { class: "cond-row stacked" }
const _hoisted_61 = { class: "date-range-inputs day-only" }
const _hoisted_62 = ["max"]
const _hoisted_63 = ["min", "max", "placeholder"]
const _hoisted_64 = { class: "cond-row stacked" }
const _hoisted_65 = { class: "search-input-wrapper" }
const _hoisted_66 = { class: "cond-row stacked" }
const _hoisted_67 = { class: "search-input-wrapper" }
const _hoisted_68 = {
  key: 3,
  class: "sidebar-closing-section",
  "data-tour": "bb-test-heumieum"
}
const _hoisted_69 = { class: "closing-header" }
const _hoisted_70 = {
  key: 0,
  class: "closing-info"
}
const _hoisted_71 = {
  key: 1,
  class: "closing-info"
}
const _hoisted_72 = { class: "closing-actions" }
const _hoisted_73 = ["disabled"]
const _hoisted_74 = ["disabled"]
const _hoisted_75 = {
  key: 2,
  class: "closing-complete"
}
const _hoisted_76 = {
  key: 4,
  class: "sidebar-actions-panel"
}
const _hoisted_77 = { class: "sap-head" }
const _hoisted_78 = { class: "sap-block" }
const _hoisted_79 = { class: "sap-grid duo" }
const _hoisted_80 = ["disabled"]
const _hoisted_81 = {
  key: 0,
  class: "sap-block"
}
const _hoisted_82 = ["title"]
const _hoisted_83 = {
  key: 1,
  class: "sap-block"
}
const _hoisted_84 = ["disabled"]
const _hoisted_85 = { class: "month-memo-left" }
const _hoisted_86 = {
  key: 0,
  class: "month-memo-dot",
  "aria-hidden": "true"
}
const _hoisted_87 = { class: "month-memo-right" }
const _hoisted_88 = {
  key: 0,
  class: "month-memo-status"
}
const _hoisted_89 = {
  key: 1,
  class: "month-memo-status ok"
}
const _hoisted_90 = {
  key: 2,
  class: "month-memo-status err"
}
const _hoisted_91 = { class: "month-memo-body" }
const _hoisted_92 = ["disabled"]
const _hoisted_93 = { class: "month-memo-footer" }
const _hoisted_94 = { class: "month-memo-count" }
const _hoisted_95 = ["disabled"]
const _hoisted_96 = {
  key: 0,
  class: "shared-split"
}
const _hoisted_97 = {
  key: 0,
  class: "start-guide"
}
const _hoisted_98 = { class: "sg-head" }
const _hoisted_99 = { class: "sg-badge" }
const _hoisted_100 = { class: "sg-sub" }
const _hoisted_101 = { class: "sg-steps" }
const _hoisted_102 = { class: "sg-icon" }
const _hoisted_103 = {
  key: 1,
  class: "sg-done-label"
}
const _hoisted_104 = { class: "sg-icon" }
const _hoisted_105 = ["disabled"]
const _hoisted_106 = { class: "sg-after" }
const _hoisted_107 = {
  class: "shared-ledger",
  "data-tour": "bb-test-ledger"
}
const _hoisted_108 = {
  class: "sl-tabs",
  role: "tablist"
}
const _hoisted_109 = { key: 0 }
const _hoisted_110 = { key: 0 }
const _hoisted_111 = {
  key: 0,
  class: "raw-empty"
}
const _hoisted_112 = {
  key: 1,
  class: "cashbook-table-wrapper shared-ledger-table-wrap"
}
const _hoisted_113 = { class: "cashbook-table shared-ledger-table" }
const _hoisted_114 = { class: "th-check" }
const _hoisted_115 = ["disabled", "title", "aria-label"]
const _hoisted_116 = {
  key: 0,
  class: "th-bank"
}
const _hoisted_117 = ["onClick"]
const _hoisted_118 = ["onClick"]
const _hoisted_119 = { class: "td-date" }
const _hoisted_120 = { class: "td-gubun" }
const _hoisted_121 = { class: "td-memo" }
const _hoisted_122 = { class: "memo-container" }
const _hoisted_123 = ["title"]
const _hoisted_124 = {
  key: 1,
  class: "memo-missing"
}
const _hoisted_125 = { class: "td-scode" }
const _hoisted_126 = {
  key: 1,
  class: "scode-missing"
}
const _hoisted_127 = {
  key: 0,
  class: "rel-acc-name is-in"
}
const _hoisted_128 = {
  key: 1,
  class: "rel-acc-missing"
}
const _hoisted_129 = ["title"]
const _hoisted_130 = { class: "ben-match-name" }
const _hoisted_131 = ["onClick"]
const _hoisted_132 = {
  key: 2,
  class: "rel-acc-na"
}
const _hoisted_133 = { class: "td-funding" }
const _hoisted_134 = {
  key: 0,
  class: "funding-name"
}
const _hoisted_135 = {
  key: 1,
  class: "funding-missing"
}
const _hoisted_136 = {
  key: 0,
  class: "td-bank"
}
const _hoisted_137 = { class: "bank-badge" }
const _hoisted_138 = ["onClick"]
const _hoisted_139 = ["onClick"]
const _hoisted_140 = { class: "td-date" }
const _hoisted_141 = ["title", "onClick"]
const _hoisted_142 = { class: "split-expand-text" }
const _hoisted_143 = { class: "split-group-date" }
const _hoisted_144 = { class: "td-gubun" }
const _hoisted_145 = { class: "td-memo" }
const _hoisted_146 = { class: "memo-container" }
const _hoisted_147 = ["title"]
const _hoisted_148 = {
  key: 1,
  class: "memo-missing"
}
const _hoisted_149 = { class: "td-scode" }
const _hoisted_150 = ["onClick"]
const _hoisted_151 = { class: "td-funding" }
const _hoisted_152 = {
  key: 0,
  class: "funding-name"
}
const _hoisted_153 = {
  key: 1,
  class: "funding-missing"
}
const _hoisted_154 = {
  key: 0,
  class: "td-bank"
}
const _hoisted_155 = { class: "bank-badge" }
const _hoisted_156 = ["onClick"]
const _hoisted_157 = ["onClick"]
const _hoisted_158 = { class: "td-gubun" }
const _hoisted_159 = { class: "td-memo" }
const _hoisted_160 = { class: "memo-container" }
const _hoisted_161 = ["title"]
const _hoisted_162 = {
  key: 1,
  class: "memo-missing"
}
const _hoisted_163 = { class: "td-scode" }
const _hoisted_164 = {
  key: 1,
  class: "scode-missing"
}
const _hoisted_165 = {
  key: 0,
  class: "rel-acc-name is-in"
}
const _hoisted_166 = {
  key: 1,
  class: "rel-acc-missing"
}
const _hoisted_167 = ["title"]
const _hoisted_168 = { class: "ben-match-name" }
const _hoisted_169 = ["onClick"]
const _hoisted_170 = {
  key: 2,
  class: "rel-acc-na"
}
const _hoisted_171 = { class: "td-funding" }
const _hoisted_172 = {
  key: 0,
  class: "funding-name"
}
const _hoisted_173 = {
  key: 1,
  class: "funding-missing"
}
const _hoisted_174 = {
  key: 0,
  class: "td-bank"
}
const _hoisted_175 = { class: "bank-badge" }
const _hoisted_176 = { class: "shared-work" }
const _hoisted_177 = ["aria-expanded"]
const _hoisted_178 = { class: "sw-quick-head-left" }
const _hoisted_179 = { class: "sw-quick-meta" }
const _hoisted_180 = { class: "sw-quick-body" }
const _hoisted_181 = { class: "sw-quick-field" }
const _hoisted_182 = ["disabled", "onKeydown"]
const _hoisted_183 = { class: "sw-quick-amount" }
const _hoisted_184 = { class: "sw-quick-amount-row" }
const _hoisted_185 = {
  class: "sw-quick-gubun",
  role: "group",
  "aria-label": "수입 지출"
}
const _hoisted_186 = ["disabled"]
const _hoisted_187 = ["disabled"]
const _hoisted_188 = ["disabled", "onKeydown"]
const _hoisted_189 = { class: "sw-quick-actions" }
const _hoisted_190 = ["disabled"]
const _hoisted_191 = { key: 1 }
const _hoisted_192 = ["disabled"]
const _hoisted_193 = {
  key: 1,
  class: "sw-multi-hint"
}
const _hoisted_194 = ["disabled"]
const _hoisted_195 = {
  class: "sw-subtabs",
  role: "tablist",
  "data-tour": "bb-test-account"
}
const _hoisted_196 = ["disabled", "title"]
const _hoisted_197 = ["disabled"]
const _hoisted_198 = { class: "sw-pane" }
const _hoisted_199 = {
  class: "sw-funding sw-pane",
  "data-tour": "bb-test-funding"
}
const _hoisted_200 = { class: "fd-head" }
const _hoisted_201 = {
  key: 0,
  class: "fd-status"
}
const _hoisted_202 = { key: 0 }
const _hoisted_203 = {
  key: 1,
  class: "fd-status muted"
}
const _hoisted_204 = { class: "sw-focus" }
const _hoisted_205 = {
  key: 0,
  class: "fd-pick-stack"
}
const _hoisted_206 = ["disabled", "onClick"]
const _hoisted_207 = {
  key: 1,
  class: "sw-hint"
}
const _hoisted_208 = { class: "sw-split sw-pane" }
const _hoisted_209 = { class: "sw-focus" }
const _hoisted_210 = { class: "sw-focus-lbl" }
const _hoisted_211 = { class: "sw-focus-memo" }
const _hoisted_212 = { class: "sw-focus-meta" }
const _hoisted_213 = {
  key: 0,
  class: "sw-focus-meta"
}
const _hoisted_214 = ["disabled"]
const _hoisted_215 = ["disabled"]
const _hoisted_216 = ["disabled"]
const _hoisted_217 = {
  key: 1,
  class: "sw-hint"
}
const _hoisted_218 = {
  key: 1,
  class: "collection-embed-view",
  "data-tour": "bb-test-collection"
}
const _hoisted_219 = {
  key: 0,
  class: "start-guide"
}
const _hoisted_220 = { class: "sg-head" }
const _hoisted_221 = { class: "sg-badge" }
const _hoisted_222 = { class: "sg-sub" }
const _hoisted_223 = { class: "sg-warn" }
const _hoisted_224 = { class: "sg-steps" }
const _hoisted_225 = { class: "current" }
const _hoisted_226 = { class: "sg-icon" }
const _hoisted_227 = ["disabled"]
const _hoisted_228 = { class: "sg-icon" }
const _hoisted_229 = { class: "sg-after" }
const _hoisted_230 = {
  key: 2,
  class: "receipt-embed-view",
  "data-tour": "bb-test-receipt"
}
const _hoisted_231 = {
  key: 0,
  class: "start-guide"
}
const _hoisted_232 = { class: "sg-head" }
const _hoisted_233 = { class: "sg-badge" }
const _hoisted_234 = { class: "sg-sub" }
const _hoisted_235 = { class: "sg-steps" }
const _hoisted_236 = { class: "sg-icon" }
const _hoisted_237 = { class: "sg-icon" }
const _hoisted_238 = { class: "sg-icon" }
const _hoisted_239 = { class: "sg-after" }
const _hoisted_240 = {
  key: 3,
  class: "analysis-reference-embed-view",
  "data-tour": "bb-test-analysis"
}
const _hoisted_241 = { class: "notification-content" }
const _hoisted_242 = { class: "notification-text" }
const _hoisted_243 = { key: 0 }
const _hoisted_244 = { key: 1 }
const _hoisted_245 = { class: "delete-modal" }
const _hoisted_246 = { class: "delete-modal-header" }
const _hoisted_247 = { class: "delete-icon" }
const _hoisted_248 = ["disabled"]
const _hoisted_249 = { class: "delete-modal-body" }
const _hoisted_250 = { class: "delete-message" }
const _hoisted_251 = {
  key: 0,
  class: "delete-info"
}
const _hoisted_252 = { class: "info-row" }
const _hoisted_253 = { class: "info-value" }
const _hoisted_254 = { class: "info-row" }
const _hoisted_255 = { class: "info-row" }
const _hoisted_256 = { class: "info-value" }
const _hoisted_257 = {
  key: 0,
  class: "info-row"
}
const _hoisted_258 = { class: "info-value" }
const _hoisted_259 = {
  key: 1,
  class: "delete-summary"
}
const _hoisted_260 = { class: "summary-row" }
const _hoisted_261 = { class: "value income" }
const _hoisted_262 = { class: "summary-row" }
const _hoisted_263 = { class: "value expense" }
const _hoisted_264 = { class: "delete-modal-footer" }
const _hoisted_265 = ["disabled"]
const _hoisted_266 = { key: 1 }
const _hoisted_267 = { class: "delete-modal delete-all-modal" }
const _hoisted_268 = { class: "delete-modal-header" }
const _hoisted_269 = { class: "delete-icon danger" }
const _hoisted_270 = ["disabled"]
const _hoisted_271 = { class: "delete-modal-body" }
const _hoisted_272 = { class: "delete-message" }
const _hoisted_273 = { class: "count" }
const _hoisted_274 = { class: "delete-summary" }
const _hoisted_275 = { class: "summary-row" }
const _hoisted_276 = { class: "value income" }
const _hoisted_277 = { class: "summary-row" }
const _hoisted_278 = { class: "value expense" }
const _hoisted_279 = { class: "warning-box" }
const _hoisted_280 = { class: "delete-modal-footer" }
const _hoisted_281 = ["disabled"]
const _hoisted_282 = { key: 1 }
const _hoisted_283 = { class: "closing-modal" }
const _hoisted_284 = { class: "closing-modal-header" }
const _hoisted_285 = { class: "closing-icon" }
const _hoisted_286 = ["disabled"]
const _hoisted_287 = { class: "closing-modal-body" }
const _hoisted_288 = {
  key: 0,
  class: "validation-loading"
}
const _hoisted_289 = {
  key: 1,
  class: "validation-failed"
}
const _hoisted_290 = { class: "validation-alert" }
const _hoisted_291 = {
  key: 0,
  class: "validation-items"
}
const _hoisted_292 = { class: "item-date" }
const _hoisted_293 = { class: "item-memo" }
const _hoisted_294 = { class: "item-price" }
const _hoisted_295 = {
  key: 2,
  class: "validation-passed"
}
const _hoisted_296 = { class: "validation-success" }
const _hoisted_297 = { class: "closing-summary" }
const _hoisted_298 = { class: "summary-row" }
const _hoisted_299 = { class: "value" }
const _hoisted_300 = { class: "summary-row" }
const _hoisted_301 = { class: "value income" }
const _hoisted_302 = { class: "summary-row" }
const _hoisted_303 = { class: "value expense" }
const _hoisted_304 = { class: "warning-box info" }
const _hoisted_305 = { class: "closing-modal-footer" }
const _hoisted_306 = ["disabled"]
const _hoisted_307 = { key: 1 }
const _hoisted_308 = {
  class: "dictionary-manage-modal pattern-manage-modal",
  "data-tour": "bb-test-patterns-dialog"
}
const _hoisted_309 = { class: "modal-header learning" }
const _hoisted_310 = { class: "header-icon" }
const _hoisted_311 = { class: "modal-body pattern-manage-body" }
const _hoisted_312 = {
  class: "pattern-tabs",
  role: "tablist"
}
const _hoisted_313 = { key: 0 }
const _hoisted_314 = { key: 0 }
const _hoisted_315 = { class: "pattern-toolbar" }
const _hoisted_316 = { class: "pattern-search" }
const _hoisted_317 = { class: "pattern-count" }
const _hoisted_318 = {
  key: 0,
  class: "detail-loading"
}
const _hoisted_319 = {
  key: 1,
  class: "dict-list"
}
const _hoisted_320 = ["title"]
const _hoisted_321 = ["title"]
const _hoisted_322 = { class: "dict-count" }
const _hoisted_323 = ["onClick"]
const _hoisted_324 = {
  key: 2,
  class: "detail-empty"
}
const _hoisted_325 = { key: 0 }
const _hoisted_326 = { key: 1 }
const _hoisted_327 = { class: "modal-footer" }
const _hoisted_328 = { class: "beneficiary-match-dialog" }
const _hoisted_329 = { class: "match-dialog-header" }
const _hoisted_330 = { class: "match-dialog-body" }
const _hoisted_331 = {
  key: 0,
  class: "match-item-info"
}
const _hoisted_332 = { class: "match-date" }
const _hoisted_333 = { class: "match-memo" }
const _hoisted_334 = { class: "match-price" }
const _hoisted_335 = { class: "match-search-area" }
const _hoisted_336 = { class: "beneficiary-item-info" }
const _hoisted_337 = {
  key: 0,
  class: "ltc-no"
}
const _hoisted_338 = {
  key: 1,
  class: "charge-amount"
}
const _hoisted_339 = { class: "match-dialog-footer" }
const _hoisted_340 = ["disabled"]
const _hoisted_341 = {
  class: "bank-manage-modal",
  "data-tour": "bb-test-bank-manage-dialog"
}
const _hoisted_342 = { class: "modal-header bank" }
const _hoisted_343 = { class: "header-icon" }
const _hoisted_344 = { class: "modal-body" }
const _hoisted_345 = {
  key: 0,
  class: "bank-guide-section"
}
const _hoisted_346 = { class: "guide-header" }
const _hoisted_347 = { class: "guide-content" }
const _hoisted_348 = { class: "guide-notice" }
const _hoisted_349 = { class: "bank-list-section" }
const _hoisted_350 = { class: "section-header" }
const _hoisted_351 = {
  key: 0,
  class: "bank-list"
}
const _hoisted_352 = { class: "bank-group-header active" }
const _hoisted_353 = { class: "bank-main" }
const _hoisted_354 = { class: "bank-icon-wrapper active" }
const _hoisted_355 = { class: "bank-info" }
const _hoisted_356 = { class: "bank-top" }
const _hoisted_357 = { class: "bank-alias" }
const _hoisted_358 = { class: "bank-bottom" }
const _hoisted_359 = { class: "bank-name" }
const _hoisted_360 = { class: "account-no" }
const _hoisted_361 = { class: "bank-period" }
const _hoisted_362 = { class: "bank-actions" }
const _hoisted_363 = ["onClick"]
const _hoisted_364 = ["onClick"]
const _hoisted_365 = {
  key: 1,
  class: "bank-list inactive-section"
}
const _hoisted_366 = { class: "bank-main" }
const _hoisted_367 = { class: "bank-icon-wrapper inactive" }
const _hoisted_368 = { class: "bank-info" }
const _hoisted_369 = { class: "bank-top" }
const _hoisted_370 = { class: "bank-alias" }
const _hoisted_371 = { class: "status-tag ended" }
const _hoisted_372 = { class: "bank-bottom" }
const _hoisted_373 = { class: "bank-name" }
const _hoisted_374 = { class: "account-no" }
const _hoisted_375 = { class: "bank-period" }
const _hoisted_376 = { class: "bank-actions" }
const _hoisted_377 = ["onClick"]
const _hoisted_378 = ["onClick"]
const _hoisted_379 = {
  key: 2,
  class: "no-banks"
}
const _hoisted_380 = { class: "section-header" }
const _hoisted_381 = { class: "bank-form" }
const _hoisted_382 = { class: "form-row" }
const _hoisted_383 = { class: "form-group required" }
const _hoisted_384 = { class: "form-row two-cols" }
const _hoisted_385 = { class: "form-group required" }
const _hoisted_386 = { class: "form-group required" }
const _hoisted_387 = {
  key: 0,
  class: "form-row"
}
const _hoisted_388 = { class: "form-group" }
const _hoisted_389 = { class: "biz-gubun-select" }
const _hoisted_390 = ["value"]
const _hoisted_391 = { class: "form-row" }
const _hoisted_392 = { class: "form-group" }
const _hoisted_393 = { class: "form-row two-cols" }
const _hoisted_394 = { class: "form-group required" }
const _hoisted_395 = { class: "form-group" }
const _hoisted_396 = ["min"]
const _hoisted_397 = { class: "form-actions" }
const _hoisted_398 = ["disabled"]
const _hoisted_399 = { key: 1 }
const _hoisted_400 = { class: "modal-footer" }
const _hoisted_401 = { class: "delete-modal" }
const _hoisted_402 = { class: "delete-modal-header" }
const _hoisted_403 = { class: "delete-icon" }
const _hoisted_404 = ["disabled"]
const _hoisted_405 = { class: "delete-modal-body" }
const _hoisted_406 = {
  key: 0,
  class: "delete-info"
}
const _hoisted_407 = { class: "info-row" }
const _hoisted_408 = { class: "info-value" }
const _hoisted_409 = { class: "info-row" }
const _hoisted_410 = { class: "info-value" }
const _hoisted_411 = { class: "info-row" }
const _hoisted_412 = { class: "info-value" }
const _hoisted_413 = { class: "delete-modal-footer" }
const _hoisted_414 = ["disabled"]
const _hoisted_415 = { key: 1 }

import { ref, computed, onMounted, watch, inject, nextTick, type Ref } from 'vue';
import { useMemberYearMonthOptional } from '@/composables/useMemberYearMonth';
import { usePageTabNav } from '@/composables/usePageTabNav';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';
import { bankbookApi, beneficiaryApi, collectionApi, closingApi } from '@/services/api';
import PgmBankbookUpload from '@/components/bankbook/PgmBankbookUpload.vue';
import ReceiptMatchingDialog from '@/components/bankbook/ReceiptMatchingDialog.vue';
import BeneficiaryManageModal from '@/components/bankbook/BeneficiaryManageModal.vue';
import CollectionExcelUploadModal from '@/components/bankbook/CollectionExcelUploadModal.vue';
import SplitModal from '@/components/bankbook/SplitModal.vue';
import AccountPairManageModal from '@/components/bankbook/AccountPairManageModal.vue';
import LaborRatioDetailModal from '@/components/bankbook/LaborRatioDetailModal.vue';
import ClosingSettlementModal from '@/components/bankbook/ClosingSettlementModal.vue';
import BankbookAdjustWorkbench from '@/components/bankbook/BankbookAdjustWorkbench.vue';
import BankbookFeatureSpecPanel from '@/components/bankbook/BankbookFeatureSpecPanel.vue';
import BankbookMatchDialog from '@/components/bankbook/BankbookMatchDialog.vue';
import AccountingAnalysisReferenceEmbed from '@/components/bankbook/AccountingAnalysisReferenceEmbed.vue';
import { BANKBOOK_TEST_FEATURE_SPEC } from '@/constants/bankbookTestFeatureSpec';
import type { BankbookGuideHost, BankbookGuidePrepareResult } from '@/constants/bankbookTestFeatureSpec';
import { buildBankbookLearnItems } from '@/utils/bankbookMemoLearn';
import type {
  BankbookAutoKind,
  BankbookAutoActionState,
  BankbookAutoPreviewRow,
} from '@/components/bankbook/BankbookAutoDialog.vue';

interface IncomeBalanceItem {
  scode: string;
  sname: string;
  remaining: number;
  totalIncome: number;
  usedExpense: number;
  paired: boolean;
  allowedExpenses: Array<{ scode: string; sname: string }>;
}

interface PickerGroup {
  incomeScode: string;
  incomeSname: string;
  remaining: number;
  paired: boolean;
  expenses: Array<{ scode: string; sname: string }>;
}

interface RawDataValue {
  value: string;
  isMemo: boolean;
}

interface CashbookData {
  cb_idx?: number;
  cb_parent_idx?: number | null;  // 분개된 항목인 경우 원본 idx
  m_code?: number;
  cb_gubun: string;
  cb_scode?: string;
  cb_funding?: string;
  cb_memo: string;
  cb_raw_data?: Record<string, RawDataValue> | string | null;
  cb_price: number;
  cb_date: string;
  cb_order?: number;  // 같은 날짜 내 거래 순서
  cb_rel_acc?: string;
  cb_need_check?: string;
  cb_bank_name?: string;
  cb_bank_balance?: number;
  cb_bank_code?: string;
  cb_confirmed?: number;
  cb_source?: string;
  cb_wdate?: string;
  cb_rdate?: string;
  cb_receipt_matched?: number;
  crm_code?: number;
  split_count?: number;
  is_split_item?: number;  // 분개 항목 여부 (1이면 분개 항목)
  parent_idx?: number | null;  // cb_parent_idx와 동일
  cb_matched_beneficiary_idx?: number | null;  // 수동 매칭된 수급자 idx
}

// 통장 인터페이스
interface BankData {
  mb_idx: number;
  m_code: number;
  mb_code: string;
  mb_alias: string;
  mb_bank_name: string;
  mb_account_no: string;
  mb_purpose?: string;
  mb_biz_gubun?: string;
  mb_sort_order: number;
  mb_is_active: number;
  mb_start_date?: string;
  mb_end_date?: string;
  mb_wdate?: string;
  mb_rdate?: string;
}

// 계정코드 인터페이스 (caion_finance_code 테이블 기반)
interface AccountCode {
  cfc_idx: number;
  gubun: 'IN' | 'OUT';  // 수입/지출 구분
  gubun_name: string;   // '수입' | '지출'
  lcode: string;        // 대분류 코드
  lname: string;        // 대분류명
  mcode: string;        // 중분류 코드
  mname: string;        // 중분류명
  scode: string;        // 소분류 코드 (계정코드)
  sname: string;        // 소분류명 (계정명)
  cfc_hope_scode?: string;
  cfc_funding?: string;
}

interface DictItem {
  cd_idx: number;
  m_code?: number;
  cd_gubun: string;
  cd_keyword: string;
  cd_scode: string;
  cd_count: number;
  ac_name?: string;
}

// ============================================
// Props & Inject
// ============================================

interface FundingInferSettings {
  enabled: boolean;
  useRelAccountFunding: boolean;
  expenseNameRules: Array<{ name: string; funding: string }>;
  incomeFunding: Record<string, string>;
}

const MONTH_MEMO_MAX = 1000;
interface UploadNotification {
  id: number;
  show: boolean;
  bankCode: string;
  bankAlias: string;
  fileName: string;
  count: number;
  success: boolean;
  message?: string;
}
interface SharedLedgerGroup {
  parentIdx: number;
  cb_date: string;
  cb_gubun: string;
  cb_price: number;
  cb_memo: string;
  cb_funding?: string;
  cb_bank_code?: string;
  children: CashbookData[];
}

type SharedLedgerRow =
  | { kind: 'item'; key: string; item: CashbookData }
  | { kind: 'group'; key: string; group: SharedLedgerGroup };

interface GroupedAccount {
  scode: string;
  scodeName: string;
  gubun: 'IN' | 'OUT' | 'MIXED';
  items: CashbookData[];
  totalIncome: number;
  totalExpense: number;
  // 완료율 정보
  relAccFilledCount: number;  // 상대계정 입력된 수 (지출만 해당)
  relAccTotalCount: number;   // 상대계정 필요한 총 수 (지출 항목 수)
  memoFilledCount: number;    // 적요 입력된 수
}

// 계정별 그룹화된 목록
type AutoFillUpdate = {
  cbIdx: number;
  date?: string;
  memo?: string;
  price?: number;
  afterName?: string;
  keyword?: string;
  balance?: number;
  patch: Record<string, string>;
};

interface UploadResultInfo {
  bankCode: string;
  bankAlias: string;
  fileName: string;
  count: number;
  success: boolean;
  message?: string;
}

type GuideToastTone = 'info' | 'success' | 'warn';

export default /*@__PURE__*/_defineComponent({
  __name: 'MemberDetailBankbookTest',
  setup(__props) {

const bankbookFeatureSpec = BANKBOOK_TEST_FEATURE_SPEC;

const store = useStore();
const route = useRoute();

// 관리자 여부 (role_level 60 이상) — 페이지 내 기능용
const isAdmin = computed(() => (store.state.user?.roleLevel || 0) >= 60);

// 최고관리자 여부 (role_level 100)
const isSuperAdmin = computed(() => (store.state.user?.roleLevel || 0) >= 100);

/** 상단 더보기: 마감 해제·테스트 자료만 (짝/패턴은 우측 계정 톱니) */
const hasMoreMenuItems = computed(() =>
  (!!closingStatus.value?.isClosed && isAdmin.value)
  || (isSuperAdmin.value && !!selectedBankCode.value)
);

// ============================================
// 인터페이스 정의
// ============================================

const memberData = inject<any>('memberData');
const bizGubunColorMap = inject<any>('bizGubunColorMap');
const selectedBizGubunRef = inject<Ref<string>>('selectedBizGubun');

// 현재 선택된 사업구분 (computed로 안전하게 접근)
const selectedBizGubun = computed(() => selectedBizGubunRef?.value || '');

// 시설 ID (m_code: 내부 PK, m_longterm_code: 시설번호)
const memberCode = computed(() => {
  return route.params.memberCode as string || memberData?.value?.m_code || 0;
});

// 시설번호 (m_longterm_code) - cashbook에 저장할 때 사용
const longtermCode = computed(() => {
  return memberData?.value?.m_longterm_code || '';
});

// ============================================
// 상태 정의
// ============================================

const isLoading = ref(true);
const isSaving = ref(false);
const isDeleting = ref(false);
const isGeneratingTestData = ref(false);

// 마감 관련 상태
const closingDialogOpen = ref(false);
const isClosing = ref(false);
const isValidating = ref(false);
const closingStatus = ref<{
  isClosed: boolean;
  currentLevel: number;
  currentClosing?: {
    cc_idx: number;
    cc_status: string;
    cc_closed_at: string;
    statusName: string;
  };
} | null>(null);
const validationResult = ref<{
  valid: boolean;
  message?: string;
  details?: {
    count: number;
    items: Array<{
      cb_idx: number;
      gubun: string;
      date: string;
      memo: string;
      price: number;
    }>;
  };
} | null>(null);

// 희망이음 업로드 관련 상태
const isRequestingHeumieum = ref(false);
const heumieumStatus = ref<{
  status: 'requested' | 'completed' | null;
  requestAt?: string;
  completedAt?: string;
  completeMemo?: string;
  displayName?: string;
} | null>(null);

// 희망이음 상태 텍스트
const heumieumStatusText = computed(() => {
  if (!heumieumStatus.value?.status) return '미요청';
  if (heumieumStatus.value.status === 'requested') return '요청중';
  if (heumieumStatus.value.status === 'completed') return '완료';
  return '미요청';
});

// 통장별 마감 요약 상태 (전체 선택 시)
const closingSummary = ref<{
  total: number;
  closed: number;
  unclosed: number;
  allClosed: boolean;
  banks: Array<{
    mb_code: string;
    mb_alias: string;
    mb_bank_name: string;
    isClosed: boolean;
    closedAt: string | null;
  }>;
} | null>(null);

const cashbookList = ref<CashbookData[]>([]);
const accountCodes = ref<AccountCode[]>([]);
const highlightedIdxList = ref<number[]>([]);
const showSaveToast = ref(false);

// 자금원천 코드 목록
const fundingCodeList = [
  { code: '04', name: '자부담' },
  { code: '05', name: '후원금' },
  { code: '06', name: '수익사업' },
  { code: '07', name: '보조금' }
];

const defaultFundingInferSettings = (): FundingInferSettings => ({
  enabled: true,
  useRelAccountFunding: true,
  expenseNameRules: [
    { name: '생계비', funding: '04' },
    { name: '생계비(보조금)', funding: '07' },
  ],
  incomeFunding: {},
});

const fundingInferSettings = ref<FundingInferSettings>(defaultFundingInferSettings());
const fundingSettingsOpen = ref(false);
const matchDialogOpen = ref(false);
const matchKind = ref<'account' | 'rel' | 'funding'>('account');
const matchTargetIds = ref<number[]>([]);
const openMatchDialog = (kind: 'account' | 'rel' | 'funding') => {
  matchKind.value = kind;
  matchTargetIds.value = [...ledgerSelectedIds.value];
  matchDialogOpen.value = true;
};
const fundingSettingSaveState = ref<'idle' | 'saving' | 'saved' | 'error'>('idle');
const fundingIncomeSearch = ref('');
let fundingSettingSaveTimer: ReturnType<typeof setTimeout> | null = null;
let fundingSettingSavedTimer: ReturnType<typeof setTimeout> | null = null;

// 자금원천 자동부여 관련
const isAutoFundingProcessing = ref(false);

// 상대계정 자동부여 관련
const isAutoRelAccProcessing = ref(false);
const isAutoBeneficiaryMatching = ref(false);

// 자동화 모달 (계정·상대계정·자금원천·본인부담금)
const autoDialogOpen = ref(false);
const autoPreviewKind = ref<BankbookAutoKind | null>(null);
const autoPreviewRows = ref<BankbookAutoPreviewRow[]>([]);
const autoPreviewLoading = ref(false);
const autoPreviewError = ref('');
const autoApplying = ref(false);
const autoAccountReadyCount = ref(0);
const autoAccountCountLoading = ref(false);
const autoAccountDisabled = ref(false);
const autoAccountDisabledReason = ref('');
const autoRelReadyCount = ref(0);
const autoRelCountLoading = ref(false);
const isAutoAccountProcessing = ref(false);
const autoPendingFocus = ref<BankbookAutoKind | null>(null);
/** 미리보기에서 확정된 계정·상대계정 패치 (적용 시 표에 보인 값만 저장) */
const autoFillPreviewPatches = ref<Array<{ cbIdx: number; patch: Record<string, string> }>>([]);
/** 본인부담금 미리보기 매칭 결과 */
const autoBenPreviewMatches = ref<Record<string, { cb_idx: number; cb_name: string }>>({});

// 수납관리 엑셀 업로드 모달
const collectionExcelModalOpen = ref(false);
const beneficiaryEmbedRef = ref<{ refresh: () => Promise<void>; isCollectionEmpty?: boolean } | null>(null);

// 수급자 매칭 결과 { [cb_idx]: { cb_idx, cb_name, matchType } }
const beneficiaryMatches = ref<Record<number, { cb_idx: number; cb_name: string; matchType: string }>>({});

// 분개 내역 펼침 상태 { [cb_idx]: ChargeItem[] }
const expandedCollectionRows = ref<Set<number>>(new Set());
const collectionDetails = ref<Record<number, { scode: string; sname: string; charge: number; memo: string }[]>>({});

// 수납관리 모달
const beneficiaryModalSearchName = ref('');
// 통장내역 본인부담금 매칭 데이터 (수금관리에서 입금 정보 표시용)
const beneficiaryModalDepositData = ref<Record<number, { amount: number; date: string }>>({});

// 수급자 목록 (매칭용)
const beneficiaryList = ref<{ cb_idx: number; cb_name: string; cb_ltc_no?: string; cb_status?: string; cc_charge?: number; cc_idx?: number; totalCharge?: number }[]>([]);

// 인라인 수정 관련
const editingRowIdx = ref<number | null>(null);
const inlineEditData = ref<CashbookData>({
  cb_gubun: '',
  cb_scode: '',
  cb_funding: '',
  cb_memo: '',
  cb_price: 0,
  cb_date: '',
  cb_rel_acc: ''
});
const isInlineSaving = ref(false);

// 날짜 관련 (시설 공통 sessionStorage — 다른 리모컨 페이지와 연동)
const memberCodeForYm = computed(() => String(memberCode.value || ''));
const memberYearMonth = useMemberYearMonthOptional(memberCodeForYm);
const currentYear = computed(() => String(memberYearMonth.selectedYear.value));
const currentMonth = computed(() => String(memberYearMonth.selectedMonth.value).padStart(2, '0'));

// 해당 월의 마지막 일자
const lastDayOfMonth = computed(() => {
  return new Date(parseInt(currentYear.value), parseInt(currentMonth.value), 0).getDate();
});

// 월 선택기
const monthPickerRef = ref<HTMLInputElement | null>(null);

// 필터
const filterNeedCheck = ref(false);
const filterReceiptMatch = ref('all');  // 영수증 매칭 필터: all, matched, unmatched
/** 통장내역: 분개된 항목만 (분개 자식 / 원본 그룹) */
const filterSplitOnly = ref(false);
/** 통장내역 표시: cashbook=현금출납부(분개 펼침), upload=통장원본(접힘) */
const ledgerDisplayMode = ref<'cashbook' | 'upload'>('cashbook');
const expandedSplitParents = ref<Record<number, boolean>>({});
const searchScode = ref('');
const searchMemo = ref('');
const filterDayStart = ref<number | null>(null);  // 일자 필터 시작일 (1~31)
const filterDayEnd = ref<number | null>(null);    // 일자 필터 종료일 (1~31)

/** 이달의 메모 (기관·연월) */
const monthMemoOpen = ref(false);
const monthMemoText = ref('');
const monthMemoLoadedKey = ref('');
const isMonthMemoLoading = ref(false);
const monthMemoSaveState = ref<'idle' | 'saving' | 'saved' | 'error'>('idle');
let monthMemoSaveTimer: ReturnType<typeof setTimeout> | null = null;
let monthMemoStatusTimer: ReturnType<typeof setTimeout> | null = null;

// 보기 모드 (normal: 일반, grouped: 계정별 그룹화) — 레거시 잔존, 통장내역 보기와 별개
const viewMode = ref<'normal' | 'grouped'>('normal');
// raw = 통장내역, summary = 수납/영수증 임베드 컨테이너, analysis-reference = 계정별내역
const workSection = ref<'raw' | 'adjust' | 'funding' | 'summary' | 'analysis-reference'>('raw');
// summary 안에서 작업 큐: 수납 / 영수증
const workQueue = ref<'collection' | 'receipt' | null>(null);

// ─── 미설정만 보기 (scode | rel_acc | funding)
const activeMissingFilter = ref<'scode' | 'rel_acc' | 'funding' | null>(null);

// 사이드바 상단 배지 타이틀 (현재 탭 이름)
const sidebarTitle = computed(() => {
  if (workSection.value === 'raw') return '통장내역';
  if (workSection.value === 'adjust') return '계정조정';
  if (workSection.value === 'funding') return '자금원천';
  if (workQueue.value === 'collection') return '수납';
  if (workQueue.value === 'receipt') return '영수증';
  if (workSection.value === 'analysis-reference') return '정리 내역 보기';
  return '통장내역';
});

const isCollectionStep = computed(() =>
  workSection.value === 'summary' && workQueue.value === 'collection'
);

const isReceiptStep = computed(() =>
  workSection.value === 'summary' && workQueue.value === 'receipt'
);

const isAnalysisReferenceStep = computed(() =>
  workSection.value === 'analysis-reference'
);

// ─── 이 달(또는 선택된 통장)에 통장내역이 없는가?
// 없으면 계정조정/자금원천/수납영수증/정리내역 탭은 모두 소용없음 → 잠금
const hasNoBankbookData = computed(() => selectedBankCashbookList.value.length === 0);

const bankbookStepKey = computed(() => {
  if (isCollectionStep.value) return 'collection';
  if (isReceiptStep.value) return 'receipt';
  if (isAnalysisReferenceStep.value) return 'analysis-reference';
  return 'raw';
});

const bankbookPageTabs = computed(() => [
  { key: 'raw', title: '통장내역' },
  { key: 'collection', title: '수납', disabled: hasNoBankbookData.value },
  { key: 'receipt', title: '영수증', disabled: hasNoBankbookData.value },
  { key: 'analysis-reference', title: '정리 내역 보기', disabled: hasNoBankbookData.value },
]);
// 시작 가이드: 이 달 데이터가 아예 없을 때 원장+작업대 대신 전체 폭 가이드 표시
const showStartGuide = computed(() => workSection.value === 'raw' && !isLoading.value && hasNoBankbookData.value);

const accountPairModalOpen = ref(false);
const laborRatioModalOpen = ref(false);
const settlementModalOpen = ref(false);
const selectedIncomeScode = ref<string | null>(null);
const isAdjustStateLoading = ref(false);
const adjustIncomes = ref<IncomeBalanceItem[]>([]);
const adjustExpenseCodes = ref<Array<{ scode: string; sname: string }>>([]);

// 계정별 그룹화 펼침 상태 (scode -> boolean)
const expandedScodes = ref<Record<string, boolean>>({});

// 정렬 (기본값: cb_order 오름차순 = 통장내역 원본 순서)
const sortKey = ref<string>('cb_order');
const sortOrder = ref<'asc' | 'desc'>('asc');

// 다이얼로그
const uploadDialogOpen = ref(false);
const deleteDialogOpen = ref(false);
const deleteAllDialogOpen = ref(false);
const dictionaryManageModalOpen = ref(false);

// 업로드 완료 알림
const uploadNotifications = ref<UploadNotification[]>([]);
let notificationIdCounter = 0;

// 삭제 대상
const selectedItem = ref<CashbookData | null>(null);

// AI 학습 관련
const newKeywordInput = ref('');
const isAddingKeyword = ref(false);

// 딕셔너리 관리
const dictionaryStats = ref<{ income: number; expense: number; relmap: number } | null>(null);
const selectedDictTable = ref<string | null>(null);
const dictDetailList = ref<DictItem[]>([]);
const dictSearchQuery = ref('');
const isDictDetailLoading = ref(false);

const filteredDictDetailList = computed(() => {
  const q = dictSearchQuery.value.trim().toLowerCase();
  if (!q) return dictDetailList.value;
  return dictDetailList.value.filter((item) => {
    const keyword = String(item.cd_keyword || '').toLowerCase();
    const name = String(item.ac_name || item.cd_scode || '').toLowerCase();
    return keyword.includes(q) || name.includes(q);
  });
});

// 수급자 정보 변경 시 호출
const onBeneficiaryChanged = async () => {
  await loadBeneficiaryList();
  await matchBeneficiaries();
};

// 수납 데이터 삭제 시 호출
const onCollectionDeleted = async () => {
  // 수납관리 모달의 depositData 업데이트만 (매칭은 새로고침하지 않음)
  beneficiaryModalDepositData.value = collectDepositData();
};

// 청구금액 변경 시 호출 - 입금 재분배
const onChargeUpdated = async (cbIdx: number) => {
  // 해당 수급자에 매칭된 통장내역이 있는지 확인
  const hasMatch = Object.values(beneficiaryMatches.value).some(m => m.cb_idx === cbIdx);
  
  if (hasMatch) {
    // 입금 재분배 실행
    await syncDepositToCollection();
    // depositData 업데이트 (모달에서 새 데이터 로드 시 반영)
    beneficiaryModalDepositData.value = collectDepositData();
  }
};

// 수납관리 엑셀 업로드 완료 시 호출
const onCollectionExcelUploaded = async () => {
  await loadBeneficiaryList();
  await loadCashbookData();
  await matchBeneficiaries();
  // 임베드 수납 목록이 depositData/API 기준으로 다시 그려지도록
  beneficiaryModalDepositData.value = collectDepositData();
  await nextTick();
  await beneficiaryEmbedRef.value?.refresh();
};

// 수급자 매칭 다이얼로그
const beneficiaryMatchDialogOpen = ref(false);
const matchTargetItem = ref<CashbookData | null>(null);
const selectedBeneficiaryForMatch = ref<number | null>(null);

// 이월금
const prevMonthBalance = ref(0);

// 영수증 매칭 관련
const selectedCashbookForMatching = ref<CashbookData | null>(null);

// 분개(Split) 모달 관련
const splitModalOpen = ref(false);
const splitTargetCbIdx = ref<number | null>(null);
const isMergingSplit = ref(false);

const openSplitModal = (item: CashbookData) => {
  if (!item.cb_idx) return;
  // 이미 분개된 자식이면 원본(parent) 기준으로 수정
  const parentIdx = isSplitChildItem(item) ? getSplitParentIdx(item) : Number(item.cb_idx);
  if (!parentIdx) return;
  splitTargetCbIdx.value = parentIdx;
  splitModalOpen.value = true;
};

const mergeSplitTarget = async () => {
  const item = splitTargetItem.value;
  if (!item?.cb_idx || !isSplitChildItem(item) || isMergingSplit.value) return;
  if (closingStatus.value?.isClosed) {
    alert('마감된 달에는 분개를 합칠 수 없습니다.');
    return;
  }
  const parentIdx = getSplitParentIdx(item);
  if (!parentIdx) return;
  if (!confirm('분개된 항목을 합쳐 원본 한 건으로 되돌릴까요?')) return;

  isMergingSplit.value = true;
  try {
    const res = await bankbookApi.clearSplits(parentIdx);
    if (!res.data?.success) {
      throw new Error(res.data?.message || '분개 합치기에 실패했습니다.');
    }
    ledgerSelectedIds.value = [];
    await loadCashbookData();
    alert(res.data?.message || '분개를 합쳤습니다.');
  } catch (error: any) {
    alert(error.response?.data?.message || error.message || '분개 합치기 중 오류가 발생했습니다.');
  } finally {
    isMergingSplit.value = false;
  }
};

const onSplitSaved = async () => {
  await loadCashbookData();
};

// 통장 관련
const bankList = ref<BankData[]>([]);
const selectedBankCode = ref<string | null>(null);
const bankManageDialogOpen = ref(false);
const showBankForm = ref(false);
const showInactiveBanks = ref(false); // 종료된 통장 섹션 펼침 여부
const editingBank = ref<BankData | null>(null);
const bankFormData = ref({
  mb_alias: '',
  mb_bank_name: '',
  mb_account_no: '',
  mb_purpose: '',
  mb_biz_gubun: '',
  mb_start_date: '',
  mb_end_date: ''
});
const isSavingBank = ref(false);
const deleteBankDialogOpen = ref(false);
const bankToDelete = ref<BankData | null>(null);
const bankFormSectionRef = ref<HTMLElement | null>(null);
const showBankGuide = ref(false);
const isDeletingBank = ref(false);


// ============================================
// Computed
// ============================================

// 시설의 활성화된 사업구분 목록 (콤마 구분 문자열 파싱)
const facilityBizGubunList = computed(() => {
  const raw = memberData?.value?.m_biz_gubun;
  if (!raw) return [];
  return raw.split(',').map((s: string) => s.trim()).filter(Boolean);
});

// 통장 관리 모달용: 현재 연월 기준 사용중인 통장
const activeBankListForModal = computed(() => {
  return bankList.value.filter(bank => isBankActiveForCurrentMonth(bank));
});

// 통장 관리 모달용: 종료된 통장 (현재 연월에 사용 불가)
const inactiveBankListForModal = computed(() => {
  return bankList.value.filter(bank => !isBankActiveForCurrentMonth(bank));
});

// 사업구분 색상 가져오기
const getBizColor = (bizGubun: string) => {
  return bizGubunColorMap?.value?.[bizGubun] || '#607d8b';
};

// 선택된 통장 정보
const selectedBank = computed(() => {
  if (!selectedBankCode.value) return null;
  return bankList.value.find(b => b.mb_code === selectedBankCode.value) || null;
});

// 통장 폼 저장 가능 여부
const canSaveBank = computed(() => {
  return (bankFormData.value.mb_alias || '').trim() && 
         (bankFormData.value.mb_bank_name || '').trim() && 
         (bankFormData.value.mb_account_no || '').trim();
});

// 수입 계정코드 리스트
const incomeCodeList = computed(() => {
  return accountCodes.value.filter(ac => ac.gubun === 'IN');
});

// 지출 계정코드 리스트
const expenseCodeList = computed(() => {
  return accountCodes.value.filter(ac => ac.gubun === 'OUT');
});

const expensePickerGroups = computed<PickerGroup[]>(() => {
  const expenseCodes = adjustExpenseCodes.value.length
    ? adjustExpenseCodes.value
    : expenseCodeList.value.map((c) => ({ scode: c.scode, sname: c.sname }));
  // 잔액 무관하게 수입 계정 전체 표시 — 잔액 0 이하는 선택지에서 경고 표시
  return adjustIncomes.value
    .map((inc) => ({
      incomeScode: inc.scode,
      incomeSname: inc.sname,
      remaining: inc.remaining,
      paired: inc.paired,
      expenses: inc.paired && inc.allowedExpenses?.length
        ? inc.allowedExpenses
        : expenseCodes,
    }));
});

// 선택된 통장의 데이터 (필터 적용 전, 통장 선택만 적용)
const selectedBankCashbookList = computed(() => {
  if (!selectedBankCode.value) {
    return cashbookList.value;
  }
  return cashbookList.value.filter(item => item.cb_bank_code === selectedBankCode.value);
});

// 통장내역 탭 날짜 포맷은 formatDate 공용 사용

// ─── 공통 통장내역 고정 레이아웃 (통장내역에서 계정조정·자금원천) ───
const usesSharedLedger = computed(() => workSection.value === 'raw');

/** 항목 목록 탭: 요약·기간/계정/적요 검색 기본 표시 */
const showItemSidebarTools = computed(() => usesSharedLedger.value);

const adjustWorkbenchRef = ref<{
  switchTab: (tab: 'in' | 'out') => void;
  toggleRow: (item: CashbookData) => void;
  toggleIncomeRow: (item: CashbookData) => void;
  openSettings?: () => void;
  closeSettings?: () => void;
  setExpenseSelection?: (ids: number[]) => void;
  setIncomeSelection?: (ids: number[]) => void;
} | null>(null);

/** 통장내역 우측: 계정 | 상대계정(지출만) | 분개 | 자금원천 */
const rawWorkTab = ref<'account' | 'rel' | 'funding' | 'split'>('account');
const ledgerListTab = ref<'in' | 'out'>('in');
const ledgerSelectedIds = ref<number[]>([]);

const isSplitTabDisabled = computed(() => ledgerSelectedIds.value.length !== 1);

const splitTargetItem = computed(() => {
  if (ledgerSelectedIds.value.length !== 1) return null;
  const id = ledgerSelectedIds.value[0];
  return selectedBankCashbookList.value.find((item) => item.cb_idx === id) || null;
});

const singleSelectedItem = computed(() => splitTargetItem.value);

const selectedLedgerItems = computed(() =>
  selectedBankCashbookList.value.filter(
    (item) => item.cb_idx != null && ledgerSelectedIds.value.includes(item.cb_idx)
  )
);

const deletableSelectedCount = computed(() =>
  selectedLedgerItems.value.filter((item) => isItemEditable(item)).length
);

const deleteTargets = ref<CashbookData[]>([]);
const quickEditMemo = ref('');
const quickEditPriceText = ref('');
const quickEditGubun = ref<'IN' | 'OUT'>('IN');
const quickEditBaseline = ref<{ memo: string; price: number; gubun: 'IN' | 'OUT' }>({
  memo: '',
  price: 0,
  gubun: 'IN',
});
const isQuickEditSaving = ref(false);
const quickEditMemoRef = ref<HTMLInputElement | null>(null);
/** 적요·금액 편집 패널 — 1건 선택 시 펼침 */
const quickEditOpen = ref(false);

const formatPriceInput = (n: number) => {
  const v = Math.trunc(Number(n) || 0);
  if (!v) return '';
  const text = Math.abs(v).toLocaleString('ko-KR');
  return v < 0 ? `-${text}` : text;
};

const parsePriceInput = (value: string) => {
  const raw = String(value || '').replace(/,/g, '').trim();
  if (!raw || raw === '-') return 0;
  const neg = raw.startsWith('-');
  const digits = raw.replace(/[^\d]/g, '');
  const n = parseInt(digits, 10) || 0;
  return neg ? -n : n;
};

const quickEditDirty = computed(() => {
  const price = parsePriceInput(quickEditPriceText.value);
  return (
    String(quickEditMemo.value || '') !== String(quickEditBaseline.value.memo || '')
    || price !== (Number(quickEditBaseline.value.price) || 0)
    || quickEditGubun.value !== quickEditBaseline.value.gubun
  );
});

const syncQuickEditFromSelection = () => {
  const item = singleSelectedItem.value;
  if (!item) {
    quickEditMemo.value = '';
    quickEditPriceText.value = '';
    quickEditGubun.value = 'IN';
    quickEditBaseline.value = { memo: '', price: 0, gubun: 'IN' };
    return;
  }
  const memo = item.cb_memo || '';
  const price = Math.trunc(Number(item.cb_price) || 0);
  const gubun: 'IN' | 'OUT' = item.cb_gubun === 'OUT' ? 'OUT' : 'IN';
  quickEditMemo.value = memo;
  quickEditPriceText.value = formatPriceInput(price);
  quickEditGubun.value = gubun;
  quickEditBaseline.value = { memo, price, gubun };
};

watch(singleSelectedItem, (item) => {
  syncQuickEditFromSelection();
  quickEditOpen.value = !!item;
}, { immediate: true });

const onQuickEditPriceInput = (e: Event) => {
  const input = e.target as HTMLInputElement;
  const raw = input.value.replace(/,/g, '');
  const neg = raw.trim().startsWith('-');
  const digits = raw.replace(/[^\d]/g, '');
  if (!digits) {
    quickEditPriceText.value = neg ? '-' : '';
    return;
  }
  const n = parseInt(digits, 10) || 0;
  quickEditPriceText.value = `${neg ? '-' : ''}${n.toLocaleString('ko-KR')}`;
};

const saveQuickEdit = async () => {
  const item = singleSelectedItem.value;
  if (!item?.cb_idx || !quickEditDirty.value) return;
  if (closingStatus.value?.isClosed || !isItemEditable(item)) {
    alert('마감된 통장내역은 수정할 수 없습니다.\n마감 해제 후 수정해주세요.');
    return;
  }

  const memo = String(quickEditMemo.value || '').trim();
  const price = parsePriceInput(quickEditPriceText.value);
  if (!price) {
    alert('금액을 입력하세요.');
    return;
  }
  const gubun = quickEditGubun.value;
  const gubunChanged = gubun !== item.cb_gubun;
  isQuickEditSaving.value = true;
  try {
    await bankbookApi.update(item.cb_idx, {
      cb_memo: memo,
      cb_price: price,
      cb_gubun: gubun,
      ...(gubunChanged ? { cb_scode: '', cb_rel_acc: '' } : {}),
    });
    const idx = cashbookList.value.findIndex((row) => row.cb_idx === item.cb_idx);
    if (idx !== -1) {
      cashbookList.value[idx] = {
        ...cashbookList.value[idx],
        cb_memo: memo,
        cb_price: price,
        cb_gubun: gubun,
        ...(gubunChanged ? { cb_scode: '', cb_rel_acc: '' } : {}),
      };
    }
    quickEditBaseline.value = { memo, price, gubun };
    if (gubunChanged && item.cb_idx) {
      const nextTab = gubun === 'IN' ? 'in' : 'out';
      ledgerListTab.value = nextTab;
      ledgerSelectedIds.value = [item.cb_idx];
      await nextTick();
      adjustWorkbenchRef.value?.switchTab(nextTab);
      syncWorkbenchSelection();
    }
    showSaveToast.value = true;
    setTimeout(() => { showSaveToast.value = false; }, 2000);
    await loadAdjustState();
  } catch (error) {
    console.error('적요·금액 저장 오류:', error);
    alert('저장에 실패했습니다.');
  } finally {
    isQuickEditSaving.value = false;
  }
};

const sortByDateOrder = (a: CashbookData, b: CashbookData) => {
  const aT = a.cb_date ? new Date(a.cb_date).getTime() : 0;
  const bT = b.cb_date ? new Date(b.cb_date).getTime() : 0;
  if (aT !== bT) return aT - bT;
  return (Number(a.cb_order) || 0) - (Number(b.cb_order) || 0);
};

const compareSharedLedger = (a: CashbookData, b: CashbookData) => {
  const dir = sortOrder.value === 'asc' ? 1 : -1;
  const key = sortKey.value;
  let cmp = 0;
  if (key === 'cb_order' || key === 'cb_date') {
    cmp = sortByDateOrder(a, b);
  } else if (key === 'cb_price') {
    cmp = (Number(a.cb_price) || 0) - (Number(b.cb_price) || 0);
  } else if (key === 'cb_memo') {
    cmp = String(a.cb_memo || '').localeCompare(String(b.cb_memo || ''), 'ko');
  } else if (key === 'cb_scode') {
    cmp = ledgerScodeLabel(a).localeCompare(ledgerScodeLabel(b), 'ko');
  } else if (key === 'cb_rel_acc') {
    const aLabel = a.cb_gubun === 'IN'
      ? (a.cb_idx ? (beneficiaryMatches.value[a.cb_idx]?.cb_name || '') : '')
      : ledgerRelLabel(a);
    const bLabel = b.cb_gubun === 'IN'
      ? (b.cb_idx ? (beneficiaryMatches.value[b.cb_idx]?.cb_name || '') : '')
      : ledgerRelLabel(b);
    cmp = aLabel.localeCompare(bLabel, 'ko');
  } else if (key === 'cb_funding') {
    cmp = getFundingName(a.cb_funding).localeCompare(getFundingName(b.cb_funding), 'ko');
  } else {
    cmp = String((a as unknown as Record<string, unknown>)[key] || '')
      .localeCompare(String((b as unknown as Record<string, unknown>)[key] || ''), 'ko');
  }
  if (cmp !== 0) return cmp * dir;
  return sortByDateOrder(a, b);
};

const isSplitChildItem = (item: CashbookData) => {
  if (Number(item.is_split_item) === 1) return true;
  const pid = item.parent_idx ?? item.cb_parent_idx;
  return pid != null && Number(pid) > 0;
};

const getSplitParentIdx = (item: CashbookData) => {
  const pid = item.parent_idx ?? item.cb_parent_idx;
  return pid != null ? Number(pid) : 0;
};

const applyLedgerSearch = (list: CashbookData[]) => {
  let next = list;
  if (filterSplitOnly.value) {
    next = next.filter(isSplitChildItem);
  }
  if (searchMemo.value) {
    const q = searchMemo.value.toLowerCase();
    next = next.filter((item) => item.cb_memo && item.cb_memo.toLowerCase().includes(q));
  }
  if (searchScode.value) {
    const q = searchScode.value.toLowerCase();
    next = next.filter((item) => {
      const name = getScodeDisplayName(item.cb_scode, item.cb_gubun);
      return (item.cb_scode && item.cb_scode.toLowerCase().includes(q))
        || name.toLowerCase().includes(q);
    });
  }
  if (filterDayStart.value || filterDayEnd.value) {
    const startDay = filterDayStart.value || 1;
    const endDay = filterDayEnd.value || lastDayOfMonth.value;
    next = next.filter((item) => {
      const day = new Date(item.cb_date).getDate();
      return day >= startDay && day <= endDay;
    });
  }
  return next;
};

const ledgerTabInBadge = computed(() =>
  selectedBankCashbookList.value.filter((item) => item.cb_gubun === 'IN').length
);

const ledgerTabOutBadge = computed(() =>
  selectedBankCashbookList.value.filter((item) => item.cb_gubun === 'OUT').length
);

/** 분개 필터 배지: 분개 원본(parent) 건수 */
const splitFilterCount = computed(() => {
  const parents = new Set<number>();
  for (const item of selectedBankCashbookList.value) {
    if (!isSplitChildItem(item)) continue;
    const pid = getSplitParentIdx(item);
    if (pid) parents.add(pid);
  }
  return parents.size;
});

/** 통장내역 조건 섹션: 초기화 버튼 표시 여부 */
const hasActiveLedgerConditions = computed(() =>
  filterSplitOnly.value
  || !!searchScode.value
  || !!searchMemo.value
  || filterDayStart.value != null
  || filterDayEnd.value != null
  || ledgerDisplayMode.value !== 'cashbook'
);

/** 출납부형 기준 평탄 목록 (선택·작업용) */
const sharedLedgerItems = computed(() => {
  const wantIn = ledgerListTab.value === 'in';
  let list = selectedBankCashbookList.value.filter((item) =>
    wantIn ? item.cb_gubun === 'IN' : item.cb_gubun === 'OUT'
  );
  return applyLedgerSearch(list).sort(compareSharedLedger);
});

const buildUploadGroup = (parentIdx: number, children: CashbookData[]): SharedLedgerGroup => {
  const sorted = [...children].sort(sortByDateOrder);
  const first = sorted[0];
  const fundings = [...new Set(sorted.map((c) => c.cb_funding || '').filter(Boolean))];
  return {
    parentIdx,
    cb_date: first?.cb_date || '',
    cb_gubun: first?.cb_gubun || 'OUT',
    cb_price: sorted.reduce((sum, c) => sum + Math.abs(Number(c.cb_price) || 0), 0),
    cb_memo: first?.cb_memo || '',
    cb_funding: fundings.length === 1 ? fundings[0] : undefined,
    cb_bank_code: first?.cb_bank_code,
    children: sorted,
  };
};

/** 화면 표시용 행 (출납부형=평탄 / 통장원본=그룹) */
const sharedLedgerRows = computed((): SharedLedgerRow[] => {
  const items = sharedLedgerItems.value;
  if (ledgerDisplayMode.value === 'cashbook') {
    return items.map((item) => ({
      kind: 'item' as const,
      key: `item-${item.cb_idx}`,
      item,
    }));
  }

  const groups = new Map<number, CashbookData[]>();
  const singles: CashbookData[] = [];
  for (const item of items) {
    const pid = getSplitParentIdx(item);
    if (pid > 0) {
      const arr = groups.get(pid) || [];
      arr.push(item);
      groups.set(pid, arr);
    } else {
      singles.push(item);
    }
  }

  const rows: SharedLedgerRow[] = [];
  for (const item of singles) {
    rows.push({ kind: 'item', key: `item-${item.cb_idx}`, item });
  }
  for (const [parentIdx, children] of groups.entries()) {
    rows.push({
      kind: 'group',
      key: `group-${parentIdx}`,
      group: buildUploadGroup(parentIdx, children),
    });
  }
  rows.sort((a, b) => {
    const aItem = a.kind === 'item' ? a.item : a.group.children[0];
    const bItem = b.kind === 'item' ? b.item : b.group.children[0];
    return compareSharedLedger(aItem, bItem);
  });
  return rows;
});

const sharedLedgerEmptyMessage = computed(() => {
  if (filterSplitOnly.value) {
    const hasAny = selectedBankCashbookList.value.some((item) =>
      (ledgerListTab.value === 'in' ? item.cb_gubun === 'IN' : item.cb_gubun === 'OUT')
      && isSplitChildItem(item)
    );
    if (!hasAny) return '분개된 항목이 없습니다.';
    return '검색 조건에 맞는 분개 항목이 없습니다.';
  }
  return ledgerListTab.value === 'in' ? '수입 내역이 없습니다.' : '지출 내역이 없습니다.';
});

const isSplitGroupExpanded = (parentIdx: number) => !!expandedSplitParents.value[parentIdx];

const toggleSplitGroup = (parentIdx: number) => {
  expandedSplitParents.value = {
    ...expandedSplitParents.value,
    [parentIdx]: !expandedSplitParents.value[parentIdx],
  };
};

const isSharedGroupPicked = (group: SharedLedgerGroup) => {
  if (!group.children.length) return false;
  return group.children.every((c) => c.cb_idx && ledgerSelectedIds.value.includes(c.cb_idx));
};

const onSharedGroupClick = (group: SharedLedgerGroup) => {
  if (workSection.value !== 'raw') return;
  const editable = group.children.filter((c) => c.cb_idx && isItemEditable(c));
  if (!editable.length) return;

  const wantTab = group.cb_gubun === 'IN' ? 'in' : 'out';
  if (ledgerListTab.value !== wantTab) {
    ledgerListTab.value = wantTab;
    ledgerSelectedIds.value = [];
    adjustWorkbenchRef.value?.switchTab(wantTab);
  }

  const ids = editable.map((c) => c.cb_idx as number);
  const allOn = ids.every((id) => ledgerSelectedIds.value.includes(id));

  if (rawWorkTab.value === 'account' || rawWorkTab.value === 'rel') {
    if (allOn) {
      // 선택 해제: 각 행 toggle
      for (const child of editable) {
        if (wantTab === 'in') adjustWorkbenchRef.value?.toggleIncomeRow(child);
        else adjustWorkbenchRef.value?.toggleRow(child);
      }
    } else {
      // 미선택 것만 토글해 모두 선택
      for (const child of editable) {
        if (child.cb_idx && ledgerSelectedIds.value.includes(child.cb_idx)) continue;
        if (wantTab === 'in') adjustWorkbenchRef.value?.toggleIncomeRow(child);
        else adjustWorkbenchRef.value?.toggleRow(child);
      }
    }
    return;
  }

  if (allOn) {
    const idSet = new Set(ids);
    ledgerSelectedIds.value = ledgerSelectedIds.value.filter((id) => !idSet.has(id));
  } else {
    const merged = new Set([...ledgerSelectedIds.value, ...ids]);
    ledgerSelectedIds.value = [...merged];
  }
};

watch(ledgerDisplayMode, () => {
  expandedSplitParents.value = {};
});

const fundingSelectedItems = computed(() =>
  selectedBankCashbookList.value.filter(
    (item) => item.cb_idx && ledgerSelectedIds.value.includes(item.cb_idx) && isItemEditable(item)
  )
);

const fundingSelectedSameCode = computed(() => {
  const codes = [...new Set(fundingSelectedItems.value.map((item) => item.cb_funding || ''))];
  if (codes.length !== 1 || !codes[0]) return null;
  return codes[0];
});

const hasLedgerScode = (item: CashbookData) =>
  !!(item.cb_scode && String(item.cb_scode).trim());

const hasLedgerRel = (item: CashbookData) =>
  !!(item.cb_rel_acc && String(item.cb_rel_acc).trim());

const ledgerScodeLabel = (item: CashbookData) => {
  if (!hasLedgerScode(item)) return '미설정';
  return getScodeDisplayName(item.cb_scode, item.cb_gubun) || item.cb_scode || '미설정';
};

const ledgerRelLabel = (item: CashbookData) => {
  if (item.cb_gubun === 'IN') return '-';
  if (!hasLedgerRel(item)) return '미설정';
  return getScodeDisplayName(item.cb_rel_acc, 'IN') || item.cb_rel_acc || '미설정';
};

const isSharedRowPicked = (item: CashbookData) =>
  !!item.cb_idx && ledgerSelectedIds.value.includes(item.cb_idx);

const syncWorkbenchSelection = () => {
  const wb = adjustWorkbenchRef.value;
  if (!wb) return;
  if (ledgerListTab.value === 'in') {
    wb.setIncomeSelection?.(ledgerSelectedIds.value);
  } else {
    wb.setExpenseSelection?.(ledgerSelectedIds.value);
  }
};

const setLedgerListTab = (tab: 'in' | 'out') => {
  if (ledgerListTab.value === tab) return;
  ledgerListTab.value = tab;
  ledgerSelectedIds.value = [];
  adjustWorkbenchRef.value?.switchTab(tab);
  syncWorkbenchSelection();
};

const onWorkbenchListTab = (tab: 'in' | 'out') => {
  if (ledgerListTab.value === tab) return;
  ledgerListTab.value = tab;
  ledgerSelectedIds.value = [];
};

const onAdjustSelectionChange = (payload: {
  listTab: 'in' | 'out';
  expenseIds: number[];
  incomeIds: number[];
}) => {
  // 목록의 수입/지출 탭이 기준. 워크벤치 내부 탭이 어긋나면 화면을 수입으로 되돌리지 않는다.
  if (payload.listTab !== ledgerListTab.value) {
    adjustWorkbenchRef.value?.switchTab(ledgerListTab.value);
    return;
  }
  ledgerSelectedIds.value = payload.listTab === 'in' ? payload.incomeIds : payload.expenseIds;
};

/** 계정 탭 — 지금 보고 있는 수입/지출 목록을 유지 */
const openLedgerAccountTab = () => {
  rawWorkTab.value = 'account';
  nextTick(() => {
    adjustWorkbenchRef.value?.switchTab(ledgerListTab.value);
    syncWorkbenchSelection();
  });
};

const clearLedgerSelection = () => {
  ledgerSelectedIds.value = [];
  syncWorkbenchSelection();
};

const selectableVisibleLedgerIds = computed(() =>
  sharedLedgerItems.value
    .filter((item) => item.cb_idx && isItemEditable(item))
    .map((item) => item.cb_idx as number)
);

const isAllVisibleLedgerSelected = computed(() => {
  const ids = selectableVisibleLedgerIds.value;
  return ids.length > 0 && ids.every((id) => ledgerSelectedIds.value.includes(id));
});

const isSomeVisibleLedgerSelected = computed(() => {
  const ids = selectableVisibleLedgerIds.value;
  return ids.some((id) => ledgerSelectedIds.value.includes(id));
});

const selectAllVisibleLedger = () => {
  ledgerSelectedIds.value = [...selectableVisibleLedgerIds.value];
  syncWorkbenchSelection();
};

const toggleSelectAllVisibleLedger = () => {
  if (isAllVisibleLedgerSelected.value) {
    clearLedgerSelection();
    return;
  }
  selectAllVisibleLedger();
};

const onSharedLedgerClick = (item: CashbookData) => {
  if (workSection.value !== 'raw') return;
  if (!item.cb_idx || !isItemEditable(item)) return;

  // 수입/지출 탭과 행 구분이 다르면 탭을 맞춘 뒤 선택
  const wantTab = item.cb_gubun === 'IN' ? 'in' : 'out';
  if (ledgerListTab.value !== wantTab) {
    ledgerListTab.value = wantTab;
    ledgerSelectedIds.value = [];
    adjustWorkbenchRef.value?.switchTab(wantTab);
  }

  // 계정·상대계정·자금원천 탭: 워크벤치 선택을 토글 (조정하기는 워크벤치 선택 기준,
  // 워크벤치가 selection-change를 emit해 부모 ledgerSelectedIds와 자동 동기화됨)
  if (
    rawWorkTab.value === 'account' ||
    rawWorkTab.value === 'rel' ||
    rawWorkTab.value === 'funding'
  ) {
    if (wantTab === 'in') {
      adjustWorkbenchRef.value?.toggleIncomeRow(item);
    } else {
      adjustWorkbenchRef.value?.toggleRow(item);
    }
    return;
  }

  // 그 외(분개 탭 등): 부모 선택만 토글
  if (ledgerSelectedIds.value.includes(item.cb_idx)) {
    ledgerSelectedIds.value = ledgerSelectedIds.value.filter((id) => id !== item.cb_idx);
  } else {
    ledgerSelectedIds.value = [...ledgerSelectedIds.value, item.cb_idx];
  }
};

watch(workSection, (section, prev) => {
  if (section === 'adjust' || section === 'funding') {
    rawWorkTab.value = section === 'adjust' ? 'account' : 'funding';
    workSection.value = 'raw';
    return;
  }
  // adjust/funding → raw 리다이렉트 직후에는 선택 유지
  if (prev === 'adjust' || prev === 'funding') return;
  ledgerSelectedIds.value = [];
});

watch(rawWorkTab, (tab) => {
  if (tab === 'account' || tab === 'rel') {
    nextTick(() => syncWorkbenchSelection());
  }
});

watch(ledgerListTab, (tab) => {
  // 수입 목록: 상대계정 숨김 → 계정으로
  if (tab === 'in' && rawWorkTab.value === 'rel') {
    rawWorkTab.value = 'account';
  }
});

watch(ledgerSelectedIds, (ids) => {
  // 2건 이상 선택 시 분개 탭 비활성 → 다른 탭으로 이동
  if (ids.length !== 1 && rawWorkTab.value === 'split') {
    rawWorkTab.value = 'account';
  }
});

const workbenchIncomes = computed(() =>
  adjustIncomes.value.map((item) => ({
    ...item,
    totalIncome: Number(item.totalIncome) || 0,
    usedExpense: Number(item.usedExpense) || 0,
  }))
);

const pendingAdjustList = computed(() =>
  selectedBankCashbookList.value.filter((item) => {
    if (item.cb_gubun !== 'OUT') return false;
    const noScode = !item.cb_scode || !String(item.cb_scode).trim();
    const noRel = !item.cb_rel_acc || !String(item.cb_rel_acc).trim();
    return noScode || noRel;
  })
);

const doneAdjustList = computed(() =>
  selectedBankCashbookList.value.filter((item) =>
    item.cb_gubun === 'OUT' && !!item.cb_scode && !!item.cb_rel_acc
  )
);

const pendingIncomeList = computed(() =>
  selectedBankCashbookList.value.filter((item) =>
    item.cb_gubun === 'IN' && (!item.cb_scode || !String(item.cb_scode).trim())
  )
);

const doneIncomeList = computed(() =>
  selectedBankCashbookList.value.filter((item) =>
    item.cb_gubun === 'IN' && !!item.cb_scode && String(item.cb_scode).trim() !== ''
  )
);

const adjustProgress = computed(() => {
  const total = selectedBankCashbookList.value.filter((item) => item.cb_gubun === 'OUT').length;
  const done = doneAdjustList.value.length;
  return {
    total,
    done,
    percent: total ? Math.round((done / total) * 100) : 0,
  };
});

const canOpenClosing = computed(() =>
  !!selectedBankCode.value
  && !closingStatus.value?.isClosed
  && selectedBankCashbookList.value.length > 0
);

const pendingAdjustCount = computed(() =>
  pendingAdjustList.value.length + pendingIncomeList.value.length
);

/** 계정 탭 완료: 수입·지출 계정(scode) 모두 지정 */
const isAccountTabDone = computed(() => {
  if (!selectedBankCashbookList.value.length) return false;
  const incomePending = pendingIncomeList.value.length > 0;
  const expensePending = selectedBankCashbookList.value.some(
    (item) => item.cb_gubun === 'OUT' && (!item.cb_scode || !String(item.cb_scode).trim())
  );
  return !incomePending && !expensePending;
});

/** 상대계정 탭 완료: 지출의 상대계정 모두 지정 */
const isRelTabDone = computed(() => {
  if (!selectedBankCashbookList.value.length) return false;
  return !selectedBankCashbookList.value.some(
    (item) => item.cb_gubun === 'OUT' && (!item.cb_rel_acc || !String(item.cb_rel_acc).trim())
  );
});

const isFundingTabDone = computed(() =>
  selectedBankCashbookList.value.length > 0 && unfundedCount.value === 0
);

// 스텝 클릭
//   raw(+adjust/funding 우측탭) / collection / receipt / analysis-reference
//   (구 summary 현금출납부 탭은 통장내역 보기「현금출납부」로 통합)
const goStep = (
  step: 'raw' | 'adjust' | 'rel' | 'funding' | 'collection' | 'receipt' | 'summary' | 'analysis-reference',
  opts?: { keepReceiptItem?: boolean; collectionSearch?: string | null; force?: boolean }
) => {
  // 통장내역이 없으면 raw 외에는 이동 불가 (가이드 force 제외)
  if (
    hasNoBankbookData.value
    && !opts?.force
    && step !== 'raw'
    && step !== 'adjust'
    && step !== 'rel'
    && step !== 'funding'
  ) return;

  // 구 현금출납부 탭 → 통장내역 + 현금출납부(분개 펼침) 보기
  if (step === 'summary') {
    workSection.value = 'raw';
    workQueue.value = null;
    activeMissingFilter.value = null;
    filterReceiptMatch.value = 'all';
    ledgerDisplayMode.value = 'cashbook';
    return;
  }

  // 계정·상대계정·자금원천 → 통장내역 + 우측 서브탭
  if (step === 'adjust' || step === 'rel' || step === 'funding') {
    workSection.value = 'raw';
    workQueue.value = null;
    activeMissingFilter.value = null;
    filterReceiptMatch.value = 'all';
    if (step === 'rel') {
      ledgerListTab.value = 'out';
      rawWorkTab.value = 'rel';
      nextTick(() => {
        adjustWorkbenchRef.value?.switchTab('out');
        syncWorkbenchSelection();
      });
      return;
    }
    rawWorkTab.value = step === 'adjust' ? 'account' : 'funding';
    nextTick(() => {
      adjustWorkbenchRef.value?.switchTab(ledgerListTab.value);
      syncWorkbenchSelection();
    });
    return;
  }

  if (step === 'collection' || step === 'receipt') {
    workSection.value = 'summary';
    workQueue.value = step;
    activeMissingFilter.value = null;
    filterReceiptMatch.value = 'all';
    if (step === 'collection') {
      if (opts && 'collectionSearch' in opts) {
        beneficiaryModalSearchName.value = opts.collectionSearch || '';
      } else {
        beneficiaryModalSearchName.value = '';
      }
      beneficiaryModalDepositData.value = collectDepositData();
    }
    if (step === 'receipt' && !opts?.keepReceiptItem) {
      selectedCashbookForMatching.value = null;
    }
  } else {
    workSection.value = step;
    workQueue.value = null;
    activeMissingFilter.value = null;
    filterReceiptMatch.value = 'all';
    if (step === 'raw') {
      nextTick(() => {
        adjustWorkbenchRef.value?.switchTab(ledgerListTab.value);
        syncWorkbenchSelection();
      });
    }
  }
};

usePageTabNav('bankbook', bankbookPageTabs, bankbookStepKey, (key) => {
  if (
    key === 'raw'
    || key === 'collection'
    || key === 'receipt'
    || key === 'analysis-reference'
  ) {
    goStep(key);
  }
});

// 데이터가 없어지면 자동으로 통장내역(raw) 탭으로 복귀
watch(hasNoBankbookData, (isEmpty) => {
  if (isEmpty && workSection.value !== 'raw') {
    workSection.value = 'raw';
    workQueue.value = null;
    activeMissingFilter.value = null;
    filterReceiptMatch.value = 'all';
  }
});

// 구 현금출납부(summary·큐없음) 잔존 상태 → 통장내역으로 복귀
watch(
  [workSection, workQueue],
  () => {
    if (workSection.value === 'summary' && !workQueue.value) {
      workSection.value = 'raw';
      ledgerDisplayMode.value = 'cashbook';
    }
  }
);

const bankNameMap = computed(() => {
  const map: Record<string, string> = {};
  for (const bank of bankList.value) {
    map[bank.mb_code] = bank.mb_alias;
  }
  return map;
});

// 요약 데이터 (선택된 통장 기준)
const summaryData = computed(() => {
  const incomeItems = selectedBankCashbookList.value.filter(item => item.cb_gubun === 'IN');
  const expenseItems = selectedBankCashbookList.value.filter(item => item.cb_gubun === 'OUT');
  const income = incomeItems.reduce((sum, item) => sum + (Number(item.cb_price) || 0), 0);
  const expense = expenseItems.reduce((sum, item) => sum + (Number(item.cb_price) || 0), 0);
  return { 
    income, 
    expense, 
    incomeCount: incomeItems.length, 
    expenseCount: expenseItems.length 
  };
});

// 누적 잔액
const totalBalance = computed(() => {
  return Number(prevMonthBalance.value) + summaryData.value.income - summaryData.value.expense;
});

/** 회계분석과 동일: 당해 1월~선택월 누적 인건비비율 */
const laborRatioYtd = ref<{
  requiredPercent: number;
  ratio: number;
  met: boolean;
  income: number;
  expense: number;
  needAmount: number;
  cumulativeLabel?: string;
  fromWage?: boolean;
} | null>(null);

const loadLaborBaseRatio = async () => {
  if (!currentYear.value || !memberCode.value || !currentMonth.value) return;
  try {
    const res = await bankbookApi.getLaborBaseRatio(
      String(currentYear.value),
      selectedBizGubun.value || undefined,
      {
        memberCode: String(memberCode.value),
        month: currentMonth.value,
        bankCode: selectedBankCode.value,
      }
    );
    const labor = res.data?.data?.labor;
    const pct = Number(labor?.requiredPercent ?? res.data?.data?.requiredPercent);
    const required = Number.isFinite(pct) ? pct : 60;
    if (labor) {
      laborRatioYtd.value = {
        requiredPercent: required,
        ratio: Number(labor.ratio) || 0,
        met: !!labor.met,
        income: Number(labor.income) || 0,
        expense: Number(labor.expense) || 0,
        needAmount: Number(labor.needAmount) || 0,
        cumulativeLabel: labor.cumulativeLabel || undefined,
        fromWage: !!labor.fromWage,
      };
    } else {
      laborRatioYtd.value = {
        requiredPercent: required,
        ratio: 0,
        met: false,
        income: 0,
        expense: 0,
        needAmount: 0,
      };
    }
  } catch (error) {
    console.error('인건비 기준비율 조회 오류:', error);
    laborRatioYtd.value = {
      requiredPercent: 60,
      ratio: 0,
      met: false,
      income: 0,
      expense: 0,
      needAmount: 0,
    };
  }
};

const laborRatioSummary = computed(() => {
  const data = laborRatioYtd.value;
  const required = data?.requiredPercent ?? 60;
  const income = data?.income ?? 0;
  const expense = data?.expense ?? 0;
  const hasIncome = income > 0;
  const ratio = data?.ratio ?? 0;
  const met = !!data?.met && hasIncome;
  const need = data?.needAmount ?? 0;
  const cumLabel = data?.cumulativeLabel
    || (currentMonth.value
      ? (Number(currentMonth.value) <= 1 ? '1월 누적' : `1~${Number(currentMonth.value)}월 누적`)
      : '');
  return {
    hasIncome,
    income,
    expense,
    ratio,
    required,
    met,
    need,
    cumulativeLabel: cumLabel,
    ratioText: hasIncome ? String(ratio) : '-',
    requiredText: String(required),
    barPct: hasIncome ? Math.min(100, Math.round((ratio / Math.max(required, 0.01)) * 100)) : 0,
    iconColor: !hasIncome ? '#94a3b8' : (met ? '#0d9488' : '#dc2626'),
    hint: !hasIncome
      ? `${cumLabel} 인건비수입(112·611·613)이 없어 비율을 계산하지 않습니다`
      : `${cumLabel} 인건비지출÷인건비수입×100 = ${ratio}% (기준 ${required}%)${met ? ' · 충족' : ` · 미충족 · 부족 ${need.toLocaleString()}원`}`,
  };
});

// 확정 여부 (선택된 통장 기준)
const isConfirmed = computed(() => {
  return selectedBankCashbookList.value.length > 0 && selectedBankCashbookList.value.every(item => item.cb_confirmed === 1);
});

// 모든 계정코드가 채워졌는지 (선택된 통장 기준)
const allScodesFilled = computed(() => {
  return selectedBankCashbookList.value.every(item => item.cb_scode && item.cb_scode.trim());
});

// 확인 필요 항목 수 (선택된 통장 기준)
const needReviewCount = computed(() => {
  return selectedBankCashbookList.value.filter(item => {
    if (!item.cb_need_check) return false;
    try {
      const info = JSON.parse(item.cb_need_check);
      return !!info.reviewReason;
    } catch {
      return false;
    }
  }).length;
});

// 영수증 매칭 카운트 (선택된 통장 기준 · 지출만)
const matchedCount = computed(() => {
  return selectedBankCashbookList.value.filter((item) =>
    item.cb_gubun === 'OUT' && Number(item.cb_receipt_matched) === 1
  ).length;
});

/** 수납 대상: 본인부담금수입(112) */
const isCollectionTarget = (item: CashbookData) =>
  item.cb_gubun === 'IN' && item.cb_scode === '112';

/** 수납(수급자) 매칭이 아직 안 된 본인부담금 */
const needsCollectionMatch = (item: CashbookData) =>
  isCollectionTarget(item) && !!item.cb_idx && !beneficiaryMatches.value[item.cb_idx];

/** 영수증 매칭이 필요한 지출 */
const needsReceiptMatch = (item: CashbookData) =>
  item.cb_gubun === 'OUT' && Number(item.cb_receipt_matched) !== 1;

const collectionPendingCount = computed(() =>
  selectedBankCashbookList.value.filter(needsCollectionMatch).length
);

const receiptPendingCount = computed(() =>
  selectedBankCashbookList.value.filter(needsReceiptMatch).length
);

// ─── 탭별 시작 가이드 (작업이 시작되지 않았을 때 먼저 표시) ───
// 수납 탭: 임베드된 수납관리가 비어 있으면 가이드 표시
const showCollectionGuide = computed(() =>
  isCollectionStep.value && beneficiaryEmbedRef.value?.isCollectionEmpty === true
);

// 영수증 탭: 이 달 지출(영수증 대상) / 매칭 완료 건수
const receiptExpenseCount = computed(() =>
  selectedBankCashbookList.value.filter(item => item.cb_gubun === 'OUT').length
);
const receiptMatchedCount = computed(() =>
  selectedBankCashbookList.value.filter(item => item.cb_gubun === 'OUT' && Number(item.cb_receipt_matched) === 1).length
);
const receiptGuideDismissed = ref(false);
watch([currentYear, currentMonth, selectedBankCode], () => { receiptGuideDismissed.value = false; });
const showReceiptGuide = computed(() =>
  isReceiptStep.value && !isLoading.value && receiptExpenseCount.value === 0
);

// 이미 매칭된 수급자 이름 목록 (수금관리에서 사용 중인 수급자)
const matchedBeneficiaryNames = computed(() => {
  const names = new Set<string>();
  Object.values(beneficiaryMatches.value).forEach(match => {
    if (match?.cb_name) {
      names.add(match.cb_name);
    }
  });
  return names;
});

// 자금원천 미설정 항목 수 (선택된 통장 기준)
const unfundedCount = computed(() => {
  return selectedBankCashbookList.value.filter(item => !item.cb_funding || item.cb_funding === '').length;
});

const unfundedItems = computed(() =>
  selectedBankCashbookList.value.filter(item => !item.cb_funding || item.cb_funding === '')
);

const fundingWorkList = computed(() =>
  unfundedItems.value.map((item) => ({
    item,
    suggested: inferFundingForItem(item),
  }))
);

const fundingInferableCount = computed(() =>
  fundingWorkList.value.filter((row) => !!row.suggested && isItemEditable(row.item)).length
);

watch(selectedBankCashbookList, (list) => {
  const valid = new Set(
    list
      .map((item) => item.cb_idx)
      .filter((id): id is number => typeof id === 'number')
  );
  ledgerSelectedIds.value = ledgerSelectedIds.value.filter((id) => valid.has(id));
});

// 통장별 항목 개수 맵
const bankCountMap = computed(() => {
  const map: Record<string, number> = {};
  for (const item of cashbookList.value) {
    const bankCode = item.cb_bank_code || '';
    if (!map[bankCode]) {
      map[bankCode] = 0;
    }
    map[bankCode]++;
  }
  return map;
});

// 특정 통장이 마감되었는지 확인 (전체 모드에서 사용)
const isBankClosed = (bankCode: string): boolean => {
  // 특정 통장 선택 시: closingStatus 사용
  if (selectedBankCode.value) {
    return closingStatus.value?.isClosed || false;
  }
  // 전체 모드: closingSummary에서 해당 통장 마감 상태 확인
  if (closingSummary.value?.banks) {
    const bank = closingSummary.value.banks.find(b => b.mb_code === bankCode);
    return bank?.isClosed || false;
  }
  return false;
};

// 특정 항목이 수정/삭제 가능한지 확인
const isItemEditable = (item: CashbookData): boolean => {
  return !isBankClosed(item.cb_bank_code || '');
};

/** 통장내역 업로드 차단: 선택 통장 마감, 또는 전체 모드에서 열린 통장이 없음 */
const isBankbookUploadDisabled = computed(() => {
  if (selectedBankCode.value) {
    return !!closingStatus.value?.isClosed;
  }
  const banks = bankList.value || [];
  if (!banks.length) return false;
  return banks.every((b: BankData) => isBankClosed(b.mb_code));
});

/** 수납 엑셀: 특정 통장 선택 중 마감이면 차단 (전체 모드는 허용) */
const isCollectionExcelDisabled = computed(() => {
  if (!selectedBankCode.value) return false;
  return !!closingStatus.value?.isClosed;
});

const markCashbookListUnconfirmed = () => {
  cashbookList.value.forEach((row) => {
    row.cb_confirmed = 0;
  });
};

/** 계정조정 저장 전: 마감·확정 상태를 확인하고 필요 시 확정 해제 */
const ensureBankbookAdjustable = async (items: CashbookData[]): Promise<boolean> => {
  if (!items.length) return false;

  if (items.some((item) => isBankClosed(item.cb_bank_code || ''))) {
    alert('마감된 통장 항목은 수정할 수 없습니다.');
    return false;
  }

  const hasConfirmed = items.some((item) => Number(item.cb_confirmed) === 1);
  if (!hasConfirmed) return true;

  if (closingStatus.value?.isClosed) {
    alert('확정된 항목은 수정할 수 없습니다. 마감 해제 후 다시 시도해 주세요.');
    return false;
  }

  try {
    await bankbookApi.unconfirm(
      memberCode.value,
      currentYear.value,
      currentMonth.value,
      selectedBizGubun.value || undefined
    );
    markCashbookListUnconfirmed();
    return true;
  } catch (error) {
    console.error(error);
    alert('확정 해제에 실패했습니다. 확정된 항목은 수정할 수 없습니다.');
    return false;
  }
};

const getWorkbenchSaveErrorMessage = (results: PromiseSettledResult<unknown>[]) => {
  const rejected = results.filter((result) => result.status === 'rejected') as PromiseRejectedResult[];
  if (!rejected.length) return '';
  const confirmed = rejected.some((result) => {
    const msg = String(
      (result.reason as { response?: { data?: { message?: string } }; message?: string })?.response?.data?.message
      || (result.reason as Error)?.message
      || ''
    );
    return msg.includes('확정');
  });
  if (confirmed) return '확정된 항목은 수정할 수 없습니다.';
  return `${rejected.length}건 저장에 실패했습니다.`;
};

// 수급자별 매칭 건수 계산
const beneficiaryMatchCount = computed(() => {
  const countMap: Record<number, number> = {};
  Object.values(beneficiaryMatches.value).forEach(match => {
    if (match?.cb_idx) {
      countMap[match.cb_idx] = (countMap[match.cb_idx] || 0) + 1;
    }
  });
  return countMap;
});

// 매칭 가능한 수급자 목록 (퇴소자만 제외, 이미 매칭된 수급자도 포함 + 매칭 건수 표시)
const availableBeneficiaryList = computed(() => {
  return beneficiaryList.value
    .filter(b => b.cb_status !== '퇴소자')
    .map(b => ({
      ...b,
      matchCount: beneficiaryMatchCount.value[b.cb_idx] || 0,
      displayName: beneficiaryMatchCount.value[b.cb_idx] 
        ? `${b.cb_name} (${beneficiaryMatchCount.value[b.cb_idx]}건 매칭)` 
        : b.cb_name
    }));
});

// 필터링된 목록
const filteredCashbookList = computed(() => {
  let list = [...cashbookList.value];
  
  // 통장 필터 (선택된 통장이 있는 경우)
  if (selectedBankCode.value) {
    list = list.filter(item => item.cb_bank_code === selectedBankCode.value);
  }
  
  // 수입/지출 탭
  if (ledgerListTab.value === 'in') {
    list = list.filter(item => item.cb_gubun === 'IN');
  } else {
    list = list.filter(item => item.cb_gubun === 'OUT');
  }
  
  // 확인필요 필터
  if (filterNeedCheck.value) {
    list = list.filter(item => {
      if (!item.cb_need_check) return false;
      try {
        const info = JSON.parse(item.cb_need_check);
        return !!info.reviewReason;
      } catch {
        return false;
      }
    });
  }
  
  // 계정 검색
  if (searchScode.value) {
    const query = searchScode.value.toLowerCase();
    list = list.filter(item => {
      const scodeName = getScodeDisplayName(item.cb_scode, item.cb_gubun);
      return scodeName.toLowerCase().includes(query) || 
             (item.cb_scode && item.cb_scode.toLowerCase().includes(query));
    });
  }
  
  // 적요 검색
  if (searchMemo.value) {
    const query = searchMemo.value.toLowerCase();
    list = list.filter(item => item.cb_memo && item.cb_memo.toLowerCase().includes(query));
  }
  
  // 일자 기간 필터 (선택한 연월 내에서)
  if (filterDayStart.value || filterDayEnd.value) {
    const startDay = filterDayStart.value || 1;
    const endDay = filterDayEnd.value || lastDayOfMonth.value;
    list = list.filter(item => {
      const day = new Date(item.cb_date).getDate();
      return day >= startDay && day <= endDay;
    });
  }
  
  // 작업 큐 / 영수증 필터
  // collection: 본인부담금 수납 미매칭만
  // receipt 큐 / unmatched: 지출 영수증 미매칭만
  if (workQueue.value === 'collection') {
    list = list.filter(needsCollectionMatch);
  } else if (workQueue.value === 'receipt') {
    list = list.filter(needsReceiptMatch);
  } else if (filterReceiptMatch.value === 'matched') {
    list = list.filter((item) => item.cb_gubun === 'OUT' && item.cb_receipt_matched === 1);
  } else if (filterReceiptMatch.value === 'unmatched') {
    list = list.filter(needsReceiptMatch);
  }

  // 미설정 필터 (스텝별 진입 시)
  if (activeMissingFilter.value === 'scode') {
    list = list.filter(item => !item.cb_scode || !String(item.cb_scode).trim());
  } else if (activeMissingFilter.value === 'rel_acc') {
    list = list.filter(item => item.cb_gubun === 'OUT' && (!item.cb_rel_acc || !String(item.cb_rel_acc).trim()));
  } else if (activeMissingFilter.value === 'funding') {
    list = list.filter(item => !item.cb_funding || item.cb_funding === '');
  }

  if (selectedIncomeScode.value) {
    const incomeScode = selectedIncomeScode.value;
    list = list.filter((item) => {
      if (item.cb_gubun === 'IN') return item.cb_scode === incomeScode;
      const rel = item.cb_rel_acc || '';
      return rel === incomeScode || rel === '';
    });
  }
  
  // 정렬
  list.sort((a, b) => {
    // 날짜(cb_order) 컬럼 정렬은 cb_order 단독이 아니라
    // 실제 날짜(일 1→31) → cb_order → cb_idx 복합 기준으로 정렬 (백엔드 ORDER BY와 동일)
    // cb_order는 "같은 날짜 내 순서"이므로 단독 정렬 시 날짜가 뒤섞임
    // cb_date 문자열 형식에 좌우되지 않도록 타임스탬프로 비교
    if (sortKey.value === 'cb_order') {
      const aTime = a.cb_date ? new Date(a.cb_date).getTime() : 0;
      const bTime = b.cb_date ? new Date(b.cb_date).getTime() : 0;
      let comparison = (isNaN(aTime) ? 0 : aTime) - (isNaN(bTime) ? 0 : bTime);
      if (comparison === 0) {
        comparison = (Number(a.cb_order) || 0) - (Number(b.cb_order) || 0);
      }
      if (comparison === 0) {
        comparison = (Number(a.cb_idx) || 0) - (Number(b.cb_idx) || 0);
      }
      return sortOrder.value === 'asc' ? comparison : -comparison;
    }

    let aVal = a[sortKey.value as keyof CashbookData];
    let bVal = b[sortKey.value as keyof CashbookData];
    
    if (aVal === undefined || aVal === null) return 1;
    if (bVal === undefined || bVal === null) return -1;
    
    // cb_price, cb_idx 등 숫자 필드는 숫자로 변환하여 비교
    const numericFields = ['cb_order', 'cb_price', 'cb_idx', 'cb_bank_balance'];
    if (numericFields.includes(sortKey.value)) {
      aVal = Number(aVal) || 0;
      bVal = Number(bVal) || 0;
    }
    
    let comparison = 0;
    if (typeof aVal === 'number' && typeof bVal === 'number') {
      comparison = aVal - bVal;
    } else {
      comparison = String(aVal).localeCompare(String(bVal));
    }
    
    return sortOrder.value === 'asc' ? comparison : -comparison;
  });

  return list;
});

// 필터 빈 메시지
const getFilteredEmptyMessage = computed(() => {
  const filters = [];
  filters.push(ledgerListTab.value === 'in' ? '수입' : '지출');
  if (filterNeedCheck.value) filters.push('확인필요');
  if (filterDayStart.value || filterDayEnd.value) {
    const startDay = filterDayStart.value || 1;
    const endDay = filterDayEnd.value || lastDayOfMonth.value;
    filters.push(`기간: ${startDay}일 ~ ${endDay}일`);
  }
  if (searchScode.value) filters.push(`계정: ${searchScode.value}`);
  if (searchMemo.value) filters.push(`적요: ${searchMemo.value}`);
  
  return `${filters.join(', ')} 조건에 맞는 항목이 없습니다.`;
});

// 계정별 그룹화 인터페이스
const groupedByAccount = computed((): GroupedAccount[] => {
  const groups: Record<string, GroupedAccount> = {};
  const UNSET_KEY = '__UNSET__';
  
  for (const item of filteredCashbookList.value) {
    const scode = item.cb_scode?.trim() || UNSET_KEY;
    
    if (!groups[scode]) {
      groups[scode] = {
        scode: scode,
        scodeName: scode === UNSET_KEY ? '계정조정 미완료' : getScodeDisplayName(scode, item.cb_gubun),
        gubun: item.cb_gubun as 'IN' | 'OUT',
        items: [],
        totalIncome: 0,
        totalExpense: 0,
        relAccFilledCount: 0,
        relAccTotalCount: 0,
        memoFilledCount: 0
      };
    }
    
    groups[scode].items.push(item);
    
    if (item.cb_gubun === 'IN') {
      groups[scode].totalIncome += Number(item.cb_price) || 0;
    } else {
      groups[scode].totalExpense += Number(item.cb_price) || 0;
      // 지출 항목은 상대계정 필요
      groups[scode].relAccTotalCount++;
      if (item.cb_rel_acc && item.cb_rel_acc.trim()) {
        groups[scode].relAccFilledCount++;
      }
    }
    
    // 적요 완료 체크
    if (item.cb_memo && item.cb_memo.trim()) {
      groups[scode].memoFilledCount++;
    }
    
    // 수입/지출이 섞여있으면 MIXED로 설정
    if (groups[scode].gubun !== item.cb_gubun && groups[scode].gubun !== 'MIXED') {
      groups[scode].gubun = 'MIXED';
    }
  }
  
  // 배열로 변환 후 정렬 (계정조정 미완료는 맨 위, 나머지는 계정명 순)
  return Object.values(groups).sort((a, b) => {
    if (a.scode === UNSET_KEY) return -1;
    if (b.scode === UNSET_KEY) return 1;
    return a.scodeName.localeCompare(b.scodeName);
  });
});

// 완료율 계산 헬퍼
const getCompletionPercent = (filled: number, total: number): number => {
  if (total === 0) return 100;
  return Math.round((filled / total) * 100);
};

// ============================================
// 연월 변경 시 저장 및 데이터 로드
// ============================================

watch([currentYear, currentMonth], () => {
  // 연월 변경 시 데이터 로드 및 일자 필터 초기화
  filterDayStart.value = null;
  filterDayEnd.value = null;
  
  // 선택된 통장이 현재 연월에 비활성화되면 "전체"로 변경
  if (selectedBankCode.value) {
    const selectedBank = bankList.value.find(b => b.mb_code === selectedBankCode.value);
    if (selectedBank && !isBankActiveForCurrentMonth(selectedBank)) {
      selectedBankCode.value = null;
    }
  }
  
  loadCashbookData();
  loadClosingStatus();
  loadHeumieumStatus();
  loadMonthMemo();
  loadLaborBaseRatio();
}, { immediate: false });

// 일자 필터는 프론트엔드 필터링이므로 API 호출 불필요 (filteredCashbookData에서 처리)

// ============================================
// 이달의 메모
// ============================================
const loadMonthMemo = async () => {
  if (!memberCode.value || !currentYear.value || !currentMonth.value) return;
  const key = `${memberCode.value}:${currentYear.value}-${currentMonth.value}`;
  if (monthMemoSaveTimer) {
    clearTimeout(monthMemoSaveTimer);
    monthMemoSaveTimer = null;
  }
  isMonthMemoLoading.value = true;
  monthMemoSaveState.value = 'idle';
  try {
    const res = await bankbookApi.getMonthMemo(
      memberCode.value,
      String(currentYear.value),
      String(currentMonth.value)
    );
    const memo = String(res.data?.data?.memo || '');
    monthMemoText.value = memo.slice(0, MONTH_MEMO_MAX);
    monthMemoLoadedKey.value = key;
    // 내용이 있으면 접힌 채로 점만 표시 (펼침은 사용자 클릭)
    if (!memo.trim()) monthMemoOpen.value = false;
  } catch (error) {
    console.error('이달의 메모 조회 오류:', error);
    monthMemoText.value = '';
    monthMemoLoadedKey.value = key;
  } finally {
    isMonthMemoLoading.value = false;
  }
};

const saveMonthMemoNow = async () => {
  if (!memberCode.value || !currentYear.value || !currentMonth.value) return;
  if (closingStatus.value?.isClosed) return;
  if (monthMemoSaveTimer) {
    clearTimeout(monthMemoSaveTimer);
    monthMemoSaveTimer = null;
  }
  const text = monthMemoText.value.slice(0, MONTH_MEMO_MAX);
  monthMemoText.value = text;
  monthMemoSaveState.value = 'saving';
  try {
    await bankbookApi.saveMonthMemo(memberCode.value, {
      year: String(currentYear.value),
      month: String(currentMonth.value),
      memo: text,
    });
    monthMemoSaveState.value = 'saved';
    if (monthMemoStatusTimer) clearTimeout(monthMemoStatusTimer);
    monthMemoStatusTimer = setTimeout(() => {
      if (monthMemoSaveState.value === 'saved') monthMemoSaveState.value = 'idle';
    }, 1800);
  } catch (error) {
    console.error('이달의 메모 저장 오류:', error);
    monthMemoSaveState.value = 'error';
  }
};

const onMonthMemoInput = () => {
  if (monthMemoText.value.length > MONTH_MEMO_MAX) {
    monthMemoText.value = monthMemoText.value.slice(0, MONTH_MEMO_MAX);
  }
  monthMemoSaveState.value = 'idle';
  if (monthMemoSaveTimer) clearTimeout(monthMemoSaveTimer);
  monthMemoSaveTimer = setTimeout(() => {
    saveMonthMemoNow();
  }, 800);
};

// ============================================
// 메서드
// ============================================

// 숫자 포맷
const formatNumber = (value: number | undefined | null): string => {
  if (value === undefined || value === null) return '0';
  return value.toLocaleString('ko-KR');
};


// 날짜 포맷
const formatDate = (value: string | null): string => {
  if (!value) return '-';
  const d = new Date(value);
  if (isNaN(d.getTime())) return value;
  return `${d.getMonth() + 1}/${d.getDate()}`;
};

// 계정명 가져오기
const getScodeDisplayName = (scode: string | undefined, gubun: string | undefined): string => {
  if (!scode) return '';
  const list = gubun === 'IN' ? incomeCodeList.value : expenseCodeList.value;
  const found = list.find(ac => ac.scode === scode);
  return found ? found.sname : scode;
};

// 상대계정이 없는 이유 반환
const getRelAccMissingReason = (item: CashbookData): string => {
  // 1. 지출이 아닌 경우
  if (item.cb_gubun !== 'OUT') {
    return '수입 항목은 상대계정이 필요하지 않습니다.';
  }
  
  // 2. 계정(cb_scode)이 지정되지 않은 경우
  if (!item.cb_scode) {
    return '지출 계정이 지정되지 않아 상대계정을 자동 추론할 수 없습니다.\n먼저 계정을 지정해주세요.';
  }
  
  // 3. 수입 데이터가 없는 경우 (이월금도 없는 경우)
  const incomeItems = cashbookList.value.filter(d => d.cb_gubun === 'IN' && d.cb_scode);
  const carryover = Number(prevMonthBalance.value) || 0;
  
  if (incomeItems.length === 0 && carryover <= 0) {
    return '수입 내역에 계정이 지정된 항목이 없고, 이월금도 없어 상대계정을 추론할 수 없습니다.\n수입 항목의 계정을 먼저 지정해주세요.';
  }
  
  // 4. 잔액 계산하여 구체적인 이유 제공
  const targetDate = item.cb_date;
  const targetIdx = item.cb_idx;
  const targetPrice = Math.abs(Number(item.cb_price) || 0);
  
  // 수입 계정별 잔액 계산
  const accountBalances = new Map<string, { totalIncome: number; usedExpense: number; sname: string }>();
  let totalIncome = 0;
  
  for (const incItem of cashbookList.value) {
    if (incItem.cb_gubun !== 'IN' || !incItem.cb_scode) continue;
    
    const isBeforeOrSame = incItem.cb_date < targetDate || 
      (incItem.cb_date === targetDate && (incItem.cb_idx || 0) <= (targetIdx || 0));
    if (!isBeforeOrSame) continue;
    
    const scode = incItem.cb_scode;
    const price = Number(incItem.cb_price) || 0;
    
    if (!accountBalances.has(scode)) {
      const sname = getScodeDisplayName(scode, 'IN') || scode;
      accountBalances.set(scode, { totalIncome: 0, usedExpense: 0, sname });
    }
    accountBalances.get(scode)!.totalIncome += price;
    totalIncome += price;
  }
  
  // 이월금 처리
  if (carryover > 0) {
    if (totalIncome > 0 && accountBalances.size > 0) {
      // 현재 월 수입이 있으면 비율에 따라 분배
      for (const [, balance] of accountBalances.entries()) {
        const ratio = balance.totalIncome / totalIncome;
        balance.totalIncome += carryover * ratio;
      }
    } else if (accountBalances.size > 0) {
      // 현재 월 수입이 없지만 계정이 있는 경우
      const firstAccount = accountBalances.entries().next().value;
      if (firstAccount) {
        firstAccount[1].totalIncome += carryover;
      }
    } else {
      // 현재 월에 수입 계정이 없는 경우, 기본 계정 사용
      const defaultIncomeCodes = ['111', '101', '102', '103'];
      let defaultCode = incomeCodeList.value.length > 0 ? incomeCodeList.value[0].scode : '111';
      
      for (const code of defaultIncomeCodes) {
        const found = incomeCodeList.value.find(c => c.scode === code);
        if (found) {
          defaultCode = found.scode;
          break;
        }
      }
      
      const sname = getScodeDisplayName(defaultCode, 'IN') || defaultCode;
      accountBalances.set(defaultCode, { totalIncome: carryover, usedExpense: 0, sname });
    }
  }
  
  for (const expItem of cashbookList.value) {
    if (expItem.cb_gubun !== 'OUT' || !expItem.cb_rel_acc) continue;
    if (expItem.cb_idx === targetIdx) continue;
    
    const isBefore = expItem.cb_date < targetDate || 
      (expItem.cb_date === targetDate && (expItem.cb_idx || 0) < (targetIdx || 0));
    if (!isBefore) continue;
    
    const relAcc = expItem.cb_rel_acc;
    if (accountBalances.has(relAcc)) {
      accountBalances.get(relAcc)!.usedExpense += Math.abs(Number(expItem.cb_price) || 0);
    }
  }
  
  // 잔액이 있는 계정이 있는지 확인
  let hasAvailableBalance = false;
  let maxRemaining = 0;
  let maxAccountName = '';
  
  for (const [, balance] of accountBalances.entries()) {
    const remaining = balance.totalIncome - balance.usedExpense;
    if (remaining > 0) {
      hasAvailableBalance = true;
      if (remaining > maxRemaining) {
        maxRemaining = remaining;
        maxAccountName = balance.sname;
      }
    }
  }
  
  if (!hasAvailableBalance) {
    return `이 날짜(${item.cb_date}) 기준 모든 수입 계정의 잔액(이월금 포함)이 이미 소진되었습니다.\n수입 내역을 확인하거나 상대계정을 직접 선택해주세요.`;
  }
  
  if (maxRemaining < targetPrice) {
    return `지출 금액(${formatNumber(targetPrice)}원)을 커버할 수 있는 수입 계정이 없습니다.\n가장 큰 잔액: ${maxAccountName} (${formatNumber(maxRemaining)}원, 이월금 포함)\n상대계정을 직접 선택해주세요.`;
  }
  
  // 5. 그 외의 경우 - 잔액은 충분하지만 자동 추론이 안 된 경우
  return `잔액이 충분한 수입 계정(${maxAccountName}: ${formatNumber(maxRemaining)}원, 이월금 포함)이 있습니다.\n계정을 다시 선택하거나, 상대계정을 직접 지정해주세요.`;
};

// 자금원천명 가져오기
const getFundingName = (code: string | undefined): string => {
  if (!code) return '';
  const found = fundingCodeList.find(f => f.code === code);
  return found ? found.name : code;
};

// 확인필요 이유 가져오기
const getReviewReason = (item: CashbookData): string | null => {
  if (!item.cb_need_check) return null;
  try {
    const info = JSON.parse(item.cb_need_check);
    return info.reviewReason || null;
  } catch {
    return null;
  }
};

// 정렬 토글
const toggleSort = (key: string) => {
  if (sortKey.value === key) {
    sortOrder.value = sortOrder.value === 'asc' ? 'desc' : 'asc';
  } else {
    sortKey.value = key;
    sortOrder.value = 'asc';
  }
};

// 정렬 아이콘
const getSortIcon = (key: string): string => {
  if (sortKey.value !== key) return 'mdi-swap-vertical';
  return sortOrder.value === 'asc' ? 'mdi-arrow-up' : 'mdi-arrow-down';
};

// 월 변경
const changeMonth = (delta: number) => {
  memberYearMonth.changeMonth(delta);
};

// 월 선택기 열기
const openMonthPicker = () => {
  monthPickerRef.value?.showPicker();
};

// 월 선택기 변경
const onMonthPickerChange = (e: Event) => {
  memberYearMonth.onMonthPickerChange(e);
};

// 필터 초기화
const resetFilters = () => {
  filterNeedCheck.value = false;
  filterReceiptMatch.value = 'all';
  filterSplitOnly.value = false;
  ledgerDisplayMode.value = 'cashbook';
  expandedSplitParents.value = {};
  searchScode.value = '';
  searchMemo.value = '';
  filterDayStart.value = null;
  filterDayEnd.value = null;
};

// 보기 모드 토글
const setViewMode = (mode: 'normal' | 'grouped') => {
  viewMode.value = mode;
  if (mode === 'grouped') {
    expandedScodes.value = {};
  }
};

const loadAdjustState = async () => {
  if (!memberCode.value) return;
  isAdjustStateLoading.value = true;
  try {
    const res = await bankbookApi.getAccountAdjustState(memberCode.value, {
      year: currentYear.value,
      month: currentMonth.value,
      bizGubun: selectedBizGubun.value || undefined,
      bankCode: selectedBankCode.value || undefined,
    });
    const data = res.data?.data;
    adjustIncomes.value = (data?.incomes || []) as IncomeBalanceItem[];
    adjustExpenseCodes.value = (data?.expenseCodes || []).map((c: { scode: string; sname: string }) => ({
      scode: c.scode,
      sname: c.sname,
    }));
  } catch (error) {
    console.error('계정조정 상태 조회 오류:', error);
  } finally {
    isAdjustStateLoading.value = false;
  }
};

const onIncomeBalanceSelect = (scode: string | null) => {
  selectedIncomeScode.value = selectedIncomeScode.value === scode ? null : scode;
};

const onExpensePickerSelect = (payload: { scode: string; relAcc: string }) => {
  // 잔액이 없거나 부족한 수입 계정을 고르면 한 번 더 확인 (차단은 하지 않음)
  const income = adjustIncomes.value.find((inc) => inc.scode === payload.relAcc);
  if (income) {
    const remaining = Number(income.remaining) || 0;
    const amount = Math.abs(Number(inlineEditData.value.cb_price) || 0);
    let warnMsg = '';
    if (remaining <= 0) {
      warnMsg = `'${income.sname}' 계정의 잔액이 없습니다.\n지정하면 해당 계정 잔액이 마이너스로 표시됩니다.\n그래도 지정하시겠습니까?`;
    } else if (amount > remaining) {
      warnMsg = `지출 금액(${formatNumber(amount)}원)이 '${income.sname}' 계정의 잔액(${formatNumber(remaining)}원)을 초과합니다.\n그래도 지정하시겠습니까?`;
    }
    if (warnMsg && !window.confirm(warnMsg)) return;
  }
  inlineEditData.value.cb_scode = payload.scode;
  inlineEditData.value.cb_rel_acc = payload.relAcc;
};

/** 계정 지정 성공 건만 과거 적요→계정으로 학습 (추천용). 실패해도 본 저장은 유지. */
const learnMemoAccountsFromSaved = async (
  savedItems: CashbookData[],
  scode: string,
  gubun: string
) => {
  if (!memberCode.value || !scode || !savedItems.length) return;
  const learnItems = buildBankbookLearnItems({
    mCode: memberCode.value,
    bizGubun: selectedBizGubun.value || null,
    items: savedItems.map((item) => ({
      memo: item.cb_memo,
      gubun,
      scode,
    })),
  });
  if (!learnItems.length) return;
  try {
    await bankbookApi.learnBatch(learnItems);
  } catch (error) {
    console.error('적요→계정 학습 누적 오류:', error);
  }
};

const onWorkbenchAssignBatch = async (payload: {
  items: CashbookData[];
  expenseScode: string;
  incomeScode: string;
  funding?: string;
}) => {
  const { items, expenseScode, incomeScode, funding: pickedFunding } = payload;
  const targets = items.filter((item) => item.cb_idx && isItemEditable(item));
  if (!targets.length) return;
  if (!(await ensureBankbookAdjustable(targets))) return;
  try {
    const inferredFunding =
      getAccountFunding(incomeScode, 'IN') ||
      (getAccountNameByCode(incomeScode, 'IN')
        ? await fetchFundingByAccount(getAccountNameByCode(incomeScode, 'IN') as string, 'IN')
        : null);
    const results = await Promise.allSettled(
      targets.map((item) => {
        const keepFunding = !!(item.cb_funding && String(item.cb_funding).trim());
        const funding = pickedFunding || inferredFunding;
        return bankbookApi.update(item.cb_idx as number, {
          cb_scode: expenseScode,
          cb_rel_acc: incomeScode,
          ...(funding && !keepFunding ? { cb_funding: funding } : {}),
        });
      })
    );
    const savedItems: CashbookData[] = [];
    results.forEach((result, index) => {
      if (result.status !== 'fulfilled') return;
      const item = targets[index];
      savedItems.push(item);
      const idx = cashbookList.value.findIndex((row) => row.cb_idx === item.cb_idx);
      if (idx === -1) return;
      cashbookList.value[idx].cb_scode = expenseScode;
      cashbookList.value[idx].cb_rel_acc = incomeScode;
      const funding = pickedFunding || inferredFunding;
      if (funding && !(item.cb_funding && String(item.cb_funding).trim())) {
        cashbookList.value[idx].cb_funding = funding;
      }
    });
    await learnMemoAccountsFromSaved(savedItems, expenseScode, 'OUT');
    const failed = results.filter((result) => result.status === 'rejected').length;
    if (failed) {
      alert(getWorkbenchSaveErrorMessage(results) || `${failed}건 저장에 실패했습니다. 나머지 항목은 반영되었습니다.`);
    } else {
      showSaveToast.value = true;
      setTimeout(() => { showSaveToast.value = false; }, 1600);
    }
    await loadAdjustState();
  } catch (error) {
    console.error(error);
    alert('계정지정 저장에 실패했습니다.');
  }
};

/** 지출 계정만 저장 (상대계정 유지) */
const onWorkbenchAssignExpenseAccount = async (payload: {
  items: CashbookData[];
  expenseScode: string;
  funding?: string;
}) => {
  const { items, expenseScode, funding: pickedFunding } = payload;
  const targets = items.filter((item) => item.cb_idx && isItemEditable(item));
  if (!targets.length) return;
  if (!(await ensureBankbookAdjustable(targets))) return;
  try {
    const results = await Promise.allSettled(
      targets.map((item) => {
        const keepFunding = !!(item.cb_funding && String(item.cb_funding).trim());
        return bankbookApi.update(item.cb_idx as number, {
          cb_scode: expenseScode,
          ...(pickedFunding && !keepFunding ? { cb_funding: pickedFunding } : {}),
        });
      })
    );
    const savedItems: CashbookData[] = [];
    results.forEach((result, index) => {
      if (result.status !== 'fulfilled') return;
      savedItems.push(targets[index]);
      const idx = cashbookList.value.findIndex((row) => row.cb_idx === targets[index].cb_idx);
      if (idx === -1) return;
      cashbookList.value[idx].cb_scode = expenseScode;
      if (pickedFunding && !(targets[index].cb_funding && String(targets[index].cb_funding).trim())) {
        cashbookList.value[idx].cb_funding = pickedFunding;
      }
    });
    await learnMemoAccountsFromSaved(savedItems, expenseScode, 'OUT');
    const failed = results.filter((result) => result.status === 'rejected').length;
    if (failed) {
      alert(getWorkbenchSaveErrorMessage(results) || `${failed}건 저장에 실패했습니다. 나머지 항목은 반영되었습니다.`);
    } else {
      showSaveToast.value = true;
      setTimeout(() => { showSaveToast.value = false; }, 1600);
    }
    await loadAdjustState();
  } catch (error) {
    console.error(error);
    alert('지출 계정 저장에 실패했습니다.');
  }
};

/** 상대계정만 저장 (지출계정 유지, 자금원천은 상대계정 기준) */
const onWorkbenchAssignRel = async (payload: {
  items: CashbookData[];
  incomeScode: string;
  funding?: string;
}) => {
  const { items, incomeScode, funding: pickedFunding } = payload;
  const targets = items.filter((item) => item.cb_idx && isItemEditable(item));
  if (!targets.length) return;
  if (!(await ensureBankbookAdjustable(targets))) return;
  try {
    const inferredFunding =
      getAccountFunding(incomeScode, 'IN') ||
      (getAccountNameByCode(incomeScode, 'IN')
        ? await fetchFundingByAccount(getAccountNameByCode(incomeScode, 'IN') as string, 'IN')
        : null);
    const results = await Promise.allSettled(
      targets.map((item) => {
        const keepFunding = !!(item.cb_funding && String(item.cb_funding).trim());
        const funding = pickedFunding || inferredFunding;
        return bankbookApi.update(item.cb_idx as number, {
          cb_rel_acc: incomeScode,
          ...(funding && !keepFunding ? { cb_funding: funding } : {}),
        });
      })
    );
    results.forEach((result, index) => {
      if (result.status !== 'fulfilled') return;
      const item = targets[index];
      const idx = cashbookList.value.findIndex((row) => row.cb_idx === item.cb_idx);
      if (idx === -1) return;
      cashbookList.value[idx].cb_rel_acc = incomeScode;
      const funding = pickedFunding || inferredFunding;
      if (funding && !(item.cb_funding && String(item.cb_funding).trim())) {
        cashbookList.value[idx].cb_funding = funding;
      }
    });
    const failed = results.filter((result) => result.status === 'rejected').length;
    if (failed) {
      alert(getWorkbenchSaveErrorMessage(results) || `${failed}건 저장에 실패했습니다. 나머지 항목은 반영되었습니다.`);
    } else {
      showSaveToast.value = true;
      setTimeout(() => { showSaveToast.value = false; }, 1600);
    }
    await loadAdjustState();
  } catch (error) {
    console.error(error);
    alert('상대계정 저장에 실패했습니다.');
  }
};

const onWorkbenchAssignIncome = async (payload: {
  items: CashbookData[];
  incomeScode: string;
}) => {
  const { items, incomeScode } = payload;
  const targets = items.filter((item) => item.cb_idx && isItemEditable(item));
  if (!targets.length) return;
  if (!(await ensureBankbookAdjustable(targets))) return;
  try {
    const funding =
      getAccountFunding(incomeScode, 'IN') ||
      (getAccountNameByCode(incomeScode, 'IN')
        ? await fetchFundingByAccount(getAccountNameByCode(incomeScode, 'IN') as string, 'IN')
        : null);
    const results = await Promise.allSettled(
      targets.map((item) => {
        const keepFunding = !!(item.cb_funding && String(item.cb_funding).trim());
        return bankbookApi.update(item.cb_idx as number, {
          cb_scode: incomeScode,
          ...(funding && !keepFunding ? { cb_funding: funding } : {}),
        });
      })
    );
    const savedItems: CashbookData[] = [];
    results.forEach((result, index) => {
      if (result.status !== 'fulfilled') return;
      const item = targets[index];
      savedItems.push(item);
      const idx = cashbookList.value.findIndex((row) => row.cb_idx === item.cb_idx);
      if (idx === -1) return;
      cashbookList.value[idx].cb_scode = incomeScode;
      if (funding && !(item.cb_funding && String(item.cb_funding).trim())) {
        cashbookList.value[idx].cb_funding = funding;
      }
    });
    await learnMemoAccountsFromSaved(savedItems, incomeScode, 'IN');
    const failed = results.filter((result) => result.status === 'rejected').length;
    if (failed) {
      alert(getWorkbenchSaveErrorMessage(results) || `${failed}건 저장에 실패했습니다. 나머지 항목은 반영되었습니다.`);
    } else {
      showSaveToast.value = true;
      setTimeout(() => { showSaveToast.value = false; }, 1600);
    }
    await loadAdjustState();
  } catch (error) {
    console.error(error);
    alert('수입 계정 저장에 실패했습니다.');
  }
};

/** 자금원천만 저장 (조정하기에서 자금원천만 골랐을 때) */
const onWorkbenchAssignFunding = async (payload: {
  items: CashbookData[];
  funding: string;
}) => {
  const { items, funding } = payload;
  const targets = items.filter((item) => item.cb_idx && isItemEditable(item));
  if (!targets.length || !funding) return;
  if (!(await ensureBankbookAdjustable(targets))) return;
  await applyFundingToItems(targets, funding);
};

const onWorkbenchUnassignIncome = async (item: CashbookData) => {
  if (!item.cb_idx || !isItemEditable(item)) return;
  if (!(await ensureBankbookAdjustable([item]))) return;
  try {
    await bankbookApi.update(item.cb_idx, { cb_scode: '' });
    const idx = cashbookList.value.findIndex((row) => row.cb_idx === item.cb_idx);
    if (idx !== -1) cashbookList.value[idx].cb_scode = '';
    await loadAdjustState();
  } catch (error) {
    console.error(error);
    alert('되돌리기에 실패했습니다.');
  }
};

const onWorkbenchUnassign = async (item: CashbookData) => {
  if (!item.cb_idx || !isItemEditable(item)) return;
  if (!(await ensureBankbookAdjustable([item]))) return;
  try {
    await bankbookApi.update(item.cb_idx, { cb_scode: '', cb_rel_acc: '' });
    const idx = cashbookList.value.findIndex((row) => row.cb_idx === item.cb_idx);
    if (idx !== -1) {
      cashbookList.value[idx].cb_scode = '';
      cashbookList.value[idx].cb_rel_acc = '';
    }
    await loadAdjustState();
  } catch (error) {
    console.error(error);
    alert('되돌리기에 실패했습니다.');
  }
};

const runPairAutoAdjust = async () => {
  await openAutoDialog('account');
};

const beneficiaryAutoCandidates = computed(() =>
  cashbookList.value.filter(
    (item) =>
      item.cb_scode === '112' &&
      item.cb_idx &&
      item.cb_memo &&
      String(item.cb_memo).trim() &&
      !item.cb_matched_beneficiary_idx &&
      !beneficiaryMatches.value[item.cb_idx] &&
      isItemEditable(item)
  )
);

const autoDialogActions = computed<BankbookAutoActionState[]>(() => [
  {
    key: 'account',
    title: '계정 자동 넣기',
    desc: '비어 있는 계정을, 기억된 적요와 같은 계정으로 채웁니다.',
    emptyHint: autoAccountDisabled.value
      ? ''
      : '기억된 적요와 맞는 빈 계정이 없어요.',
    icon: 'mdi-book-check-outline',
    count: autoAccountReadyCount.value,
    countLoading: autoAccountCountLoading.value,
    busy: isAutoAccountProcessing.value,
    applyDisabled: autoAccountDisabled.value,
    applyDisabledReason: autoAccountDisabled.value ? autoAccountDisabledReason.value : undefined,
  },
  {
    key: 'rel',
    title: '상대계정 자동 넣기',
    desc: '계정은 있고 상대계정만 비어 있는 지출을, 잔액이 되는 수입으로 채웁니다.',
    emptyHint: '잔액으로 채울 수 있는 빈 상대계정이 없어요.',
    icon: 'mdi-link-variant',
    count: autoRelReadyCount.value,
    countLoading: autoRelCountLoading.value,
    busy: isAutoRelAccProcessing.value,
  },
  {
    key: 'funding',
    title: '자금원천 자동 넣기',
    desc: '비어 있는 자금원천을 규칙대로 채웁니다.',
    emptyHint: '규칙으로 채울 수 있는 빈 자금원천이 없어요.',
    icon: 'mdi-cash-multiple',
    count: fundingInferableCount.value,
    busy: isAutoFundingProcessing.value,
    applyDisabled: !fundingInferSettings.value.enabled,
    applyDisabledReason: !fundingInferSettings.value.enabled
      ? '자금원천 규칙이 꺼져 있어요. 통장내역 탭 → 자금원천 → 톱니에서 켜 주세요.'
      : undefined,
  },
  {
    key: 'beneficiary',
    title: '본인부담금 자동매칭',
    desc: '적요의 수급자 이름으로, 아직 연결되지 않은 입금만 연결합니다.',
    emptyHint: '적요에 수급자 이름이 보이는 미연결 입금이 없어요.',
    icon: 'mdi-account-multiple-check',
    count: beneficiaryAutoCandidates.value.length,
    busy: isAutoBeneficiaryMatching.value,
  },
]);

const clearAutoPreview = () => {
  autoPreviewKind.value = null;
  autoPreviewRows.value = [];
  autoPreviewLoading.value = false;
  autoPreviewError.value = '';
  autoFillPreviewPatches.value = [];
  autoBenPreviewMatches.value = {};
};

const autoFillQuery = () => ({
  year: String(currentYear.value),
  month: String(currentMonth.value),
  bizGubun: selectedBizGubun.value || undefined,
  bankCode: selectedBankCode.value || undefined,
});

const buildFillPreviewRows = (
  updates: AutoFillUpdate[],
  hintOf: (row: AutoFillUpdate) => string
): BankbookAutoPreviewRow[] =>
  updates.map((row) => ({
    id: row.cbIdx,
    date: formatDate(row.date || null),
    memo: String(row.memo || ''),
    priceLabel: `${formatNumber(row.price || 0)}원`,
    before: '비어 있음',
    after: row.afterName || '계정',
    hint: hintOf(row),
  }));

const refreshAutoAccountCount = async () => {
  if (!memberCode.value || closingStatus.value?.isClosed) {
    autoAccountReadyCount.value = 0;
    autoAccountDisabled.value = false;
    autoAccountDisabledReason.value = '';
    return;
  }
  autoAccountCountLoading.value = true;
  try {
    const res = await bankbookApi.autoFillAccounts(memberCode.value, {
      ...autoFillQuery(),
      dryRun: true,
    });
    const data = res.data?.data || {};
    autoAccountReadyCount.value = Number(data.updatedCount) || 0;
    autoAccountDisabled.value = !!data.disabled;
    autoAccountDisabledReason.value = String(data.disabledReason || '');
  } catch (error) {
    console.error('계정 자동화 건수 조회 오류:', error);
    autoAccountReadyCount.value = 0;
  } finally {
    autoAccountCountLoading.value = false;
  }
};

const refreshAutoRelCount = async () => {
  if (!memberCode.value || closingStatus.value?.isClosed) {
    autoRelReadyCount.value = 0;
    return;
  }
  autoRelCountLoading.value = true;
  try {
    const res = await bankbookApi.autoFillRelAccounts(memberCode.value, {
      ...autoFillQuery(),
      dryRun: true,
    });
    autoRelReadyCount.value = Number(res.data?.data?.updatedCount) || 0;
  } catch (error) {
    console.error('상대계정 자동화 건수 조회 오류:', error);
    autoRelReadyCount.value = 0;
  } finally {
    autoRelCountLoading.value = false;
  }
};

const openAutoDialog = async (focus?: BankbookAutoKind) => {
  autoDialogOpen.value = true;
  autoPendingFocus.value = focus || null;
  clearAutoPreview();
  await Promise.all([refreshAutoAccountCount(), refreshAutoRelCount()]);
  if (focus) {
    await previewAutoKind(focus);
  }
};

const previewAutoKind = async (kind: BankbookAutoKind) => {
  if (!memberCode.value || closingStatus.value?.isClosed) return;
  autoPreviewKind.value = kind;
  autoPreviewRows.value = [];
  autoPreviewLoading.value = true;
  autoPreviewError.value = '';
  autoFillPreviewPatches.value = [];
  autoBenPreviewMatches.value = {};

  try {
    if (kind === 'account' || kind === 'rel') {
      const res = kind === 'account'
        ? await bankbookApi.autoFillAccounts(memberCode.value, { ...autoFillQuery(), dryRun: true })
        : await bankbookApi.autoFillRelAccounts(memberCode.value, { ...autoFillQuery(), dryRun: true });
      const data = res.data?.data || {};
      const updates = (data.updates || []) as AutoFillUpdate[];
      if (kind === 'account') {
        autoAccountReadyCount.value = updates.length;
        autoAccountDisabled.value = !!data.disabled;
        autoAccountDisabledReason.value = String(data.disabledReason || '');
      } else {
        autoRelReadyCount.value = updates.length;
      }
      autoFillPreviewPatches.value = updates.map((row) => ({ cbIdx: row.cbIdx, patch: row.patch }));
      autoPreviewRows.value = buildFillPreviewRows(updates, (row) => {
        if (kind === 'account' && row.keyword) return `기억된 적요 「${row.keyword}」`;
        if (kind === 'rel' && row.balance != null) return `잔액 ${formatNumber(row.balance)}원`;
        return '';
      });
    } else if (kind === 'funding') {
      const rows = fundingWorkList.value.filter((row) => row.suggested && isItemEditable(row.item));
      autoPreviewRows.value = rows.map((row) => ({
        id: row.item.cb_idx,
        date: formatDate(row.item.cb_date || null),
        memo: String(row.item.cb_memo || ''),
        priceLabel: `${formatNumber(row.item.cb_price || 0)}원`,
        before: '비어 있음',
        after: getFundingName(row.suggested as string),
      }));
    } else if (kind === 'beneficiary') {
      const candidates = beneficiaryAutoCandidates.value;
      if (!candidates.length) {
        autoPreviewRows.value = [];
        return;
      }
      const payload = candidates.map((item) => ({
        idx: item.cb_idx!,
        memo: item.cb_memo || '',
        price: item.cb_price || 0,
      }));
      const res = await beneficiaryApi.matchFromMemo(memberCode.value, payload);
      const memoMatches = res.data?.success ? (res.data.data || {}) : {};
      autoBenPreviewMatches.value = memoMatches;
      autoPreviewRows.value = Object.entries(memoMatches).map(([cbIdxStr, match]) => {
        const item = cashbookList.value.find((row) => String(row.cb_idx) === cbIdxStr);
        return {
          id: cbIdxStr,
          date: formatDate(item?.cb_date || null),
          memo: String(item?.cb_memo || ''),
          priceLabel: `${formatNumber(item?.cb_price || 0)}원`,
          before: '미연결',
          after: (match as { cb_name?: string })?.cb_name || '수급자',
        };
      });
    }
  } catch (error) {
    console.error('자동화 미리보기 오류:', error);
    autoPreviewRows.value = [];
    autoPreviewError.value = '미리보기를 불러오지 못했습니다. 잠시 후 다시 눌러 주세요.';
  } finally {
    autoPreviewLoading.value = false;
  }
};

const applyPreviewPatches = async (label: string) => {
  const patches = autoFillPreviewPatches.value;
  if (!patches.length) {
    alert('적용할 항목이 없습니다. 미리보기를 먼저 확인해 주세요.');
    return;
  }
  const results = await Promise.allSettled(
    patches.map((row) => bankbookApi.update(row.cbIdx, row.patch))
  );
  const ok = results.filter((result) => result.status === 'fulfilled').length;
  await loadCashbookData();
  alert(ok > 0 ? `${label} ${ok}건을 채웠습니다. 틀린 항목은 해당 행에서 고치면 됩니다.` : '적용할 항목이 없습니다.');
};

const applyAutoKind = async (kind: BankbookAutoKind) => {
  if (!memberCode.value || closingStatus.value?.isClosed) return;
  if (autoPreviewKind.value !== kind) return;
  autoApplying.value = true;
  try {
    if (kind === 'account') {
      isAutoAccountProcessing.value = true;
      try {
        await applyPreviewPatches('계정');
        await refreshAutoAccountCount();
      } catch (error) {
        console.error('계정 자동 넣기 오류:', error);
        alert('계정 자동 넣기 중 오류가 발생했습니다.');
      } finally {
        isAutoAccountProcessing.value = false;
      }
    } else if (kind === 'rel') {
      isAutoRelAccProcessing.value = true;
      try {
        await applyPreviewPatches('상대계정');
        await refreshAutoRelCount();
      } catch (error) {
        console.error('상대계정 자동 넣기 오류:', error);
        alert('상대계정 자동 넣기 중 오류가 발생했습니다.');
      } finally {
        isAutoRelAccProcessing.value = false;
      }
    } else if (kind === 'funding') {
      await autoAssignFunding({ skipConfirm: true });
    } else if (kind === 'beneficiary') {
      await runBeneficiaryAutoMatchFromMemo({
        skipConfirm: true,
        previewMatches:
          Object.keys(autoBenPreviewMatches.value).length
            ? autoBenPreviewMatches.value
            : undefined,
      });
    }
    clearAutoPreview();
    if (kind === 'funding' || kind === 'beneficiary') {
      await Promise.all([refreshAutoAccountCount(), refreshAutoRelCount()]);
    }
  } finally {
    autoApplying.value = false;
  }
};

// 계정 그룹 펼치기/접기 토글
const toggleAccountGroup = (scode: string) => {
  expandedScodes.value[scode] = !expandedScodes.value[scode];
};

// 모든 계정 그룹 펼치기
const expandAllGroups = () => {
  for (const group of groupedByAccount.value) {
    expandedScodes.value[group.scode] = true;
  }
};

// 모든 계정 그룹 접기
const collapseAllGroups = () => {
  expandedScodes.value = {};
};

// 검색 초기화
const clearAllSearch = () => {
  searchScode.value = '';
  searchMemo.value = '';
  filterDayStart.value = null;
  filterDayEnd.value = null;
  filterSplitOnly.value = false;
  ledgerDisplayMode.value = 'cashbook';
  expandedSplitParents.value = {};
};

// 계정코드에 박혀 있는 자금원천 (caion_fn_code.cfc_funding) + 기관 오버라이드
const getAccountFunding = (scode: string | undefined, gubun: 'IN' | 'OUT'): string | null => {
  if (!scode) return null;
  if (gubun === 'IN') {
    const override = fundingInferSettings.value.incomeFunding[scode];
    if (override) return override;
  }
  const list = gubun === 'IN' ? incomeCodeList.value : expenseCodeList.value;
  const found = list.find((c) => c.scode === scode);
  const funding = found?.cfc_funding ? String(found.cfc_funding).trim() : '';
  return funding || null;
};

// 수입: 해당 계정(오버라이드 또는 코드표)의 자금원천
// 지출: 설정한 계정명 예외 → (옵션) 상대계정 자금원천 → 지출계정 기본
const inferFundingForItem = (item: CashbookData): string | null => {
  if (!fundingInferSettings.value.enabled) return null;
  if (item.cb_gubun === 'IN') {
    return getAccountFunding(item.cb_scode, 'IN');
  }
  const scodeName = item.cb_scode ? getScodeNameByCode(item.cb_scode, 'OUT') : null;
  if (scodeName) {
    const rule = fundingInferSettings.value.expenseNameRules.find(
      (r) => r.name.trim() === scodeName.trim()
    );
    if (rule?.funding) return rule.funding;
  }
  if (fundingInferSettings.value.useRelAccountFunding && item.cb_rel_acc) {
    return getAccountFunding(item.cb_rel_acc, 'IN');
  }
  return getAccountFunding(item.cb_scode, 'OUT');
};

const filteredFundingIncomeCodes = computed(() => {
  const q = fundingIncomeSearch.value.trim().toLowerCase();
  const list = incomeCodeList.value;
  if (!q) return list;
  return list.filter(
    (c) =>
      String(c.sname || '').toLowerCase().includes(q) ||
      String(c.scode || '').toLowerCase().includes(q)
  );
});

const effectiveIncomeFunding = (code: { scode: string; cfc_funding?: string }) => {
  const override = fundingInferSettings.value.incomeFunding[code.scode];
  if (override) return override;
  const base = code.cfc_funding ? String(code.cfc_funding).trim() : '';
  return base || '';
};

const applyFundingInferSettings = (setting: FundingInferSettings) => {
  fundingInferSettings.value = {
    enabled: setting.enabled !== false,
    useRelAccountFunding: setting.useRelAccountFunding !== false,
    expenseNameRules: (setting.expenseNameRules?.length
      ? setting.expenseNameRules
      : defaultFundingInferSettings().expenseNameRules
    ).map((r) => ({ name: r.name, funding: r.funding })),
    incomeFunding: { ...(setting.incomeFunding || {}) },
  };
};

const loadFundingInferSettings = async () => {
  if (!memberCode.value) {
    applyFundingInferSettings(defaultFundingInferSettings());
    return;
  }
  try {
    const res = await bankbookApi.getFundingInferSetting(memberCode.value);
    if (res.data?.success && res.data.data) {
      applyFundingInferSettings(res.data.data as FundingInferSettings);
    } else {
      applyFundingInferSettings(defaultFundingInferSettings());
    }
  } catch (error) {
    console.error('자금원천 규칙 조회 오류:', error);
    applyFundingInferSettings(defaultFundingInferSettings());
  }
};

const persistFundingInferSettings = () => {
  if (fundingSettingSaveTimer) clearTimeout(fundingSettingSaveTimer);
  fundingSettingSaveTimer = setTimeout(async () => {
    if (!memberCode.value) return;
    fundingSettingSaveState.value = 'saving';
    try {
      const res = await bankbookApi.saveFundingInferSetting(memberCode.value, {
        enabled: fundingInferSettings.value.enabled,
        useRelAccountFunding: fundingInferSettings.value.useRelAccountFunding,
        expenseNameRules: fundingInferSettings.value.expenseNameRules
          .map((r) => ({ name: r.name.trim(), funding: r.funding }))
          .filter((r) => r.name && r.funding),
        incomeFunding: { ...fundingInferSettings.value.incomeFunding },
      });
      if (res.data?.success && res.data.data) {
        applyFundingInferSettings(res.data.data as FundingInferSettings);
      }
      fundingSettingSaveState.value = 'saved';
      if (fundingSettingSavedTimer) clearTimeout(fundingSettingSavedTimer);
      fundingSettingSavedTimer = setTimeout(() => {
        fundingSettingSaveState.value = 'idle';
      }, 1600);
    } catch (error) {
      console.error('자금원천 규칙 저장 오류:', error);
      fundingSettingSaveState.value = 'error';
    }
  }, 280);
};

const onIncomeFundingPick = (scode: string, event: Event) => {
  setIncomeFundingOverride(scode, (event.target as HTMLSelectElement).value);
};

const onExpenseFundingPick = (idx: number, event: Event) => {
  setExpenseRuleFunding(idx, (event.target as HTMLSelectElement).value);
};

const setIncomeFundingOverride = (scode: string, funding: string) => {
  const next = { ...fundingInferSettings.value.incomeFunding };
  if (!funding) {
    delete next[scode];
  } else {
    next[scode] = funding;
  }
  fundingInferSettings.value.incomeFunding = next;
  persistFundingInferSettings();
};

const setExpenseRuleFunding = (idx: number, funding: string) => {
  const rules = fundingInferSettings.value.expenseNameRules.map((r, i) =>
    i === idx ? { ...r, funding } : r
  );
  fundingInferSettings.value.expenseNameRules = rules;
  persistFundingInferSettings();
};

const addExpenseNameRule = () => {
  fundingInferSettings.value.expenseNameRules = [
    ...fundingInferSettings.value.expenseNameRules,
    { name: '', funding: '04' },
  ];
};

const removeExpenseNameRule = (idx: number) => {
  if (fundingInferSettings.value.expenseNameRules.length <= 1) return;
  fundingInferSettings.value.expenseNameRules = fundingInferSettings.value.expenseNameRules.filter(
    (_, i) => i !== idx
  );
  persistFundingInferSettings();
};

const applyFundingToItems = async (items: CashbookData[], funding: string) => {
  const targets = items.filter((item) => item.cb_idx && isItemEditable(item) && item.cb_funding !== funding);
  if (!targets.length || !funding) return;
  isAutoFundingProcessing.value = true;
  try {
    const results = await Promise.allSettled(
      targets.map((item) => bankbookApi.update(item.cb_idx as number, { cb_funding: funding }))
    );
    results.forEach((result, index) => {
      if (result.status !== 'fulfilled') return;
      const idx = cashbookList.value.findIndex((row) => row.cb_idx === targets[index].cb_idx);
      if (idx !== -1) cashbookList.value[idx].cb_funding = funding;
    });
    const failed = results.filter((result) => result.status === 'rejected').length;
    if (failed) {
      alert(getWorkbenchSaveErrorMessage(results) || `${failed}건 저장에 실패했습니다. 나머지 항목은 반영되었습니다.`);
    } else {
      showSaveToast.value = true;
      setTimeout(() => { showSaveToast.value = false; }, 1600);
    }
  } catch (error) {
    console.error('자금원천 저장 오류:', error);
    alert('자금원천 저장 중 오류가 발생했습니다.');
  } finally {
    isAutoFundingProcessing.value = false;
  }
};

const applyFundingToSelected = async (funding: string) => {
  const selectedIdSet = new Set(ledgerSelectedIds.value);
  const targets = fundingSelectedItems.value.filter(
    (item) => item.cb_idx != null && selectedIdSet.has(item.cb_idx)
  );
  if (!targets.length || !funding) {
    alert('바꿀 항목을 먼저 체크하세요.');
    return;
  }
  const name = fundingCodeList.find((row) => row.code === funding)?.name || '선택한 원천';
  const preview = targets
    .slice(0, 3)
    .map((item) => item.cb_memo || '적요 없음')
    .join(', ');
  const more = targets.length > 3 ? ` 외 ${targets.length - 3}건` : '';
  const ok = confirm(
    `체크한 ${targets.length}건의 자금원천을 「${name}」으로 바꿉니다.\n${preview}${more}`
  );
  if (!ok) return;
  await applyFundingToItems(targets, funding);
};

// 계정 기준으로 자금원천 일괄 부여 (자동화 패널에서 미리보기 후 적용)
const autoAssignFunding = async (opts?: { skipConfirm?: boolean }) => {
  const targets = fundingWorkList.value.filter((row) => row.suggested && isItemEditable(row.item));
  if (!targets.length) {
    alert('기준으로 넣을 자금원천 항목이 없습니다.');
    return;
  }
  if (!opts?.skipConfirm) {
    if (!confirm(`자금원천 ${targets.length}건을 규칙대로 채울까요?`)) return;
  }
  isAutoFundingProcessing.value = true;
  try {
    const results = await Promise.allSettled(
      targets.map((row) => bankbookApi.update(row.item.cb_idx as number, { cb_funding: row.suggested as string }))
    );
    results.forEach((result, index) => {
      if (result.status !== 'fulfilled') return;
      const item = targets[index].item;
      const idx = cashbookList.value.findIndex((row) => row.cb_idx === item.cb_idx);
      if (idx !== -1) cashbookList.value[idx].cb_funding = targets[index].suggested as string;
    });
    const failed = results.filter((result) => result.status === 'rejected').length;
    if (failed) {
      alert(getWorkbenchSaveErrorMessage(results) || `${failed}건 저장에 실패했습니다. 나머지 항목은 반영되었습니다.`);
    } else {
      showSaveToast.value = true;
      setTimeout(() => { showSaveToast.value = false; }, 1600);
      if (opts?.skipConfirm) {
        alert(`${targets.length - failed}건 자금원천을 넣었습니다.`);
      }
    }
  } catch (error) {
    console.error('자금원천 자동부여 오류:', error);
    alert('자금원천 자동부여 중 오류가 발생했습니다.');
  } finally {
    isAutoFundingProcessing.value = false;
  }
};

// 계정코드로 계정명 조회 (수입/지출 구분)
const getScodeNameByCode = (scode: string, gubun: 'IN' | 'OUT'): string | null => {
  const list = gubun === 'IN' ? incomeCodeList.value : expenseCodeList.value;
  const found = list.find(c => c.scode === scode);
  return found?.sname || null;
};

// 이월금 계산 (stepu 정책): 해당 연도 1월부터 (month-1)월까지의 (수입 - 지출) 누적
const calculateCarryover = async (year: number, month: number): Promise<number> => {
  if (month <= 1) return 0;
  if (!memberCode.value) return 0;
  
  // stepu 정책 누적 이월금(해당 연도 1월~전월 수입-지출)을 백엔드 단일 쿼리로 조회.
  // 기존 월별 반복 조회는 중간 요청 실패를 무시(catch)하여 잔액이 어긋나는 문제가 있었음.
  const res = await bankbookApi.getCumulativeCarryover(
    memberCode.value,
    String(year),
    String(month).padStart(2, '0'),
    selectedBizGubun.value || undefined,
    selectedBankCode.value || undefined
  );
  
  return Number(res.data?.data?.balance) || 0;
};

// 데이터 로드
const loadCashbookData = async () => {
  if (!memberCode.value) return;
  
  isLoading.value = true;
  try {
    // API 파라미터 구성 (항상 연월 기준으로 조회, 일자 필터는 프론트에서 처리)
    const params: any = {
      bizGubun: selectedBizGubun.value || undefined,
      year: currentYear.value,
      month: currentMonth.value
    };
    
    // 분개 개수 포함된 목록 조회 API 사용 (전체 데이터 조회, 통장 필터는 프론트에서 처리)
    const res = await bankbookApi.getListWithSplits(memberCode.value, params);
    // cb_price를 숫자로 변환
    const data = res.data?.data || [];
    cashbookList.value = data.map((item: CashbookData) => ({
      ...item,
      cb_price: Number(item.cb_price) || 0,
      split_count: Number(item.split_count) || 0,
      is_split_item: Number(item.is_split_item) || 0,
      parent_idx: item.parent_idx ?? item.cb_parent_idx ?? null,
      cb_parent_idx: item.cb_parent_idx ?? item.parent_idx ?? null,
      cb_receipt_matched: Number(item.cb_receipt_matched) === 1 ? 1 : 0,
    }));
    expandedSplitParents.value = {};
    
    // 이월금 계산 (stepu 정책)
    // - 1월: 이월금 = 0 (전년도 잔고는 "전년도이월금" 수입 계정으로 포함됨)
    // - 2월 이상: 해당 연도 1월부터 전월까지의 (수입 - 지출) 누적
    const currentMonthNum = parseInt(currentMonth.value);
    const currentYearNum = parseInt(currentYear.value);
    
    if (currentMonthNum === 1) {
      prevMonthBalance.value = 0;
    } else {
      // 이월금 조회 실패가 이미 로드된 목록을 지우지 않도록 개별 처리
      try {
        prevMonthBalance.value = await calculateCarryover(currentYearNum, currentMonthNum);
      } catch (carryoverError) {
        console.error('이월금 조회 오류:', carryoverError);
        prevMonthBalance.value = 0;
      }
    }
    
    // 본인부담금수입(112) 항목에 대해 수급자 매칭 수행
    await matchBeneficiaries();
    await loadAdjustState();
    await loadLaborBaseRatio();
  } catch (error) {
    console.error('통장내역 데이터 로드 오류:', error);
    cashbookList.value = [];
    prevMonthBalance.value = 0;
  } finally {
    isLoading.value = false;
  }
};

// 본인부담금수입: 저장된(수동/자동매칭 확정) 매칭만 복원 — 적요 자동매칭은 하지 않음
const matchBeneficiaries = async () => {
  if (!memberCode.value) return;
  
  const targetItems = cashbookList.value
    .filter(item => item.cb_scode === '112' && item.cb_idx)
    .map(item => ({
      idx: item.cb_idx!,
      matchedBeneficiaryIdx: item.cb_matched_beneficiary_idx
    }));
  
  if (targetItems.length === 0) {
    beneficiaryMatches.value = {};
    return;
  }
  
  try {
    const collectionRes = await collectionApi.getByMember(memberCode.value, {
      year: parseInt(currentYear.value),
      month: parseInt(currentMonth.value),
      bizGubun: selectedBizGubun.value || undefined
    });
    
    const collectionData = collectionRes.data?.success 
      ? (collectionRes.data.data?.list || collectionRes.data.data || [])
      : [];
    
    const beneficiaryNameMap = new Map<number, string>();
    collectionData.forEach((item: any) => {
      if (item.cb_idx && item.cb_name) {
        beneficiaryNameMap.set(item.cb_idx, item.cb_name);
      }
    });
    
    const finalMatches: Record<number, { cb_idx: number; cb_name: string; matchType: string }> = {};
    targetItems.forEach(item => {
      if (!item.matchedBeneficiaryIdx) return;
      finalMatches[item.idx] = {
        cb_idx: item.matchedBeneficiaryIdx,
        cb_name: beneficiaryNameMap.get(item.matchedBeneficiaryIdx) || '',
        matchType: 'manual'
      };
    });
    
    beneficiaryMatches.value = finalMatches;
    
    if (Object.keys(finalMatches).length > 0) {
      await syncDepositToCollection();
    }
  } catch (error) {
    console.error('수급자 매칭 복원 오류:', error);
    beneficiaryMatches.value = {};
  }
};

/** 본인부담금 자동매칭 (자동화 패널 미리보기 후 적용) */
const runBeneficiaryAutoMatchFromMemo = async (opts?: {
  skipConfirm?: boolean;
  previewMatches?: Record<string, { cb_idx: number; cb_name: string }>;
}) => {
  if (!memberCode.value || closingStatus.value?.isClosed) return;

  const candidates = beneficiaryAutoCandidates.value;

  if (candidates.length === 0) {
    alert('자동매칭할 본인부담금 항목이 없습니다.\n(이미 매칭됐거나 적요가 없는 항목은 제외됩니다)');
    return;
  }

  if (!opts?.skipConfirm) {
    if (!confirm(
      `적요에 수급자 이름이 포함된 본인부담금 ${candidates.length}건을 자동매칭할까요?\n이미 매칭된 항목은 그대로 둡니다.`
    )) {
      return;
    }
  }

  isAutoBeneficiaryMatching.value = true;
  try {
    let memoMatches = opts?.previewMatches;
    if (!memoMatches) {
      const payload = candidates.map((item) => ({
        idx: item.cb_idx!,
        memo: item.cb_memo || '',
        price: item.cb_price || 0,
      }));
      const res = await beneficiaryApi.matchFromMemo(memberCode.value, payload);
      memoMatches = res.data?.success ? (res.data.data || {}) : {};
    }

    const entries = Object.entries(memoMatches) as Array<[string, { cb_idx: number; cb_name: string }]>;

    if (entries.length === 0) {
      alert('적요에서 일치하는 수급자를 찾지 못했습니다.\n수급자가 등록돼 있고 적요에 이름이 포함돼 있는지 확인해 주세요.');
      return;
    }

    let saved = 0;
    for (const [cbIdxStr, match] of entries) {
      const cashbookIdx = parseInt(cbIdxStr, 10);
      if (!cashbookIdx || !match?.cb_idx) continue;

      await bankbookApi.update(cashbookIdx, {
        cb_matched_beneficiary_idx: match.cb_idx,
      });

      const itemIndex = cashbookList.value.findIndex((i) => i.cb_idx === cashbookIdx);
      if (itemIndex !== -1) {
        cashbookList.value[itemIndex].cb_matched_beneficiary_idx = match.cb_idx;
      }

      beneficiaryMatches.value[cashbookIdx] = {
        cb_idx: match.cb_idx,
        cb_name: match.cb_name,
        matchType: 'manual',
      };
      saved += 1;
    }

    if (saved > 0) {
      await syncDepositToCollection();
      beneficiaryModalDepositData.value = collectDepositData();
    }

    alert(`${saved}건을 수급자와 매칭했습니다.${candidates.length > saved ? `\n(대상 ${candidates.length}건 중 이름 미일치 ${candidates.length - saved}건)` : ''}`);
  } catch (error: any) {
    console.error('수급자 본인부담금 자동매칭 오류:', error);
    alert(`자동매칭에 실패했습니다: ${error.response?.data?.message || error.message || '알 수 없는 오류'}`);
  } finally {
    isAutoBeneficiaryMatching.value = false;
  }
};

// 통장 본인부담금수입과 수납 데이터 동기화
const syncDepositToCollection = async () => {
  if (!memberCode.value) return;
  
  try {
    // 매칭된 수급자별로 입금 정보 수집 (날짜순 정렬 포함)
    const depositsMap = new Map<number, Array<{ amount: number; date: string; cashbookIdx: number }>>();
    
    // 본인부담금수입(112) 항목들을 날짜순으로 정렬
    const sortedItems = cashbookList.value
      .filter(item => item.cb_scode === '112' && item.cb_idx)
      .sort((a, b) => {
        // 날짜순 정렬, 같은 날짜면 idx순
        const dateCompare = (a.cb_date || '').localeCompare(b.cb_date || '');
        if (dateCompare !== 0) return dateCompare;
        return (a.cb_idx || 0) - (b.cb_idx || 0);
      });
    
    sortedItems.forEach(item => {
      const match = beneficiaryMatches.value[item.cb_idx!];
      if (match) {
        const cbIdx = match.cb_idx;
        if (!depositsMap.has(cbIdx)) {
          depositsMap.set(cbIdx, []);
        }
        depositsMap.get(cbIdx)!.push({
          amount: item.cb_price || 0,
          date: item.cb_date || '',
          cashbookIdx: item.cb_idx!
        });
      }
    });
    
    // 수급자별로 입금 정보 집계 (합산 + 개별 내역)
    const deposits: Array<{ 
      cb_idx: number; 
      amount: number; 
      date?: string;
      depositDetails?: Array<{ amount: number; date: string }>;
    }> = [];
    
    for (const [cbIdx, depositList] of depositsMap.entries()) {
      const totalAmount = depositList.reduce((sum, d) => sum + d.amount, 0);
      const firstDate = depositList[0]?.date;
      
      deposits.push({
        cb_idx: cbIdx,
        amount: totalAmount,
        date: firstDate || undefined,
        depositDetails: depositList.map(d => ({ amount: d.amount, date: d.date }))
      });
    }
    
    // 수납 데이터 동기화 API 호출 (deposits가 비어있어도 호출 - 이전 매칭 초기화 위해)
    await collectionApi.syncDeposit(memberCode.value, {
      year: parseInt(currentYear.value),
      month: parseInt(currentMonth.value),
      deposits,
      bizGubun: selectedBizGubun.value || undefined
    });
    
  } catch (error) {
    console.error('수납 데이터 동기화 오류:', error);
  }
};

// 계정코드 로드
const loadAccountCodes = async () => {
  try {
    const res = await bankbookApi.getAccountCodes(currentYear.value);
    accountCodes.value = (res.data?.data || []) as AccountCode[];
  } catch (error) {
    console.error('계정코드 로드 오류:', error);
  }
};

// 인라인 수정 시작
const startInlineEdit = (item: CashbookData) => {
  // 마감 상태에서는 수정 불가
  if (closingStatus.value?.isClosed) {
    alert('마감된 통장내역은 수정할 수 없습니다.\n마감 해제 후 수정해주세요.');
    return;
  }
  
  editingRowIdx.value = item.cb_idx || null;
  inlineEditData.value = { ...item };
};

// 인라인 수정 취소
const cancelInlineEdit = () => {
  editingRowIdx.value = null;
  inlineEditData.value = {
    cb_gubun: '',
    cb_scode: '',
    cb_funding: '',
    cb_memo: '',
    cb_price: 0,
    cb_date: '',
    cb_rel_acc: ''
  };
  newKeywordInput.value = '';
};

// 인라인 수정 저장
const saveInlineEdit = async () => {
  if (!editingRowIdx.value) return;
  
  isInlineSaving.value = true;
  try {
    await bankbookApi.update(editingRowIdx.value, {
      cb_scode: inlineEditData.value.cb_scode,
      cb_funding: inlineEditData.value.cb_funding,
      cb_memo: inlineEditData.value.cb_memo,
      cb_price: inlineEditData.value.cb_price,
      cb_rel_acc: inlineEditData.value.cb_rel_acc
    });
    
    // 로컬 데이터 업데이트
    const idx = cashbookList.value.findIndex(item => item.cb_idx === editingRowIdx.value);
    if (idx !== -1) {
      cashbookList.value[idx] = { ...cashbookList.value[idx], ...inlineEditData.value };
    }
    
    showSaveToast.value = true;
    setTimeout(() => { showSaveToast.value = false; }, 2000);
    
    cancelInlineEdit();
    await loadAdjustState();
  } catch (error) {
    console.error('저장 오류:', error);
    alert('저장에 실패했습니다.');
  } finally {
    isInlineSaving.value = false;
  }
};

// ============================================
// 자금원천 자동 부여 로직
// ============================================

// 계정코드로 계정명 조회
const getAccountNameByCode = (scode: string, gubun: string): string | null => {
  const list = gubun === 'IN' ? incomeCodeList.value : expenseCodeList.value;
  const found = list.find(item => item.scode === scode);
  return found?.sname || null;
};

// ============================================
// 상대계정 자동 추론 로직
// ============================================

/**
 * 지출 항목에 대해 사용 가능한 수입 계정(상대계정)을 자동으로 추론
 * 
 * 로직:
 * 1. 해당 지출의 날짜/idx 이전 데이터 기준으로 각 수입 계정별 잔액 계산
 * 2. 잔액 = (수입 합계) - (해당 계정을 상대계정으로 사용한 지출 합계)
 * 3. 이월금이 있으면 수입 비율에 따라 각 계정에 분배
 * 4. 지출 금액을 커버할 수 있는 수입 계정 중 잔액이 가장 많은 것을 선택
 * 
 * @param targetItem 상대계정을 찾을 지출 항목
 * @returns 추론된 수입 계정 코드 또는 null
 */
const inferRelativeAccount = (targetItem: CashbookData): string | null => {
  // 지출이 아니면 상대계정 불필요
  if (targetItem.cb_gubun !== 'OUT') return null;
  
  const targetDate = targetItem.cb_date;
  const targetIdx = targetItem.cb_idx;
  const targetPrice = Math.abs(Number(targetItem.cb_price) || 0);
  
  if (targetPrice <= 0) return null;
  
  // 수입 계정별 잔액 계산
  // Map<scode, { totalIncome: number, usedExpense: number }>
  const accountBalances = new Map<string, { totalIncome: number; usedExpense: number; sname: string }>();
  
  // 1. 수입 항목 집계 (targetItem 날짜/idx 이전 또는 같은 날짜라면 idx가 작은 것)
  let totalIncome = 0; // 전체 수입 합계 (이월금 분배용)
  
  for (const item of cashbookList.value) {
    if (item.cb_gubun !== 'IN' || !item.cb_scode) continue;
    
    // 날짜 비교: targetDate 이전이거나, 같은 날짜면 idx가 작거나 같아야 함
    const isBeforeOrSame = item.cb_date < targetDate || 
      (item.cb_date === targetDate && (item.cb_idx || 0) <= (targetIdx || 0));
    
    if (!isBeforeOrSame) continue;
    
    const scode = item.cb_scode;
    const price = Number(item.cb_price) || 0;
    
    if (!accountBalances.has(scode)) {
      const sname = getAccountNameByCode(scode, 'IN') || scode;
      accountBalances.set(scode, { totalIncome: 0, usedExpense: 0, sname });
    }
    
    accountBalances.get(scode)!.totalIncome += price;
    totalIncome += price;
  }
  
  // 2. 이월금 처리 - 현재 월에 실제 수입이 있는 계정에만 비율 배분
  const carryover = Number(prevMonthBalance.value) || 0;
  
  if (carryover > 0 && totalIncome > 0 && accountBalances.size > 0) {
    // 현재 월 수입이 있는 계정에만 이월금을 비율에 따라 분배
    for (const [scode, balance] of accountBalances.entries()) {
      const ratio = balance.totalIncome / totalIncome;
      balance.totalIncome += carryover * ratio;
    }
  }
  // 현재 월에 수입이 없으면 이월금만으로는 상대계정 추론하지 않음
  // (실제 수입이 있는 계정만 상대계정 후보가 됨)
  
  // 3. 지출에서 사용된 상대계정 집계 (targetItem 이전의 지출만)
  for (const item of cashbookList.value) {
    if (item.cb_gubun !== 'OUT' || !item.cb_rel_acc) continue;
    if (item.cb_idx === targetIdx) continue; // 자기 자신 제외
    
    // 날짜 비교: targetDate 이전이거나, 같은 날짜면 idx가 작아야 함
    const isBefore = item.cb_date < targetDate || 
      (item.cb_date === targetDate && (item.cb_idx || 0) < (targetIdx || 0));
    
    if (!isBefore) continue;
    
    const relAcc = item.cb_rel_acc;
    const price = Math.abs(Number(item.cb_price) || 0);
    
    if (accountBalances.has(relAcc)) {
      accountBalances.get(relAcc)!.usedExpense += price;
    }
  }
  
  // 4. 잔액이 충분한 수입 계정 찾기 (잔액이 가장 많은 것 선택)
  let bestAccount: string | null = null;
  let bestBalance = 0;
  
  for (const [scode, balance] of accountBalances.entries()) {
    const remaining = balance.totalIncome - balance.usedExpense;
    
    // 잔액이 지출 금액 이상이고, 가장 잔액이 많은 계정 선택
    if (remaining >= targetPrice && remaining > bestBalance) {
      bestBalance = remaining;
      bestAccount = scode;
    }
  }
  
  return bestAccount;
};

// 자금원천 자동 조회 (API)
const fetchFundingByAccount = async (sname: string, trcode: string): Promise<string | null> => {
  if (!sname || /^\d+$/.test(sname)) return null; // 숫자로만 구성된 계정명은 스킵
  
  try {
    const res = await bankbookApi.getFundingByAccount(sname, trcode, currentYear.value);
    if (res.data?.success && res.data.data?.funding) {
      return res.data.data.funding;
    }
  } catch (error) {
    console.error('자금원천 조회 오류:', error);
  }
  return null;
};

// 세입(수입) 계정 선택 시 자금원천 자동 설정
watch(() => inlineEditData.value.cb_scode, async (newScode, oldScode) => {
  if (!newScode || newScode === oldScode || !editingRowIdx.value) return;
  
  const gubun = inlineEditData.value.cb_gubun;
  
  // 수입(IN)인 경우: 계정의 funding 조회
  if (gubun === 'IN') {
    const sname = getAccountNameByCode(newScode, 'IN');
    if (sname) {
      const funding = await fetchFundingByAccount(sname, 'IN');
      if (funding) {
        inlineEditData.value.cb_funding = funding;
        // 후원금인 경우 사업명도 설정 (필요시)
      }
    }
  }
  
  if (gubun === 'OUT') {
    const paired = adjustIncomes.value.filter((inc) =>
      (inc.allowedExpenses || []).some((exp) => exp.scode === newScode) && inc.remaining > 0
    );
    const currentRel = inlineEditData.value.cb_rel_acc;
    const currentOk = currentRel && paired.some((inc) => inc.scode === currentRel);
    if (paired.length && !currentOk) {
      paired.sort((a, b) => b.remaining - a.remaining);
      inlineEditData.value.cb_rel_acc = paired[0].scode;
    }
    const relScode = inlineEditData.value.cb_rel_acc;
    const relName = relScode ? getAccountNameByCode(relScode, 'IN') : null;
    if (relName) {
      const funding = await fetchFundingByAccount(relName, 'IN');
      if (funding) inlineEditData.value.cb_funding = funding;
    }
  }
});

// 지출(OUT) 상대계정 선택 시 자금원천 자동 설정 (생계비 제외)
watch(() => inlineEditData.value.cb_rel_acc, async (newRelAcc, oldRelAcc) => {
  if (!newRelAcc || newRelAcc === oldRelAcc || !editingRowIdx.value) return;
  
  const gubun = inlineEditData.value.cb_gubun;
  if (gubun !== 'OUT') return;
  
  const scode = inlineEditData.value.cb_scode;
  if (!scode) return;
  
  // 상대계정(수입 계정)의 funding 조회
  const relAccName = getAccountNameByCode(newRelAcc, 'IN');
  if (relAccName) {
    const funding = await fetchFundingByAccount(relAccName, 'IN');
    if (funding) {
      inlineEditData.value.cb_funding = funding;
    }
  }
});

// ============================================
// 수급자관리 모달 (수금관리 탭) 관련
// ============================================

// 통장내역에서 본인부담금(112) 매칭 데이터 수집 (같은 수급자는 합산)
const collectDepositData = () => {
  const depositData: Record<number, { amount: number; date: string }> = {};
  
  // 현재 월의 통장내역에서 본인부담금(112) 항목 중 매칭된 것들 수집
  cashbookList.value.forEach((item: CashbookData) => {
    if (item.cb_scode === '112' && item.cb_idx) {
      const match = beneficiaryMatches.value[item.cb_idx];
      if (match) {
        // cb_idx(수급자 idx)를 키로 사용 - 같은 수급자는 합산
        if (depositData[match.cb_idx]) {
          // 기존 값이 있으면 합산
          depositData[match.cb_idx].amount += (item.cb_price || 0);
          // 날짜는 가장 빠른 날짜 유지
          if ((item.cb_date || '') < depositData[match.cb_idx].date) {
            depositData[match.cb_idx].date = item.cb_date || '';
          }
        } else {
          // 새로 추가
          depositData[match.cb_idx] = {
            amount: item.cb_price || 0,
            date: item.cb_date || ''
          };
        }
      }
    }
  });
  
  return depositData;
};

// 수급자 칩 → 수납 탭으로 이동 (해당 이름으로 검색)
const openCollectionForBeneficiary = (beneficiaryName: string) => {
  goStep('collection', { collectionSearch: beneficiaryName || '' });
};

// 본인부담금수입 클릭 시 분개 내역 토글
const toggleCollectionDetails = async (item: CashbookData) => {
  if (!item.cb_idx) return;
  
  // 이미 펼쳐져 있으면 접기
  if (expandedCollectionRows.value.has(item.cb_idx)) {
    expandedCollectionRows.value.delete(item.cb_idx);
    return;
  }
  
  // 매칭된 수급자 정보 확인
  const matchInfo = beneficiaryMatches.value[item.cb_idx];
  if (!matchInfo) return;
  
  // 분개 내역 조회
  try {
    const res = await collectionApi.getByBeneficiary(matchInfo.cb_idx, {
      year: parseInt(currentYear.value),
      month: parseInt(currentMonth.value)
    });
    
    const items = res.data?.data || [];
    // 모든 분개 항목 표시 (금액이 있는 항목만)
    collectionDetails.value[item.cb_idx] = items
      .filter((c: any) => c.cc_charge > 0 || c.cc_deposit > 0)
      .map((c: any) => ({
        scode: c.cc_scode,
        sname: c.cc_sname,
        charge: c.cc_charge || 0,
        memo: c.cc_memo || ''
      }));
    
    expandedCollectionRows.value.add(item.cb_idx);
  } catch (error) {
    console.error('분개 내역 조회 오류:', error);
  }
};

// 분개 내역이 펼쳐져 있는지 확인
const isCollectionExpanded = (cbIdx: number) => {
  return expandedCollectionRows.value.has(cbIdx);
};

// 분개 내역 합계 계산
const getCollectionTotal = (cbIdx: number) => {
  const details = collectionDetails.value[cbIdx];
  if (!details || details.length === 0) return 0;
  return details.reduce((sum, detail) => sum + (detail.charge || 0), 0);
};

// 인라인 금액 입력 처리
const handleInlinePriceInput = (e: Event) => {
  const input = e.target as HTMLInputElement;
  const value = input.value.replace(/[^0-9]/g, '');
  inlineEditData.value.cb_price = parseInt(value) || 0;
};

// 인라인 금액 키다운 처리
const handleInlinePriceKeydown = (e: KeyboardEvent) => {
  if (e.key === 'Enter') {
    saveInlineEdit();
  } else if (e.key === 'Escape') {
    cancelInlineEdit();
  }
};

// 삭제 확인 (단건)
const confirmDelete = (item: CashbookData) => {
  if (closingStatus.value?.isClosed || !isItemEditable(item)) {
    alert('마감된 통장내역은 삭제할 수 없습니다.\n마감 해제 후 삭제해주세요.');
    return;
  }
  selectedItem.value = item;
  deleteTargets.value = [item];
  deleteDialogOpen.value = true;
};

// 선택 항목 삭제 확인 (다건)
const confirmDeleteSelected = () => {
  if (closingStatus.value?.isClosed) {
    alert('마감된 통장내역은 삭제할 수 없습니다.\n마감 해제 후 삭제해주세요.');
    return;
  }
  const items = selectedLedgerItems.value.filter((item) => isItemEditable(item));
  if (!items.length) {
    alert('삭제할 수 있는 항목이 없습니다.');
    return;
  }
  deleteTargets.value = items;
  selectedItem.value = items[0] || null;
  deleteDialogOpen.value = true;
};

// 항목 삭제 (단건·다건)
const deleteItem = async () => {
  const targets = (deleteTargets.value.length
    ? deleteTargets.value
    : (selectedItem.value ? [selectedItem.value] : [])
  ).filter((item) => item.cb_idx);

  if (!targets.length) return;

  if (closingStatus.value?.isClosed) {
    alert('마감된 통장내역은 삭제할 수 없습니다.\n마감 해제 후 삭제해주세요.');
    deleteDialogOpen.value = false;
    return;
  }

  isDeleting.value = true;
  try {
    const matchedCbIdxList: number[] = [];
    targets.forEach((deletedItem) => {
      if (deletedItem.cb_scode === '112' && deletedItem.cb_idx) {
        const match = beneficiaryMatches.value[deletedItem.cb_idx];
        if (match && !matchedCbIdxList.includes(match.cb_idx)) {
          matchedCbIdxList.push(match.cb_idx);
        }
      }
    });

    if (matchedCbIdxList.length > 0 && memberCode.value) {
      try {
        await collectionApi.clearDeposits(memberCode.value, {
          cbIdxList: matchedCbIdxList,
          year: parseInt(currentYear.value),
          month: parseInt(currentMonth.value),
          bizGubun: selectedBizGubun.value || undefined
        });
      } catch (clearError) {
        console.error('수납관리 입금액 초기화 오류:', clearError);
      }
    }

    targets.forEach((deletedItem) => {
      if (deletedItem.cb_idx && beneficiaryMatches.value[deletedItem.cb_idx]) {
        delete beneficiaryMatches.value[deletedItem.cb_idx];
      }
    });

    const deletedIds = new Set(targets.map((t) => t.cb_idx!));
    if (targets.length === 1) {
      await bankbookApi.delete(targets[0].cb_idx!);
    } else {
      await bankbookApi.deleteMultiple([...deletedIds]);
    }

    cashbookList.value = cashbookList.value.filter((item) => !deletedIds.has(item.cb_idx!));
    ledgerSelectedIds.value = ledgerSelectedIds.value.filter((id) => !deletedIds.has(id));
    deleteDialogOpen.value = false;
    selectedItem.value = null;
    deleteTargets.value = [];
    await loadAdjustState();
  } catch (error) {
    console.error('삭제 오류:', error);
    alert('삭제에 실패했습니다.');
  } finally {
    isDeleting.value = false;
  }
};

// 모두 삭제
const deleteAllItems = async () => {
  // 마감 상태에서는 삭제 불가
  if (closingStatus.value?.isClosed) {
    alert('마감된 통장내역은 삭제할 수 없습니다.\n마감 해제 후 삭제해주세요.');
    deleteAllDialogOpen.value = false;
    return;
  }
  
  isDeleting.value = true;
  try {
    const itemsToDelete = filteredCashbookList.value;
    const idxList = itemsToDelete.map(item => item.cb_idx).filter(Boolean) as number[];
    
    // 본인부담금(112) 항목 중 수급자 매칭된 것들의 수급자 ID 수집
    const matchedCbIdxList: number[] = [];
    itemsToDelete.forEach(item => {
      if (item.cb_scode === '112' && item.cb_idx) {
        const match = beneficiaryMatches.value[item.cb_idx];
        if (match && !matchedCbIdxList.includes(match.cb_idx)) {
          matchedCbIdxList.push(match.cb_idx);
        }
      }
    });
    
    // 수납관리의 입금액 초기화
    if (matchedCbIdxList.length > 0 && memberCode.value) {
      try {
        await collectionApi.clearDeposits(memberCode.value, {
          cbIdxList: matchedCbIdxList,
          year: parseInt(currentYear.value),
          month: parseInt(currentMonth.value),
          bizGubun: selectedBizGubun.value || undefined
        });
      } catch (clearError) {
        console.error('수납관리 입금액 초기화 오류:', clearError);
      }
    }
    
    // beneficiaryMatches에서 삭제되는 항목들 제거
    itemsToDelete.forEach(item => {
      if (item.cb_scode === '112' && item.cb_idx && beneficiaryMatches.value[item.cb_idx]) {
        delete beneficiaryMatches.value[item.cb_idx];
      }
    });
    
    await bankbookApi.deleteMultiple(idxList);
    
    cashbookList.value = cashbookList.value.filter(item => !idxList.includes(item.cb_idx!));
    deleteAllDialogOpen.value = false;
  } catch (error) {
    console.error('일괄 삭제 오류:', error);
    alert('삭제에 실패했습니다.');
  } finally {
    isDeleting.value = false;
  }
};

// 업로드 다이얼로그 열기
const openUploadDialog = () => {
  if (isBankbookUploadDisabled.value) {
    alert('마감된 통장내역에는 업로드할 수 없습니다.\n마감 해제 후 업로드해주세요.');
    return;
  }
  uploadDialogOpen.value = true;
};

// 업로드 완료 처리
const handleUploadSaved = (savedItems?: CashbookData[]) => {
  // 새로 저장된 항목들의 ID를 하이라이트 목록에 추가 (있는 경우에만)
  if (savedItems && Array.isArray(savedItems) && savedItems.length > 0) {
    highlightedIdxList.value = savedItems.map(item => item.cb_idx!).filter(Boolean);
    
    // 3초 후 하이라이트 해제
    setTimeout(() => {
      highlightedIdxList.value = [];
    }, 3000);
  }
  
  // 데이터 새로고침
  loadCashbookData();
};

// 업로드 완료 알림 처리 (빠른 업로드용)
const handleUploadComplete = (results: UploadResultInfo[]) => {
  // 기존 알림 초기화
  uploadNotifications.value = [];
  
  // 각 결과에 대해 알림 생성 (순차적으로 표시)
  results.forEach((result, index) => {
    const notification: UploadNotification = {
      id: ++notificationIdCounter,
      show: false,
      bankCode: result.bankCode,
      bankAlias: result.bankAlias,
      fileName: result.fileName,
      count: result.count,
      success: result.success,
      message: result.message
    };
    
    uploadNotifications.value.push(notification);
    
    // 순차적으로 알림 표시 (200ms 간격)
    setTimeout(() => {
      notification.show = true;
    }, index * 200);
    
    // 5초 후 알림 제거
    setTimeout(() => {
      notification.show = false;
      // 애니메이션 후 배열에서 제거
      setTimeout(() => {
        const idx = uploadNotifications.value.findIndex(n => n.id === notification.id);
        if (idx !== -1) {
          uploadNotifications.value.splice(idx, 1);
        }
      }, 300);
    }, 5000 + index * 200);
  });
  
  // 데이터 새로고침
  loadCashbookData();

  // 업로드된 통장으로 사이드바 전환 (업로드 결과 확인용)
  const firstSuccess = results.find(r => r.success && r.bankCode);
  if (firstSuccess?.bankCode) {
    selectedBankCode.value = firstSuccess.bankCode;
  }
};

// 커스텀 키워드 추가
const addCustomKeyword = async () => {
  if (!newKeywordInput.value.trim() || !inlineEditData.value.cb_scode) return;
  
  isAddingKeyword.value = true;
  try {
    await bankbookApi.learn({
      m_code: memberCode.value,
      biz_gubun: selectedBizGubun.value || undefined,
      gubun: inlineEditData.value.cb_gubun,
      keyword: newKeywordInput.value.trim(),
      scode: inlineEditData.value.cb_scode
    });
    
    newKeywordInput.value = '';
  } catch (error) {
    console.error('키워드 추가 오류:', error);
  } finally {
    isAddingKeyword.value = false;
  }
};

// 수급자 목록 로드 (매칭용) - 수납관리에 등록된 모든 수급자 (이미 매칭된 수급자 포함)
const loadBeneficiaryList = async () => {
  if (!memberCode.value) return;
  
  try {
    // 1. 해당 월 수납관리에 등록된 수급자 목록 조회
    const collectionRes = await collectionApi.getByMember(memberCode.value, {
      year: parseInt(currentYear.value),
      month: parseInt(currentMonth.value),
      bizGubun: selectedBizGubun.value || undefined
    });
    
    if (!collectionRes.data?.success) {
      beneficiaryList.value = [];
      return;
    }
    
    const collectionData = collectionRes.data.data?.list || collectionRes.data.data || [];
    
    // 2. 수급자별로 그룹핑하여 총 청구금액 계산 (본인부담금 + 비급여 합산)
    // 이미 매칭된 수급자도 포함 (같은 수급자를 여러 통장내역에 매칭 가능)
    const beneficiaryMap = new Map<number, {
      cb_idx: number;
      cb_name: string;
      cb_ltc_no: string;
      cc_idx: number;
      cc_charge: number;
      totalCharge: number;
    }>();
    
    collectionData.forEach((item: any) => {
      const cbIdx = item.cb_idx;
      if (!cbIdx) return;
      
      if (!beneficiaryMap.has(cbIdx)) {
        beneficiaryMap.set(cbIdx, {
          cb_idx: cbIdx,
          cb_name: item.cb_name || '',
          cb_ltc_no: item.cb_ltc_no || '',
          cc_idx: 0,
          cc_charge: 0,
          totalCharge: 0
        });
      }
      
      const entry = beneficiaryMap.get(cbIdx)!;
      const charge = item.cc_charge || 0;
      
      if (item.cc_scode === '112') {
        entry.cc_idx = item.cc_idx;
        entry.cc_charge = charge;
      }
      
      entry.totalCharge += charge;
    });
    
    beneficiaryList.value = Array.from(beneficiaryMap.values()).filter(b => b.cc_idx > 0);
      
  } catch (error) {
    console.error('수급자 목록 로드 오류:', error);
    beneficiaryList.value = [];
  }
};

// 수급자 매칭 팝오버 열기
const openBeneficiaryMatchPopover = async (item: CashbookData) => {
  matchTargetItem.value = item;
  selectedBeneficiaryForMatch.value = null;
  
  // 매칭되지 않은 수급자 목록 새로고침
  await loadBeneficiaryList();
  
  beneficiaryMatchDialogOpen.value = true;
};

// 수급자 매칭 팝오버 닫기
const closeBeneficiaryMatchDialog = () => {
  beneficiaryMatchDialogOpen.value = false;
  matchTargetItem.value = null;
  selectedBeneficiaryForMatch.value = null;
};

// 수급자 매칭 저장
const saveBeneficiaryMatch = async () => {
  if (!selectedBeneficiaryForMatch.value || !matchTargetItem.value?.cb_idx || !memberCode.value) {
    return;
  }
  
  const selectedBeneficiary = beneficiaryList.value.find(
    b => b.cb_idx === selectedBeneficiaryForMatch.value
  );
  
  if (!selectedBeneficiary || !selectedBeneficiary.cc_idx) {
    alert('수급자 정보를 찾을 수 없습니다.');
    return;
  }
  
  try {
    // 1. 통장내역에 매칭 수급자 정보 저장 (수동 매칭 유지용)
    await bankbookApi.update(matchTargetItem.value.cb_idx, {
      cb_matched_beneficiary_idx: selectedBeneficiary.cb_idx
    });
    
    // 2. 로컬 cashbookList 업데이트
    const itemIndex = cashbookList.value.findIndex(i => i.cb_idx === matchTargetItem.value?.cb_idx);
    if (itemIndex !== -1) {
      cashbookList.value[itemIndex].cb_matched_beneficiary_idx = selectedBeneficiary.cb_idx;
    }
    
    // 3. beneficiaryMatches에 매칭 정보 추가 (통장내역 idx → 수급자 정보)
    beneficiaryMatches.value[matchTargetItem.value.cb_idx] = {
      cb_idx: selectedBeneficiary.cb_idx,
      cb_name: selectedBeneficiary.cb_name,
      matchType: 'manual'
    };
    
    // 4. syncDepositToCollection을 호출하여 전체 매칭 정보 기반으로 합산 처리
    await syncDepositToCollection();
    
    closeBeneficiaryMatchDialog();
  } catch (error: any) {
    console.error('수급자 매칭 저장 오류:', error);
    alert(`수급자 매칭 저장에 실패했습니다: ${error.response?.data?.message || error.message || '알 수 없는 오류'}`);
  }
};

// 수급자 매칭 변경 (기존 매칭 해제 후 새 매칭 다이얼로그 열기)
const changeBeneficiaryMatch = async (item: CashbookData) => {
  if (!item.cb_idx || !memberCode.value) return;
  
  const currentMatch = beneficiaryMatches.value[item.cb_idx];
  if (!currentMatch) return;
  
  try {
    // 같은 수급자에게 다른 통장내역도 매칭되어 있는지 확인
    const otherMatchCount = Object.entries(beneficiaryMatches.value)
      .filter(([cbIdx, match]) => 
        parseInt(cbIdx) !== item.cb_idx && match.cb_idx === currentMatch.cb_idx
      ).length;
    
    // 1. 통장내역의 매칭 정보 초기화
    await bankbookApi.update(item.cb_idx, {
      cb_matched_beneficiary_idx: null
    });
    
    // 2. 로컬 cashbookList 업데이트
    const itemIndex = cashbookList.value.findIndex(i => i.cb_idx === item.cb_idx);
    if (itemIndex !== -1) {
      cashbookList.value[itemIndex].cb_matched_beneficiary_idx = null;
    }
    
    // 3. 로컬 매칭 정보 삭제
    delete beneficiaryMatches.value[item.cb_idx];
    
    // 4. 수납 데이터 재계산 (이전 수급자 입금 초기화 + 남은 매칭 반영)
    // syncDepositToCollection()은 백엔드에서 매칭되지 않은 수급자의 입금을 자동 초기화함
    await syncDepositToCollection();
    
    // 5. 새 매칭 다이얼로그 열기
    openBeneficiaryMatchPopover(item);
    
  } catch (error: any) {
    console.error('수급자 매칭 변경 오류:', error);
    alert(`수급자 매칭 변경에 실패했습니다: ${error.response?.data?.message || error.message || '알 수 없는 오류'}`);
  }
};

// 수급자 매칭 해제
const removeBeneficiaryMatch = async (item: CashbookData) => {
  if (!item.cb_idx || !memberCode.value) return;
  
  const currentMatch = beneficiaryMatches.value[item.cb_idx];
  if (!currentMatch) return;
  
  // 같은 수급자에게 다른 통장내역도 매칭되어 있는지 확인
  const otherMatchCount = Object.entries(beneficiaryMatches.value)
    .filter(([cbIdx, match]) => 
      parseInt(cbIdx) !== item.cb_idx && match.cb_idx === currentMatch.cb_idx
    ).length;
  
  const confirmMsg = otherMatchCount > 0
    ? `'${currentMatch.cb_name}' 수급자와의 이 통장내역 매칭을 해제하시겠습니까?\n(다른 ${otherMatchCount}건의 통장내역은 유지됩니다)`
    : `'${currentMatch.cb_name}' 수급자와의 매칭을 해제하시겠습니까?\n수납관리의 입금 정보도 초기화됩니다.`;
  
  if (!confirm(confirmMsg)) {
    return;
  }
  
  try {
    // 1. 통장내역의 매칭 정보 초기화
    await bankbookApi.update(item.cb_idx, {
      cb_matched_beneficiary_idx: null
    });
    
    // 2. 로컬 cashbookList 업데이트
    const itemIndex = cashbookList.value.findIndex(i => i.cb_idx === item.cb_idx);
    if (itemIndex !== -1) {
      cashbookList.value[itemIndex].cb_matched_beneficiary_idx = null;
    }
    
    // 3. 로컬 매칭 정보 삭제
    delete beneficiaryMatches.value[item.cb_idx];
    
    // 4. 수납 데이터 재계산 (이전 수급자 입금 초기화 + 남은 매칭 반영)
    // syncDepositToCollection()은 백엔드에서 매칭되지 않은 수급자의 입금을 자동 초기화함
    await syncDepositToCollection();
    
  } catch (error: any) {
    console.error('수급자 매칭 해제 오류:', error);
    alert(`수급자 매칭 해제에 실패했습니다: ${error.response?.data?.message || error.message || '알 수 없는 오류'}`);
  }
};

// AI 학습 관리 모달 열기
const mapLearnRows = (rows: any[]): DictItem[] =>
  (rows || []).map((item: any) => ({
    cd_idx: item.cl_idx,
    m_code: item.m_code,
    cd_gubun: item.cl_gubun,
    cd_keyword: item.cl_keyword,
    cd_scode: item.cl_scode,
    cd_count: item.cl_count,
    ac_name: item.scode_name
  }));

const openDictionaryManageModal = async () => {
  dictionaryManageModalOpen.value = true;
  dictSearchQuery.value = '';
  selectedDictTable.value = null;
  dictDetailList.value = [];
  isDictDetailLoading.value = true;

  try {
    const [incomeRes, expenseRes] = await Promise.all([
      bankbookApi.getLearnList(memberCode.value, { gubun: 'IN' }),
      bankbookApi.getLearnList(memberCode.value, { gubun: 'OUT' })
    ]);
    const incomeRows = incomeRes.data?.data || [];
    const expenseRows = expenseRes.data?.data || [];
    dictionaryStats.value = {
      income: incomeRows.length,
      expense: expenseRows.length,
      relmap: 0
    };
    const preferExpense = expenseRows.length >= incomeRows.length;
    selectedDictTable.value = preferExpense ? 'expense' : 'income';
    dictDetailList.value = mapLearnRows(preferExpense ? expenseRows : incomeRows);
  } catch (error) {
    console.error('딕셔너리 통계 로드 오류:', error);
    dictionaryStats.value = { income: 0, expense: 0, relmap: 0 };
    selectedDictTable.value = 'expense';
    dictDetailList.value = [];
  } finally {
    isDictDetailLoading.value = false;
  }
};


// 딕셔너리 테이블 선택
const selectDictTable = async (table: string) => {
  if (selectedDictTable.value === table && dictDetailList.value.length) return;
  selectedDictTable.value = table;
  isDictDetailLoading.value = true;
  dictSearchQuery.value = '';

  try {
    if (table === 'relmap') {
      dictDetailList.value = [];
      return;
    }
    const gubun = table === 'income' ? 'IN' : 'OUT';
    const res = await bankbookApi.getLearnList(memberCode.value, { gubun });
    dictDetailList.value = mapLearnRows(res.data?.data || []);
  } catch (error) {
    console.error('딕셔너리 목록 로드 오류:', error);
    dictDetailList.value = [];
  } finally {
    isDictDetailLoading.value = false;
  }
};

// 딕셔너리 항목 삭제
const deleteDictItem = async (item: DictItem) => {
  if (!confirm('이 학습 데이터를 삭제하시겠습니까?')) return;
  
  try {
    await bankbookApi.deleteLearn(item.cd_idx);
    dictDetailList.value = dictDetailList.value.filter(d => d.cd_idx !== item.cd_idx);
    
    // 통계 업데이트
    if (dictionaryStats.value && selectedDictTable.value) {
      const key = selectedDictTable.value as keyof typeof dictionaryStats.value;
      dictionaryStats.value[key]--;
    }
  } catch (error) {
    console.error('딕셔너리 삭제 오류:', error);
    alert('삭제에 실패했습니다.');
  }
};

// 영수증 매칭: 편집·캔버스 탭으로 이동
const openReceiptMatchingDialog = (item: CashbookData) => {
  selectedCashbookForMatching.value = item;
  if (isReceiptStep.value) return;
  goStep('receipt', { keepReceiptItem: true });
};

// 영수증 매칭 저장 완료 처리
const handleMatchingSaved = (data: { crm_code: number | null; unmatched?: boolean; cb_idx?: number }) => {
  const targetIdx = data.cb_idx ?? selectedCashbookForMatching.value?.cb_idx;
  if (targetIdx) {
    const idx = cashbookList.value.findIndex(item => item.cb_idx === targetIdx);
    if (idx !== -1) {
      cashbookList.value[idx].cb_receipt_matched = data.unmatched ? 0 : 1;
    }
    if (selectedCashbookForMatching.value?.cb_idx === targetIdx) {
      selectedCashbookForMatching.value = {
        ...selectedCashbookForMatching.value,
        cb_receipt_matched: data.unmatched ? 0 : 1,
      };
    }
  }

  showSaveToast.value = true;
  setTimeout(() => { showSaveToast.value = false; }, 2000);
};

// ============================================
// 통장 관리 메서드
// ============================================

// 통장 목록 로드 (caion_member_bank.m_code = 시설 내부 PK)
const loadBankList = async () => {
  if (!memberCode.value) return;
  
  try {
    const res = await bankbookApi.getBankList(memberCode.value, true);
    let allBanks = (res.data?.data || []) as BankData[];
    
    // 사업구분 필터링: 선택된 사업구분에 해당하는 통장만 표시 (공통 통장 불허용)
    const currentBizGubun = selectedBizGubun.value;
    
    if (currentBizGubun) {
      allBanks = allBanks.filter(b => b.mb_biz_gubun === currentBizGubun);
    }
    
    bankList.value = allBanks;
    
    // 기본값: 전체 보기 (null)
    // selectedBankCode가 아직 설정되지 않았거나, 설정된 통장이 더 이상 존재하지 않으면 전체로 설정
    if (selectedBankCode.value !== null) {
      const exists = bankList.value.some(b => b.mb_code === selectedBankCode.value);
      if (!exists) {
        selectedBankCode.value = null;
      }
    }
  } catch (error) {
    console.error('통장 목록 로드 오류:', error);
    bankList.value = [];
  }
};

// 통장 선택 (null이면 전체 보기)
const selectBank = (bankCode: string | null) => {
  selectedBankCode.value = bankCode;
  // 통장 변경 시 마감/희망이음 상태만 다시 로드 (데이터는 이미 전체 로드됨)
  loadClosingStatus();
  loadHeumieumStatus();
  loadAdjustState();
};

// 통장 코드로 별칭 가져오기
const getBankAlias = (bankCode: string | null | undefined): string => {
  if (!bankCode) return '-';
  const bank = bankList.value.find(b => b.mb_code === bankCode);
  return bank?.mb_alias || bankCode;
};

// 계좌번호 포맷팅
const formatAccountNo = (accountNo: string): string => {
  if (!accountNo) return '';
  // 앞 4자리와 뒤 4자리만 표시, 중간은 *로 마스킹
  if (accountNo.length <= 8) return accountNo;
  const front = accountNo.slice(0, 4);
  const back = accountNo.slice(-4);
  const middle = '*'.repeat(Math.min(accountNo.length - 8, 6));
  return `${front}-${middle}-${back}`;
};

// 통장 사용기간 포맷 (YYYY-MM → YYYY.MM)
const formatBankPeriod = (bank: BankData): string => {
  const formatMonth = (monthStr: string | undefined | null) => {
    if (!monthStr) return '';
    return monthStr.replace('-', '.');
  };
  
  const start = formatMonth(bank.mb_start_date);
  const end = formatMonth(bank.mb_end_date);
  
  if (!start && !end) return '기간 미설정';
  if (start && !end) return `${start} ~ 사용중`;
  if (!start && end) return `~ ${end}`;
  return `${start} ~ ${end}`;
};

// 통장이 현재 연월에 활성화되어 있는지 확인
const isBankActiveForCurrentMonth = (bank: BankData): boolean => {
  const currentYM = `${currentYear.value}-${currentMonth.value}`;
  
  // 시작월이 없으면 항상 활성화
  if (!bank.mb_start_date) return true;
  
  // 현재 연월이 시작월보다 이전이면 비활성화
  if (currentYM < bank.mb_start_date) return false;
  
  // 종료월이 있고, 현재 연월이 종료월보다 이후면 비활성화
  if (bank.mb_end_date && currentYM > bank.mb_end_date) return false;
  
  return true;
};

// 비활성 통장의 툴팁 텍스트
const getBankPeriodTooltip = (bank: BankData): string => {
  const currentYM = `${currentYear.value}-${currentMonth.value}`;
  
  if (!bank.mb_start_date) return '';
  
  if (currentYM < bank.mb_start_date) {
    return `${bank.mb_start_date.replace('-', '.')}부터 사용 가능`;
  }
  
  if (bank.mb_end_date && currentYM > bank.mb_end_date) {
    return `${bank.mb_end_date.replace('-', '.')}에 사용 종료됨`;
  }
  
  return '';
};

// 통장 상태 텍스트 (모달용)
const getBankStatusText = (bank: BankData): string => {
  const currentYM = `${currentYear.value}-${currentMonth.value}`;
  
  if (!bank.mb_start_date) return '기간 미설정';
  
  if (currentYM < bank.mb_start_date) {
    return '예정';
  }
  
  if (bank.mb_end_date && currentYM > bank.mb_end_date) {
    return '종료';
  }
  
  return '사용중';
};

// 통장 관리 다이얼로그 열기
const openBankManageDialog = () => {
  bankManageDialogOpen.value = true;
  showBankForm.value = false;
  editingBank.value = null;
};

// 통장 폼 초기화
const resetBankForm = () => {
  editingBank.value = null;
  // 기본 시작월을 현재 연월로 설정
  const defaultStartMonth = `${currentYear.value}-${currentMonth.value}`;
  // 기본 사업구분: 첫 번째 사업구분 또는 빈 값
  const defaultBizGubun = facilityBizGubunList.value.length > 0 ? facilityBizGubunList.value[0] : '';
  bankFormData.value = {
    mb_alias: '',
    mb_bank_name: '',
    mb_account_no: '',
    mb_purpose: '',
    mb_biz_gubun: defaultBizGubun,
    mb_start_date: defaultStartMonth,
    mb_end_date: ''
  };
};

// 통장 추가 버튼 클릭 - 폼 표시 후 스크롤
const onAddBankClick = () => {
  showBankForm.value = true;
  resetBankForm();
  
  // nextTick으로 DOM 업데이트 후 스크롤
  nextTick(() => {
    if (bankFormSectionRef.value) {
      bankFormSectionRef.value.scrollIntoView({ 
        behavior: 'smooth', 
        block: 'start' 
      });
    }
  });
};

// 통장 수정 모드
const editBank = (bank: BankData) => {
  editingBank.value = bank;
  bankFormData.value = {
    mb_alias: bank.mb_alias,
    mb_bank_name: bank.mb_bank_name,
    mb_account_no: bank.mb_account_no,
    mb_purpose: bank.mb_purpose || '',
    mb_biz_gubun: bank.mb_biz_gubun || '',
    mb_start_date: bank.mb_start_date || '',
    mb_end_date: bank.mb_end_date || ''
  };
  showBankForm.value = true;
  
  // nextTick으로 DOM 업데이트 후 스크롤
  nextTick(() => {
    if (bankFormSectionRef.value) {
      bankFormSectionRef.value.scrollIntoView({ 
        behavior: 'smooth', 
        block: 'start' 
      });
    }
  });
};

// 통장 저장
const saveBank = async () => {
  if (!canSaveBank.value || isSavingBank.value) return;
  
  isSavingBank.value = true;
  try {
    // 사업구분 결정: 폼에서 선택된 값 또는 첫 번째 사업구분 (공통 불가)
    const bizGubun = bankFormData.value.mb_biz_gubun || 
      (facilityBizGubunList.value.length > 0 ? facilityBizGubunList.value[0] : undefined);
    
    if (editingBank.value) {
      // 수정
      await bankbookApi.updateBank(editingBank.value.mb_idx, {
        mb_alias: bankFormData.value.mb_alias,
        mb_bank_name: bankFormData.value.mb_bank_name,
        mb_account_no: bankFormData.value.mb_account_no,
        mb_purpose: bankFormData.value.mb_purpose || undefined,
        mb_biz_gubun: bizGubun,
        mb_start_date: bankFormData.value.mb_start_date || undefined,
        mb_end_date: bankFormData.value.mb_end_date || undefined
      });
    } else {
      // 등록 (m_code = 시설 내부 PK)
      await bankbookApi.createBank({
        m_code: memberCode.value,
        mb_alias: bankFormData.value.mb_alias,
        mb_bank_name: bankFormData.value.mb_bank_name,
        mb_account_no: bankFormData.value.mb_account_no,
        mb_purpose: bankFormData.value.mb_purpose || undefined,
        mb_biz_gubun: bizGubun,
        mb_start_date: bankFormData.value.mb_start_date || undefined,
        mb_end_date: bankFormData.value.mb_end_date || undefined
      });
    }
    
    // 목록 새로고침
    await loadBankList();
    
    showBankForm.value = false;
    editingBank.value = null;
    
    showSaveToast.value = true;
    setTimeout(() => { showSaveToast.value = false; }, 2000);
  } catch (error: any) {
    console.error('통장 저장 오류:', error);
    const errorMessage = error.response?.data?.message || '통장 저장에 실패했습니다.';
    alert(errorMessage);
  } finally {
    isSavingBank.value = false;
  }
};

// 통장 삭제 확인
const confirmDeleteBank = (bank: BankData) => {
  bankToDelete.value = bank;
  deleteBankDialogOpen.value = true;
};

// 통장 삭제
const deleteBank = async () => {
  if (!bankToDelete.value) return;
  
  isDeletingBank.value = true;
  try {
    const res = await bankbookApi.deleteBank(bankToDelete.value.mb_idx);
    
    if (res.data?.deactivated) {
      alert('연결된 통장내역 데이터가 있어 비활성화 처리되었습니다.');
    }
    
    await loadBankList();
    
    deleteBankDialogOpen.value = false;
    bankToDelete.value = null;
  } catch (error: any) {
    console.error('통장 삭제 오류:', error);
    const errorMessage = error.response?.data?.message || '통장 삭제에 실패했습니다.';
    alert(errorMessage);
  } finally {
    isDeletingBank.value = false;
  }
};

// ============================================
// 테스트 데이터 생성 (최고관리자 전용)
// ============================================

const generateTestData = async () => {
  if (!isSuperAdmin.value) {
    alert('최고관리자 권한이 필요합니다.');
    return;
  }
  
  if (!selectedBankCode.value) {
    alert('테스트 데이터를 생성할 통장을 먼저 선택해주세요.');
    return;
  }
  
  const selectedBank = bankList.value.find(b => b.mb_code === selectedBankCode.value);
  const bankAlias = selectedBank?.mb_alias || '';
  
  const confirmMsg = bankAlias.includes('보조금') 
    ? `[${bankAlias}] 통장에 보조금 관련 테스트 데이터 (수입 10건 + 지출 10건)를 생성합니다.\n\n계속하시겠습니까?`
    : `[${bankAlias}] 통장에 테스트 데이터 (수입 50건 + 지출 50건)를 생성합니다.\n\n계속하시겠습니까?`;
  
  if (!confirm(confirmMsg)) return;
  
  isGeneratingTestData.value = true;
  
  try {
    const response = await bankbookApi.generateTestData({
      memberCode: memberCode.value,
      year: currentYear.value,
      month: currentMonth.value,
      bankCode: selectedBankCode.value,
      bankAlias: bankAlias,
      bizGubun: selectedBizGubun.value || null
    });
    
    if (response.data?.success) {
      const { incomeCount, expenseCount } = response.data.data;
      alert(`테스트 데이터 생성 완료!\n수입: ${incomeCount}건, 지출: ${expenseCount}건`);
      await loadCashbookData();
    } else {
      throw new Error(response.data?.message || '테스트 데이터 생성 실패');
    }
  } catch (error: any) {
    console.error('테스트 데이터 생성 오류:', error);
    const errorMessage = error.response?.data?.message || error.message || '테스트 데이터 생성에 실패했습니다.';
    alert(`오류: ${errorMessage}`);
  } finally {
    isGeneratingTestData.value = false;
  }
};

// ============================================
// 기능정의서 가이드: 탭·모달 전환 + 테스트 자료
// ============================================

const waitGuide = (ms: number) => new Promise<void>((resolve) => setTimeout(resolve, ms));

const guideToast = ref({
  show: false,
  message: '',
  color: 'info' as string,
});

const notifyGuide = (message: string, tone: GuideToastTone = 'info') => {
  const color =
    tone === 'success' ? 'success' : tone === 'warn' ? 'warning' : 'primary';
  guideToast.value = { show: true, message, color };
};

const closeGuideOverlays = () => {
  bankManageDialogOpen.value = false;
  uploadDialogOpen.value = false;
  dictionaryManageModalOpen.value = false;
  accountPairModalOpen.value = false;
  collectionExcelModalOpen.value = false;
  settlementModalOpen.value = false;
  laborRatioModalOpen.value = false;
  closingDialogOpen.value = false;
  splitModalOpen.value = false;
  fundingSettingsOpen.value = false;
  matchDialogOpen.value = false;
  autoDialogOpen.value = false;
  clearAutoPreview();
  adjustWorkbenchRef.value?.closeSettings?.();
};

const selectOneLedgerItemForGuide = async () => {
  const item =
    selectedBankCashbookList.value.find(
      (row) => row.cb_idx != null && Number(row.is_split_item) !== 1
    ) || selectedBankCashbookList.value.find((row) => row.cb_idx != null);
  if (!item?.cb_idx) return;
  const tab: 'in' | 'out' = item.cb_gubun === 'IN' ? 'in' : 'out';
  ledgerListTab.value = tab;
  ledgerSelectedIds.value = [item.cb_idx];
  await nextTick();
  adjustWorkbenchRef.value?.switchTab(tab);
  if (tab === 'in') {
    adjustWorkbenchRef.value?.setIncomeSelection?.([item.cb_idx]);
  } else {
    adjustWorkbenchRef.value?.setExpenseSelection?.([item.cb_idx]);
  }
};

const ensureGuideTestData = async (): Promise<{
  ok: boolean;
  message?: string;
  cancelled?: boolean;
}> => {
  closeGuideOverlays();
  goStep('raw');

  if (!selectedBankCode.value) {
    const first =
      activeBankListForModal.value[0] ||
      bankList.value[0] ||
      null;
    if (!first?.mb_code) {
      window.alert(
        '아직 등록된 통장이 없습니다.\n\n' +
          '1) 위쪽 톱니(통장 관리)에서 통장을 만든 뒤\n' +
          '2) 다시 「기능정의서」→「처음부터 자동으로 보기」를 눌러 주세요.'
      );
      return {
        ok: false,
        cancelled: true,
        message: '통장이 없습니다. 통장 관리에서 먼저 등록해 주세요.',
      };
    }
    const pickOk = window.confirm(
      `안내를 위해 통장 하나를 골라 둘까요?\n\n` +
        `통장 이름: ${first.mb_alias || first.mb_bank_name || first.mb_code}\n` +
        `보는 달: ${currentYear.value}년 ${currentMonth.value}월\n\n` +
        '확인을 누르면 이 통장 기준으로 화면을 보여 줍니다.'
    );
    if (!pickOk) {
      return { ok: false, cancelled: true, message: '통장 선택을 취소했습니다.' };
    }
    selectBank(first.mb_code);
    notifyGuide('통장을 골랐습니다.', 'info');
    await waitGuide(50);
  }

  if (!hasNoBankbookData.value) {
    notifyGuide('이미 있는 내역으로 안내를 이어갑니다.', 'info');
    return { ok: true, message: '이미 있는 통장내역으로 안내합니다.' };
  }

  if (!isSuperAdmin.value) {
    window.alert(
      '이 달 통장내역이 비어 있습니다.\n\n' +
        '그래도 「어디에 뭐가 있는지」는 보여 드릴게요.\n' +
        '나중에 엑셀을 올린 뒤 다시 안내를 실행하면 더 실감 납니다.'
    );
    notifyGuide('빈 화면이어도 위치는 보여 드립니다.', 'warn');
    return {
      ok: true,
      message: '내역이 없어도 위치 안내로 진행합니다.',
    };
  }

  if (!selectedBankCode.value) {
    window.alert('통장을 먼저 선택한 뒤 다시 시도해 주세요.');
    return { ok: false, cancelled: true, message: '통장을 먼저 선택해 주세요.' };
  }

  const selectedBank = bankList.value.find((b) => b.mb_code === selectedBankCode.value);
  const bankAlias = selectedBank?.mb_alias || '';
  const createOk = window.confirm(
    `연습용 데이터가 없습니다.\n\n` +
      `「${bankAlias || '선택한 통장'}」에 샘플 수입·지출을 만들어 볼까요?\n\n` +
      '· 확인: 샘플을 넣고 실제 화면처럼 안내\n' +
      '· 취소: 샘플 없이 「버튼·탭 위치」만 안내'
  );
  if (!createOk) {
    notifyGuide('샘플 없이 위치만 안내합니다.', 'warn');
    return {
      ok: true,
      message: '샘플 없이 위치 안내로 진행합니다.',
    };
  }

  isGeneratingTestData.value = true;
  notifyGuide('연습용 샘플을 만드는 중…', 'info');
  try {
    const response = await bankbookApi.generateTestData({
      memberCode: memberCode.value,
      year: currentYear.value,
      month: currentMonth.value,
      bankCode: selectedBankCode.value,
      bankAlias,
      bizGubun: selectedBizGubun.value || null,
    });
    if (response.data?.success) {
      await loadCashbookData();
      const { incomeCount, expenseCount } = response.data.data || {};
      window.alert(
        `연습용 샘플을 만들었습니다.\n\n` +
          `수입 ${incomeCount ?? '-'}건 · 지출 ${expenseCount ?? '-'}건\n\n` +
          '이제 실제 작업하는 것처럼 화면을 보여 드릴게요.'
      );
      notifyGuide('연습용 샘플 준비 완료', 'success');
      return {
        ok: true,
        message: `연습용 샘플 준비 (수입 ${incomeCount ?? '-'} · 지출 ${expenseCount ?? '-'})`,
      };
    }
    window.alert(response.data?.message || '연습용 샘플을 만들지 못했습니다.');
    return { ok: false, message: response.data?.message || '연습용 샘플을 만들지 못했습니다.' };
  } catch (error: any) {
    console.error('가이드 테스트 자료 생성 오류:', error);
    const msg =
      error?.response?.data?.message || error?.message || '연습용 샘플을 만들지 못했습니다.';
    window.alert(`오류가 났습니다.\n${msg}`);
    return { ok: false, message: msg };
  } finally {
    isGeneratingTestData.value = false;
  }
};

const GUIDE_STEP_NOTIFY: Record<string, string> = {
  'bb-test-ym': '어느 달을 볼지 고르는 곳입니다.',
  'bb-test-banks': '어느 통장을 볼지 고르는 곳입니다.',
  'bb-test-bank-manage': '통장을 새로 등록·수정하는 창을 엽니다.',
  'bb-test-steps': '일 순서를 나타내는 1~4단계 탭입니다.',
  'bb-test-summary': '왼쪽에서 합계(이월·수입·지출·잔액)를 봅니다.',
  'bb-test-conditions': '목록을 좁혀 보는 조건·검색입니다.',
  'bb-test-upload-quick': '엑셀로 통장내역을 올리는 창을 엽니다.',
  'bb-test-ledger': '올린 거래 목록(원장)입니다.',
  'bb-test-account': '오른쪽에서 「계정」을 지정하는 곳입니다.',
  'bb-test-recommend-settings': '이 기관의 계정 연결을 보고, 빈칸에 넣습니다.',
  'bb-test-patterns': '예전에 지정해 둔 적요·계정 목록입니다.',
  'bb-test-pairs': '이 수입으로 나갈 수 있는 지출을 연결해 둡니다.',
  'bb-test-rel': '지출의 「어디서 나왔는지」(상대계정)를 고릅니다.',
  'bb-test-funding': '돈의 출처(자금원천)를 지정합니다.',
  'bb-test-funding-settings': '이 기관의 계정과 자금원천 연결을 보고, 빈칸에 넣습니다.',
  'bb-test-auto': '톱니에서 연결을 보고, 이번 달 빈칸을 미리본 뒤 넣습니다.',
  'bb-test-quick-edit': '항목 하나를 고르면 오른쪽 「적요 수정」에서 적요·금액과 수입/지출을 고칩니다.',
  'bb-test-split': '한 건을 여러 계정으로 나누는 분개입니다.',
  'bb-test-collection': '수급자 청구·입금을 다루는 수납 화면입니다.',
  'bb-test-collection-excel': '수납 내용을 엑셀로 올리는 창입니다.',
  'bb-test-receipt': '통장 지출과 영수증 사진을 맞추는 화면입니다.',
  'bb-test-analysis': '계정별로 모아 보는 참고 화면입니다.',
  'bb-test-closing': '이 달 작업을 확정(마감)하는 곳입니다.',
};

const prepareGuideStep = async (target: string): Promise<BankbookGuidePrepareResult> => {
  closeGuideOverlays();
  await nextTick();

  const ahead = GUIDE_STEP_NOTIFY[target];
  if (ahead) notifyGuide(ahead, 'info');

  let status = '';

  switch (target) {
    case 'bb-test-ym':
    case 'bb-test-banks':
    case 'bb-test-steps':
    case 'bb-test-closing':
    case 'bb-test-more':
    case 'bb-test-summary':
    case 'bb-test-conditions':
    case 'bb-test-auto-ben':
    case 'bb-test-auto':
    case 'bb-test-delete-all':
    case 'bb-test-ledger':
      goStep('raw');
      if (target === 'bb-test-auto' || target === 'bb-test-auto-ben') {
        openMatchDialog('account');
        status = '톱니에서 연결을 보고, 빈칸을 미리본 뒤 넣습니다.';
      } else if (target === 'bb-test-closing' && !canOpenClosing.value && !closingStatus.value?.isClosed) {
        status = '내역이 준비되면 여기서 「이 달 마감」을 누릅니다.';
      }
      break;

    case 'bb-test-heumieum':
      goStep('raw');
      if (!(closingStatus.value?.isClosed && selectedBankCode.value)) {
        status = '마감 후에 쓰는 기능입니다. 지금은 마감 버튼 자리를 보여 드립니다.';
      }
      break;

    case 'bb-test-bank-manage':
      goStep('raw');
      bankManageDialogOpen.value = true;
      status = '통장 이름·계좌를 등록하는 창입니다.';
      break;

    case 'bb-test-memo':
      goStep('raw');
      monthMemoOpen.value = true;
      status = '이달에 남길 메모 칸입니다.';
      break;

    case 'bb-test-labor':
      goStep('raw');
      laborRatioModalOpen.value = true;
      status = '인건비 비율을 자세히 보는 창입니다.';
      break;

    case 'bb-test-upload-quick':
    case 'bb-test-upload-manual':
      goStep('raw');
      if (!isBankbookUploadDisabled.value) {
        uploadDialogOpen.value = true;
        status = '은행 엑셀을 올리는 창입니다.';
      } else {
        status = '마감된 달이라 업로드가 잠겨 있어요. 버튼 위치만 기억해 주세요.';
      }
      break;

    case 'bb-test-settlement':
      goStep('raw');
      settlementModalOpen.value = true;
      status = '예산과 실제를 비교하는 결산표입니다.';
      break;

    case 'bb-test-account':
      goStep('adjust');
      status = '오른쪽에서 거래의 「계정」을 고릅니다.';
      break;

    case 'bb-test-recommend-settings':
      goStep('adjust');
      await nextTick();
      openMatchDialog('account');
      status = '이 기관의 적요와 계정 연결입니다. 빈 계정만 넣습니다.';
      break;

    case 'bb-test-patterns':
      goStep('adjust');
      dictionaryManageModalOpen.value = true;
      status = '예전에 지정해 둔 적요·계정 목록입니다.';
      break;

    case 'bb-test-pairs':
      goStep('adjust');
      accountPairModalOpen.value = true;
      status = '이 수입으로 나갈 수 있는 지출을 미리 짝지어 둡니다.';
      break;

    case 'bb-test-rel':
      goStep('rel');
      status = '지출이 「어느 수입에서 나왔는지」 연결하는 곳입니다.';
      break;

    case 'bb-test-funding':
      goStep('funding');
      status = '돈이 어디서 왔는지(자금원천)를 표시합니다.';
      break;

    case 'bb-test-funding-settings':
      goStep('funding');
      await nextTick();
      openMatchDialog('funding');
      status = '이 기관의 계정과 자금원천 연결입니다. 빈 자금원천만 넣습니다.';
      break;

    case 'bb-test-split':
    case 'bb-test-quick-edit':
      goStep('raw');
      await selectOneLedgerItemForGuide();
      rawWorkTab.value = target === 'bb-test-split' ? 'split' : 'account';
      if (target === 'bb-test-quick-edit') {
        quickEditOpen.value = true;
        status = '항목을 하나 고르면 오른쪽 「적요 수정」에서 적요·금액과 수입/지출을 고칠 수 있습니다.';
      } else if (target === 'bb-test-split') {
        status = ledgerSelectedIds.value.length === 1
          ? '한 건을 여러 계정으로 나누는 분개입니다.'
          : '항목을 하나만 고르면 분개할 수 있어요. 분개 탭 위치입니다.';
      }
      break;

    case 'bb-test-collection':
    case 'bb-test-arrears':
      goStep('collection', { force: true });
      status = hasNoBankbookData.value
        ? '내역이 없어도 수납 탭 자리를 열어 두었습니다.'
        : '수급자 청구·입금을 다루는 수납 화면입니다.';
      break;

    case 'bb-test-collection-excel':
      goStep('collection', { force: true });
      await nextTick();
      if (!isCollectionExcelDisabled.value) {
        collectionExcelModalOpen.value = true;
        status = '수납 내용을 엑셀로 한꺼번에 올리는 창입니다.';
      } else {
        status = '지금은 엑셀 올리기가 잠겨 있어요. 수납 탭·엑셀 버튼 위치입니다.';
      }
      break;

    case 'bb-test-receipt':
      goStep('receipt', { force: true });
      status = hasNoBankbookData.value
        ? '내역이 없어도 영수증 탭을 열어 두었습니다. 나중에 사진과 통장을 맞춥니다.'
        : '통장 지출과 영수증 사진을 같은 날짜로 맞추는 화면입니다.';
      break;

    case 'bb-test-analysis':
      goStep('analysis-reference', { force: true });
      status = hasNoBankbookData.value
        ? '내역이 없어도 계정별내역 탭을 열어 두었습니다.'
        : '계정별로 모아 보는 참고 화면입니다. 여기서는 수정하지 않습니다.';
      break;

    default:
      goStep('raw');
      break;
  }

  await nextTick();
  return { status: status || undefined };
};

const bankbookGuideHost: BankbookGuideHost = {
  ensureData: ensureGuideTestData,
  prepare: prepareGuideStep,
  cleanup: closeGuideOverlays,
  notify: notifyGuide,
};

// ============================================
// 마감 관리 기능
// ============================================

// 마감 상태 조회
const loadClosingStatus = async () => {
  // 통장이 선택되지 않으면 마감 상태 초기화하고 요약 조회
  if (!memberCode.value || !selectedBankCode.value) {
    closingStatus.value = null;
    // 전체 선택 시 마감 요약 상태 조회
    await loadClosingSummary();
    return;
  }
  
  // 특정 통장 선택 시 요약 초기화
  closingSummary.value = null;
  
  try {
    const response = await closingApi.getStatus(memberCode.value, {
      year: currentYear.value,
      month: currentMonth.value,
      type: 'bankbook',
      bizGubun: selectedBizGubun.value || undefined,
      bankCode: selectedBankCode.value
    });
    
    if (response.data?.success) {
      closingStatus.value = response.data.data;
    }
  } catch (error) {
    console.error('마감 상태 조회 오류:', error);
  }
};

// 마감 요약 상태 조회 (전체 통장 선택 시)ㅋ
const loadClosingSummary = async () => {
  if (!memberCode.value) {
    closingSummary.value = null;
    return;
  }
  
  try {
    const response = await closingApi.getBankClosingSummary(memberCode.value, {
      year: currentYear.value,
      month: currentMonth.value,
      type: 'bankbook',
      bizGubun: selectedBizGubun.value || undefined
    });
    
    if (response.data?.success) {
      closingSummary.value = response.data.data;
    }
  } catch (error) {
    console.error('마감 요약 상태 조회 오류:', error);
    closingSummary.value = null;
  }
};

// 마감 다이얼로그 열기
const openClosingDialog = () => {
  validationResult.value = null;
  closingDialogOpen.value = true;
  runValidation();
};

// 유효성 검사 실행
const runValidation = async () => {
  if (!memberCode.value) return;
  
  isValidating.value = true;
  validationResult.value = null;
  
  try {
    const response = await closingApi.validate(memberCode.value, {
      year: currentYear.value,
      month: currentMonth.value,
      type: 'bankbook',
      status: 'account_adjust',
      bizGubun: selectedBizGubun.value || undefined,
      bankCode: selectedBankCode.value || undefined,
      checkPairs: true
    });
    
    if (response.data?.success) {
      validationResult.value = response.data.data;
    }
  } catch (error: any) {
    console.error('유효성 검사 오류:', error);
    validationResult.value = {
      valid: false,
      message: error.response?.data?.message || '유효성 검사 중 오류가 발생했습니다.'
    };
  } finally {
    isValidating.value = false;
  }
};

// 마감 처리 실행
const executeClosing = async () => {
  if (!memberCode.value || !validationResult.value?.valid) return;
  
  isClosing.value = true;
  
  try {
    const response = await closingApi.close(memberCode.value, {
      year: currentYear.value,
      month: currentMonth.value,
      type: 'bankbook',
      status: 'account_adjust',
      bizGubun: selectedBizGubun.value || undefined,
      bankCode: selectedBankCode.value || undefined,
      checkPairs: true
    });
    
    if (response.data?.success) {
      closingDialogOpen.value = false;
      await loadClosingStatus();
      
      showSaveToast.value = true;
      setTimeout(() => { showSaveToast.value = false; }, 2000);
    } else {
      throw new Error(response.data?.message || '마감 처리 실패');
    }
  } catch (error: any) {
    console.error('마감 처리 오류:', error);
    const errorMessage = error.response?.data?.message || error.message || '마감 처리에 실패했습니다.';
    alert(`오류: ${errorMessage}`);
  } finally {
    isClosing.value = false;
  }
};

// 마감 해제 확인
const confirmUnclose = async () => {
  if (!isAdmin.value) {
    alert('마감 해제는 관리자 이상만 가능합니다.');
    return;
  }
  
  // 희망이음 업로드 요청 중일 때는 마감해제 불가
  if (heumieumStatus.value?.status === 'requested') {
    alert('희망이음 업로드 요청이 대기중입니다.\n\n요청을 먼저 취소한 후 마감을 해제해주세요.');
    return;
  }
  
  // 희망이음 업로드 완료 상태 확인
  let confirmMessage = '마감을 해제하시겠습니까?\n마감 해제 후 통장내역을 수정할 수 있습니다.';
  
  if (heumieumStatus.value?.status === 'completed') {
    confirmMessage = '주의: 희망이음 업로드가 완료된 상태입니다.\n\n마감을 해제하면 희망이음 업로드 기록도 함께 삭제됩니다.\n이미 업로드된 데이터는 희망이음에서 별도로 삭제해야 합니다.\n\n계속하시겠습니까?';
  }
  
  if (!confirm(confirmMessage)) return;
  
  isClosing.value = true;
  
  try {
    const response = await closingApi.unclose(memberCode.value, {
      year: currentYear.value,
      month: currentMonth.value,
      type: 'bankbook',
      status: 'account_adjust',
      bizGubun: selectedBizGubun.value || undefined,
      bankCode: selectedBankCode.value || undefined
    });
    
    if (response.data?.success) {
      await loadClosingStatus();
      await loadHeumieumStatus();
      
      showSaveToast.value = true;
      setTimeout(() => { showSaveToast.value = false; }, 2000);
    } else {
      throw new Error(response.data?.message || '마감 해제 실패');
    }
  } catch (error: any) {
    console.error('마감 해제 오류:', error);
    const errorMessage = error.response?.data?.message || error.message || '마감 해제에 실패했습니다.';
    alert(`오류: ${errorMessage}`);
  } finally {
    isClosing.value = false;
  }
};

// 마감일시 포맷
const formatClosingDate = (dateStr: string | undefined) => {
  if (!dateStr) return '';
  const date = new Date(dateStr);
  return `${date.getFullYear()}.${(date.getMonth() + 1).toString().padStart(2, '0')}.${date.getDate().toString().padStart(2, '0')} ${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}`;
};

// ============================================
// 희망이음 업로드 관련
// ============================================

// 희망이음 업로드 상태 조회
const loadHeumieumStatus = async () => {
  if (!memberCode.value || !selectedBankCode.value) {
    heumieumStatus.value = null;
    return;
  }
  
  try {
    const response = await closingApi.heumieumStatus(memberCode.value, {
      year: currentYear.value,
      month: currentMonth.value,
      bizGubun: selectedBizGubun.value || undefined
    });
    
    if (response.data?.success) {
      const items = response.data.data?.items || [];
      const currentBankItem = items.find((item: any) => item.cc_bank_code === selectedBankCode.value);
      
      if (currentBankItem) {
        heumieumStatus.value = {
          status: currentBankItem.cc_request_status,
          requestAt: currentBankItem.cc_request_at,
          completedAt: currentBankItem.cc_closed_at,
          completeMemo: currentBankItem.cc_complete_memo,
          displayName: currentBankItem.cc_display_name
        };
      } else {
        heumieumStatus.value = null;
      }
    }
  } catch (error) {
    console.error('희망이음 상태 조회 오류:', error);
    heumieumStatus.value = null;
  }
};

// 희망이음 업로드 요청
const requestHeumieumUpload = async () => {
  if (!memberCode.value || !selectedBankCode.value) return;
  
  const bankAlias = getBankAlias(selectedBankCode.value);
  if (!confirm(`${bankAlias} 통장의 희망이음 업로드를 요청하시겠습니까?`)) return;
  
  isRequestingHeumieum.value = true;
  
  try {
    const response = await closingApi.heumieumRequest(memberCode.value, {
      year: currentYear.value,
      month: currentMonth.value,
      bizGubun: selectedBizGubun.value || undefined,
      bankCode: selectedBankCode.value,
      bankAlias: bankAlias
    });
    
    if (response.data?.success) {
      await loadHeumieumStatus();
      alert('희망이음 업로드가 요청되었습니다.');
    } else {
      throw new Error(response.data?.message || '요청 실패');
    }
  } catch (error: any) {
    console.error('희망이음 업로드 요청 오류:', error);
    const errorMessage = error.response?.data?.message || error.message || '요청에 실패했습니다.';
    alert(`오류: ${errorMessage}`);
  } finally {
    isRequestingHeumieum.value = false;
  }
};

// 희망이음 업로드 요청 취소
const cancelHeumieumUpload = async () => {
  if (!memberCode.value || !selectedBankCode.value) return;
  
  if (!confirm('희망이음 업로드 요청을 취소하시겠습니까?')) return;
  
  isRequestingHeumieum.value = true;
  
  try {
    const response = await closingApi.heumieumCancel(memberCode.value, {
      year: currentYear.value,
      month: currentMonth.value,
      bankCode: selectedBankCode.value
    });
    
    if (response.data?.success) {
      await loadHeumieumStatus();
      alert('요청이 취소되었습니다.');
    } else {
      throw new Error(response.data?.message || '취소 실패');
    }
  } catch (error: any) {
    console.error('희망이음 업로드 취소 오류:', error);
    const errorMessage = error.response?.data?.message || error.message || '취소에 실패했습니다.';
    alert(`오류: ${errorMessage}`);
  } finally {
    isRequestingHeumieum.value = false;
  }
};

// ============================================
// 라이프사이클
// ============================================

// 초기 데이터 로드 여부
const initialDataLoaded = ref(false);

// 초기 데이터 로드
const loadInitialData = async () => {
  if (initialDataLoaded.value) return;
  initialDataLoaded.value = true;
  
  await loadBankList();
  await loadAccountCodes();
  await loadFundingInferSettings();
  await loadBeneficiaryList();
  await loadCashbookData();
  await loadClosingStatus();
  await loadHeumieumStatus();
  await loadMonthMemo();
  await loadLaborBaseRatio();
};

// 사업구분 변경 감지 → 통장 목록 및 데이터 다시 로드
watch(selectedBizGubun, async (newBizGubun, oldBizGubun) => {
  // 사업구분이 설정되면 초기 데이터 로드 (첫 로드)
  if (newBizGubun && !initialDataLoaded.value) {
    await loadInitialData();
    return;
  }
  
  // 이미 로드된 상태에서 사업구분 변경 시 다시 로드
  if (newBizGubun !== oldBizGubun && initialDataLoaded.value) {
    await loadBankList();
    await loadCashbookData();
    await loadLaborBaseRatio();
  }
}, { immediate: true });

watch(selectedBankCode, () => {
  if (!initialDataLoaded.value) return;
  loadLaborBaseRatio();
});

onMounted(async () => {
  // 단일 사업구분 시설이거나 이미 selectedBizGubun이 설정된 경우 바로 로드
  // (watch에서 처리되지 않은 경우를 대비)
  if (selectedBizGubun.value && !initialDataLoaded.value) {
    await loadInitialData();
  }
});

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_snackbar = _resolveComponent("v-snackbar")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_Transition, { name: "toast" }, {
      default: _withCtx(() => [
        (showSaveToast.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_component_v_icon, {
                size: "18",
                color: "white"
              }, {
                default: _withCtx(() => [...(_cache[94] || (_cache[94] = [
                  _createTextVNode("mdi-check-circle", -1)
                ]))]),
                _: 1
              }),
              _cache[95] || (_cache[95] = _createElementVNode("span", null, "저장되었습니다", -1))
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    (isLoading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_v_progress_circular, {
            indeterminate: "",
            color: "primary",
            size: "48"
          }),
          _cache[96] || (_cache[96] = _createElementVNode("p", null, "통장내역 데이터 로딩 중...", -1))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("header", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("button", {
                  type: "button",
                  class: "wt-ym-nav",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (changeMonth(-1))),
                  title: "이전 달"
                }, [
                  _createVNode(_component_v_icon, { size: "18" }, {
                    default: _withCtx(() => [...(_cache[97] || (_cache[97] = [
                      _createTextVNode("mdi-chevron-left", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _createElementVNode("button", {
                  type: "button",
                  class: "wt-ym-value",
                  onClick: openMonthPicker
                }, [
                  _createElementVNode("span", _hoisted_8, _toDisplayString(currentYear.value), 1),
                  _cache[98] || (_cache[98] = _createElementVNode("span", { class: "wt-ym-sep" }, ".", -1)),
                  _createElementVNode("span", _hoisted_9, _toDisplayString(currentMonth.value), 1),
                  _createElementVNode("input", {
                    type: "month",
                    ref_key: "monthPickerRef",
                    ref: monthPickerRef,
                    value: `${currentYear.value}-${currentMonth.value}`,
                    onChange: onMonthPickerChange,
                    class: "hidden-month-picker"
                  }, null, 40, _hoisted_10)
                ]),
                _createElementVNode("button", {
                  type: "button",
                  class: "wt-ym-nav",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (changeMonth(1))),
                  title: "다음 달"
                }, [
                  _createVNode(_component_v_icon, { size: "18" }, {
                    default: _withCtx(() => [...(_cache[99] || (_cache[99] = [
                      _createTextVNode("mdi-chevron-right", -1)
                    ]))]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("button", {
                  type: "button",
                  class: _normalizeClass(["wt-bank all", { active: selectedBankCode.value === null }]),
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (selectBank(null)))
                }, [
                  _createVNode(_component_v_icon, { size: "13" }, {
                    default: _withCtx(() => [...(_cache[100] || (_cache[100] = [
                      _createTextVNode("mdi-view-grid-outline", -1)
                    ]))]),
                    _: 1
                  }),
                  _cache[101] || (_cache[101] = _createElementVNode("span", null, "전체", -1))
                ], 2),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activeBankListForModal.value, (bank) => {
                  return (_openBlock(), _createElementBlock("button", {
                    key: bank.mb_code,
                    type: "button",
                    class: _normalizeClass(["wt-bank", { active: selectedBankCode.value === bank.mb_code, closed: isBankClosed(bank.mb_code) }]),
                    onClick: ($event: any) => (selectBank(bank.mb_code))
                  }, [
                    _createVNode(_component_v_icon, { size: "13" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(isBankClosed(bank.mb_code) ? 'mdi-lock' : 'mdi-bank'), 1)
                      ]),
                      _: 2
                    }, 1024),
                    _createElementVNode("span", null, _toDisplayString(bank.mb_alias), 1)
                  ], 10, _hoisted_12))
                }), 128)),
                _createElementVNode("button", {
                  type: "button",
                  class: "wt-bank-add",
                  "data-tour": "bb-test-bank-manage",
                  onClick: openBankManageDialog,
                  title: "통장 관리"
                }, [
                  _createVNode(_component_v_icon, { size: "14" }, {
                    default: _withCtx(() => [...(_cache[102] || (_cache[102] = [
                      _createTextVNode("mdi-cog-outline", -1)
                    ]))]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createVNode(BankbookFeatureSpecPanel, {
                  spec: _unref(bankbookFeatureSpec),
                  "guide-host": bankbookGuideHost
                }, null, 8, ["spec"]),
                _createElementVNode("div", _hoisted_14, [
                  (canOpenClosing.value)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        type: "button",
                        class: "wt-action primary",
                        onClick: openClosingDialog
                      }, [
                        _createVNode(_component_v_icon, { size: "14" }, {
                          default: _withCtx(() => [...(_cache[103] || (_cache[103] = [
                            _createTextVNode("mdi-lock-check", -1)
                          ]))]),
                          _: 1
                        }),
                        _cache[104] || (_cache[104] = _createTextVNode(" 이 달 마감 ", -1))
                      ]))
                    : (closingStatus.value?.isClosed)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                          _createVNode(_component_v_icon, { size: "14" }, {
                            default: _withCtx(() => [...(_cache[105] || (_cache[105] = [
                              _createTextVNode("mdi-lock", -1)
                            ]))]),
                            _: 1
                          }),
                          _cache[106] || (_cache[106] = _createTextVNode(" 마감됨 ", -1))
                        ]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_16, "마감"))
                ]),
                (hasMoreMenuItems.value)
                  ? (_openBlock(), _createBlock(_component_v_menu, {
                      key: 0,
                      location: "bottom end",
                      "close-on-content-click": true
                    }, {
                      activator: _withCtx(({ props }) => [
                        _createElementVNode("button", _mergeProps(props, {
                          type: "button",
                          class: "wt-more",
                          title: "더보기",
                          "data-tour": "bb-test-more"
                        }), [
                          _createVNode(_component_v_icon, { size: "18" }, {
                            default: _withCtx(() => [...(_cache[107] || (_cache[107] = [
                              _createTextVNode("mdi-dots-horizontal", -1)
                            ]))]),
                            _: 1
                          })
                        ], 16)
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_v_list, {
                          density: "compact",
                          class: "wt-more-menu"
                        }, {
                          default: _withCtx(() => [
                            (closingStatus.value?.isClosed && isAdmin.value)
                              ? (_openBlock(), _createBlock(_component_v_list_item, {
                                  key: 0,
                                  onClick: confirmUnclose,
                                  disabled: isClosing.value
                                }, {
                                  prepend: _withCtx(() => [
                                    _createVNode(_component_v_icon, { size: "18" }, {
                                      default: _withCtx(() => [...(_cache[108] || (_cache[108] = [
                                        _createTextVNode("mdi-lock-open-outline", -1)
                                      ]))]),
                                      _: 1
                                    })
                                  ]),
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_list_item_title, null, {
                                      default: _withCtx(() => [...(_cache[109] || (_cache[109] = [
                                        _createTextVNode("마감 해제", -1)
                                      ]))]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["disabled"]))
                              : _createCommentVNode("", true),
                            (isSuperAdmin.value && selectedBankCode.value)
                              ? (_openBlock(), _createBlock(_component_v_list_item, {
                                  key: 1,
                                  onClick: generateTestData,
                                  disabled: isGeneratingTestData.value
                                }, {
                                  prepend: _withCtx(() => [
                                    _createVNode(_component_v_icon, { size: "18" }, {
                                      default: _withCtx(() => [...(_cache[110] || (_cache[110] = [
                                        _createTextVNode("mdi-flask-outline", -1)
                                      ]))]),
                                      _: 1
                                    })
                                  ]),
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_list_item_title, null, {
                                      default: _withCtx(() => [...(_cache[111] || (_cache[111] = [
                                        _createTextVNode("테스트 자료 생성", -1)
                                      ]))]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["disabled"]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("nav", _hoisted_17, [
              _createElementVNode("button", {
                type: "button",
                class: _normalizeClass(["work-step", {
              active: workSection.value === 'raw',
              todo: hasNoBankbookData.value || pendingAdjustCount.value > 0 || unfundedCount.value > 0,
              done: !hasNoBankbookData.value && pendingAdjustCount.value === 0 && unfundedCount.value === 0
            }]),
                "data-tour": "bb-test-raw-tab",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (goStep('raw')))
              }, [
                _cache[113] || (_cache[113] = _createElementVNode("span", { class: "ws-num" }, "1", -1)),
                _createElementVNode("span", _hoisted_18, [
                  _cache[112] || (_cache[112] = _createElementVNode("span", { class: "ws-name" }, "통장내역", -1)),
                  (hasNoBankbookData.value)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_19, "업로드 필요"))
                    : (pendingAdjustCount.value === 0 && unfundedCount.value === 0)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_20, "완료"))
                      : _createCommentVNode("", true)
                ])
              ], 2),
              _createElementVNode("button", {
                type: "button",
                class: _normalizeClass(["work-step", {
              active: isCollectionStep.value,
              todo: !hasNoBankbookData.value && collectionPendingCount.value > 0,
              done: !hasNoBankbookData.value && collectionPendingCount.value === 0,
              disabled: hasNoBankbookData.value
            }]),
                "data-tour": "bb-test-collection-tab",
                disabled: hasNoBankbookData.value,
                title: hasNoBankbookData.value ? '통장내역을 먼저 업로드해주세요' : '',
                onClick: _cache[4] || (_cache[4] = ($event: any) => (goStep('collection')))
              }, [
                _cache[115] || (_cache[115] = _createElementVNode("span", { class: "ws-num" }, "2", -1)),
                _createElementVNode("span", _hoisted_22, [
                  _cache[114] || (_cache[114] = _createElementVNode("span", { class: "ws-name" }, "수납", -1)),
                  (hasNoBankbookData.value)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_23, "-"))
                    : (collectionPendingCount.value === 0)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_24, "완료"))
                      : _createCommentVNode("", true)
                ])
              ], 10, _hoisted_21),
              _createElementVNode("button", {
                type: "button",
                class: _normalizeClass(["work-step", {
              active: isReceiptStep.value,
              todo: !hasNoBankbookData.value && receiptPendingCount.value > 0,
              done: !hasNoBankbookData.value && receiptPendingCount.value === 0,
              disabled: hasNoBankbookData.value
            }]),
                "data-tour": "bb-test-receipt-tab",
                disabled: hasNoBankbookData.value,
                title: hasNoBankbookData.value ? '통장내역을 먼저 업로드해주세요' : '',
                onClick: _cache[5] || (_cache[5] = ($event: any) => (goStep('receipt')))
              }, [
                _cache[117] || (_cache[117] = _createElementVNode("span", { class: "ws-num" }, "3", -1)),
                _createElementVNode("span", _hoisted_26, [
                  _cache[116] || (_cache[116] = _createElementVNode("span", { class: "ws-name" }, "영수증", -1)),
                  (hasNoBankbookData.value)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_27, "-"))
                    : (receiptPendingCount.value === 0)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_28, "완료"))
                      : _createCommentVNode("", true)
                ])
              ], 10, _hoisted_25),
              _createElementVNode("button", {
                type: "button",
                class: _normalizeClass(["work-step", {
              active: isAnalysisReferenceStep.value,
              disabled: hasNoBankbookData.value
            }]),
                "data-tour": "bb-test-analysis-tab",
                disabled: hasNoBankbookData.value,
                title: hasNoBankbookData.value ? '통장내역을 먼저 업로드해주세요' : '정리 내역 보기',
                onClick: _cache[6] || (_cache[6] = ($event: any) => (goStep('analysis-reference')))
              }, [...(_cache[118] || (_cache[118] = [
                _createElementVNode("span", { class: "ws-num" }, "4", -1),
                _createElementVNode("span", { class: "ws-body" }, [
                  _createElementVNode("span", { class: "ws-name" }, "정리 내역 보기")
                ], -1)
              ]))], 10, _hoisted_29)
            ])
          ]),
          _createElementVNode("div", _hoisted_30, [
            (!isReceiptStep.value && !isAnalysisReferenceStep.value)
              ? (_openBlock(), _createElementBlock("aside", _hoisted_31, [
                  _createElementVNode("div", _hoisted_32, [
                    _createVNode(_component_v_icon, { size: "14" }, {
                      default: _withCtx(() => [...(_cache[119] || (_cache[119] = [
                        _createTextVNode("mdi-book-open-page-variant", -1)
                      ]))]),
                      _: 1
                    }),
                    _createElementVNode("span", null, _toDisplayString(sidebarTitle.value), 1)
                  ]),
                  (showItemSidebarTools.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                        _createElementVNode("div", _hoisted_34, [
                          _createElementVNode("div", _hoisted_35, [
                            _createVNode(_component_v_icon, {
                              size: "14",
                              color: "#6366f1"
                            }, {
                              default: _withCtx(() => [...(_cache[120] || (_cache[120] = [
                                _createTextVNode("mdi-arrow-right-bold", -1)
                              ]))]),
                              _: 1
                            }),
                            _cache[121] || (_cache[121] = _createElementVNode("span", { class: "label" }, "이월금", -1))
                          ]),
                          _createElementVNode("span", _hoisted_36, _toDisplayString(formatNumber(prevMonthBalance.value)) + "원", 1)
                        ]),
                        _cache[125] || (_cache[125] = _createElementVNode("div", { class: "summary-divider" }, null, -1)),
                        _createElementVNode("div", _hoisted_37, [
                          _cache[122] || (_cache[122] = _createElementVNode("div", { class: "summary-header" }, [
                            _createElementVNode("span", { class: "dot" }),
                            _createElementVNode("span", { class: "label" }, "수입")
                          ], -1)),
                          _createElementVNode("span", _hoisted_38, _toDisplayString(formatNumber(summaryData.value.income)) + "원", 1)
                        ]),
                        _createElementVNode("div", _hoisted_39, [
                          _cache[123] || (_cache[123] = _createElementVNode("div", { class: "summary-header" }, [
                            _createElementVNode("span", { class: "dot" }),
                            _createElementVNode("span", { class: "label" }, "지출")
                          ], -1)),
                          _createElementVNode("span", _hoisted_40, _toDisplayString(formatNumber(summaryData.value.expense)) + "원", 1)
                        ]),
                        _cache[126] || (_cache[126] = _createElementVNode("div", { class: "summary-divider" }, null, -1)),
                        _createElementVNode("div", {
                          class: _normalizeClass(["summary-item balance", { warning: totalBalance.value < 0 }])
                        }, [
                          _createElementVNode("div", _hoisted_41, [
                            _createVNode(_component_v_icon, {
                              size: "14",
                              color: totalBalance.value >= 0 ? '#1e3a5f' : '#4b5563'
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(totalBalance.value >= 0 ? 'mdi-check-circle' : 'mdi-alert-circle-outline'), 1)
                              ]),
                              _: 1
                            }, 8, ["color"]),
                            _cache[124] || (_cache[124] = _createElementVNode("span", { class: "label" }, "누적잔액", -1))
                          ]),
                          _createElementVNode("span", _hoisted_42, _toDisplayString(formatNumber(totalBalance.value)) + "원", 1)
                        ], 2)
                      ]))
                    : _createCommentVNode("", true),
                  (showItemSidebarTools.value)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        type: "button",
                        class: _normalizeClass(["sidebar-labor-ratio", {
            met: laborRatioSummary.value.met,
            warn: laborRatioSummary.value.hasIncome && !laborRatioSummary.value.met,
            empty: !laborRatioSummary.value.hasIncome,
          }]),
                        "data-tour": "bb-test-labor",
                        title: laborRatioSummary.value.hint,
                        onClick: _cache[7] || (_cache[7] = ($event: any) => (laborRatioModalOpen.value = true))
                      }, [
                        _createElementVNode("div", _hoisted_44, [
                          _cache[127] || (_cache[127] = _createElementVNode("span", { class: "lr-title" }, "인건비비율", -1)),
                          (laborRatioSummary.value.cumulativeLabel)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_45, _toDisplayString(laborRatioSummary.value.cumulativeLabel), 1))
                            : _createCommentVNode("", true),
                          (laborRatioSummary.value.hasIncome)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_46, _toDisplayString(laborRatioSummary.value.met ? '충족' : '미충족'), 1))
                            : (_openBlock(), _createElementBlock("span", _hoisted_47, "계산불가"))
                        ]),
                        _createElementVNode("div", _hoisted_48, [
                          _createElementVNode("span", {
                            class: "lr-bar-fill",
                            style: _normalizeStyle({ width: laborRatioSummary.value.barPct + '%' })
                          }, null, 4)
                        ]),
                        _createElementVNode("div", _hoisted_49, [
                          (laborRatioSummary.value.hasIncome)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createElementVNode("span", _hoisted_50, _toDisplayString(laborRatioSummary.value.ratioText) + "%", 1),
                                _createElementVNode("span", _hoisted_51, "기준 " + _toDisplayString(laborRatioSummary.value.requiredText) + "%", 1)
                              ], 64))
                            : (_openBlock(), _createElementBlock("span", _hoisted_52, "인건비수입 없음"))
                        ])
                      ], 10, _hoisted_43))
                    : _createCommentVNode("", true),
                  (usesSharedLedger.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                        _createElementVNode("div", _hoisted_54, [
                          _createVNode(_component_v_icon, {
                            size: "14",
                            color: "#64748b"
                          }, {
                            default: _withCtx(() => [...(_cache[128] || (_cache[128] = [
                              _createTextVNode("mdi-filter-variant", -1)
                            ]))]),
                            _: 1
                          }),
                          _cache[129] || (_cache[129] = _createElementVNode("span", null, "조건", -1)),
                          (hasActiveLedgerConditions.value)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                type: "button",
                                class: "cond-reset",
                                title: "조건 초기화",
                                onClick: clearAllSearch
                              }, " 초기화 "))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_55, [
                          _cache[130] || (_cache[130] = _createElementVNode("span", { class: "cond-label" }, "보기", -1)),
                          _createElementVNode("div", _hoisted_56, [
                            _createElementVNode("button", {
                              type: "button",
                              class: _normalizeClass(["cond-opt", { on: ledgerDisplayMode.value === 'cashbook' }]),
                              onClick: _cache[8] || (_cache[8] = ($event: any) => (ledgerDisplayMode.value = 'cashbook'))
                            }, "현금출납부", 2),
                            _createElementVNode("button", {
                              type: "button",
                              class: _normalizeClass(["cond-opt", { on: ledgerDisplayMode.value === 'upload' }]),
                              onClick: _cache[9] || (_cache[9] = ($event: any) => (ledgerDisplayMode.value = 'upload'))
                            }, "통장 원본", 2)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_57, [
                          _cache[132] || (_cache[132] = _createElementVNode("span", { class: "cond-label" }, "범위", -1)),
                          _createElementVNode("div", _hoisted_58, [
                            _createElementVNode("button", {
                              type: "button",
                              class: _normalizeClass(["cond-opt", { on: !filterSplitOnly.value }]),
                              onClick: _cache[10] || (_cache[10] = ($event: any) => (filterSplitOnly.value = false))
                            }, "전체", 2),
                            _createElementVNode("button", {
                              type: "button",
                              class: _normalizeClass(["cond-opt", { on: filterSplitOnly.value }]),
                              onClick: _cache[11] || (_cache[11] = ($event: any) => (filterSplitOnly.value = true))
                            }, [
                              _cache[131] || (_cache[131] = _createTextVNode("분개만 ", -1)),
                              (splitFilterCount.value)
                                ? (_openBlock(), _createElementBlock("em", _hoisted_59, _toDisplayString(splitFilterCount.value), 1))
                                : _createCommentVNode("", true)
                            ], 2)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_60, [
                          _cache[136] || (_cache[136] = _createElementVNode("span", { class: "cond-label" }, "기간", -1)),
                          _createElementVNode("div", _hoisted_61, [
                            _withDirectives(_createElementVNode("input", {
                              type: "number",
                              class: "day-input",
                              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((filterDayStart).value = $event)),
                              min: 1,
                              max: filterDayEnd.value || lastDayOfMonth.value,
                              placeholder: "1"
                            }, null, 8, _hoisted_62), [
                              [
                                _vModelText,
                                filterDayStart.value,
                                void 0,
                                { number: true }
                              ]
                            ]),
                            _cache[133] || (_cache[133] = _createElementVNode("span", { class: "day-unit" }, "일", -1)),
                            _cache[134] || (_cache[134] = _createElementVNode("span", { class: "date-separator" }, "~", -1)),
                            _withDirectives(_createElementVNode("input", {
                              type: "number",
                              class: "day-input",
                              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((filterDayEnd).value = $event)),
                              min: filterDayStart.value || 1,
                              max: lastDayOfMonth.value,
                              placeholder: String(lastDayOfMonth.value)
                            }, null, 8, _hoisted_63), [
                              [
                                _vModelText,
                                filterDayEnd.value,
                                void 0,
                                { number: true }
                              ]
                            ]),
                            _cache[135] || (_cache[135] = _createElementVNode("span", { class: "day-unit" }, "일", -1))
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_64, [
                          _cache[138] || (_cache[138] = _createElementVNode("span", { class: "cond-label" }, "계정", -1)),
                          _createElementVNode("div", _hoisted_65, [
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              class: "search-input",
                              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((searchScode).value = $event)),
                              placeholder: "코드·이름"
                            }, null, 512), [
                              [_vModelText, searchScode.value]
                            ]),
                            (searchScode.value)
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  type: "button",
                                  class: "search-clear",
                                  onClick: _cache[15] || (_cache[15] = ($event: any) => (searchScode.value = ''))
                                }, [
                                  _createVNode(_component_v_icon, { size: "12" }, {
                                    default: _withCtx(() => [...(_cache[137] || (_cache[137] = [
                                      _createTextVNode("mdi-close", -1)
                                    ]))]),
                                    _: 1
                                  })
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_66, [
                          _cache[140] || (_cache[140] = _createElementVNode("span", { class: "cond-label" }, "적요", -1)),
                          _createElementVNode("div", _hoisted_67, [
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              class: "search-input",
                              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((searchMemo).value = $event)),
                              placeholder: "검색"
                            }, null, 512), [
                              [_vModelText, searchMemo.value]
                            ]),
                            (searchMemo.value)
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  type: "button",
                                  class: "search-clear",
                                  onClick: _cache[17] || (_cache[17] = ($event: any) => (searchMemo.value = ''))
                                }, [
                                  _createVNode(_component_v_icon, { size: "12" }, {
                                    default: _withCtx(() => [...(_cache[139] || (_cache[139] = [
                                      _createTextVNode("mdi-close", -1)
                                    ]))]),
                                    _: 1
                                  })
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (closingStatus.value?.isClosed && selectedBankCode.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
                        _createElementVNode("div", _hoisted_69, [
                          _cache[141] || (_cache[141] = _createElementVNode("span", null, "희망이음", -1)),
                          _createElementVNode("span", {
                            class: _normalizeClass(["closing-status-text", { 
              requested: heumieumStatus.value?.status === 'requested',
              closed: heumieumStatus.value?.status === 'completed' 
            }])
                          }, _toDisplayString(heumieumStatusText.value), 3)
                        ]),
                        (heumieumStatus.value?.requestAt)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
                              _createElementVNode("small", null, _toDisplayString(heumieumStatus.value.status === 'completed' ? '완료' : '요청') + ": " + _toDisplayString(formatClosingDate(heumieumStatus.value.requestAt)), 1)
                            ]))
                          : _createCommentVNode("", true),
                        (heumieumStatus.value?.completeMemo)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_71, [
                              _createElementVNode("small", null, _toDisplayString(heumieumStatus.value.completeMemo), 1)
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_72, [
                          (!heumieumStatus.value?.status)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                class: "closing-btn",
                                onClick: requestHeumieumUpload,
                                disabled: isRequestingHeumieum.value
                              }, " 업로드 요청 ", 8, _hoisted_73))
                            : _createCommentVNode("", true),
                          (heumieumStatus.value?.status === 'requested')
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 1,
                                class: "closing-btn secondary",
                                onClick: cancelHeumieumUpload,
                                disabled: isRequestingHeumieum.value
                              }, " 요청취소 ", 8, _hoisted_74))
                            : _createCommentVNode("", true),
                          (heumieumStatus.value?.status === 'completed')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_75, [...(_cache[142] || (_cache[142] = [
                                _createElementVNode("small", null, "업로드 완료", -1)
                              ]))]))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (workSection.value === 'raw' || isCollectionStep.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_76, [
                        _createElementVNode("div", _hoisted_77, [
                          _createVNode(_component_v_icon, {
                            size: "14",
                            color: "#64748b"
                          }, {
                            default: _withCtx(() => [...(_cache[143] || (_cache[143] = [
                              _createTextVNode("mdi-flash-outline", -1)
                            ]))]),
                            _: 1
                          }),
                          _cache[144] || (_cache[144] = _createElementVNode("span", null, "기능", -1))
                        ]),
                        (workSection.value === 'raw')
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createElementVNode("div", _hoisted_78, [
                                _cache[149] || (_cache[149] = _createElementVNode("div", { class: "sap-label" }, "자료", -1)),
                                _createElementVNode("div", _hoisted_79, [
                                  _createElementVNode("button", {
                                    type: "button",
                                    class: "sap-btn",
                                    "data-tour": "bb-test-upload-quick",
                                    onClick: openUploadDialog,
                                    disabled: isBankbookUploadDisabled.value,
                                    title: "통장내역 업로드"
                                  }, [
                                    _createVNode(_component_v_icon, { size: "14" }, {
                                      default: _withCtx(() => [...(_cache[145] || (_cache[145] = [
                                        _createTextVNode("mdi-upload", -1)
                                      ]))]),
                                      _: 1
                                    }),
                                    _cache[146] || (_cache[146] = _createElementVNode("span", null, "업로드", -1))
                                  ], 8, _hoisted_80),
                                  _createElementVNode("button", {
                                    type: "button",
                                    class: "sap-btn",
                                    "data-tour": "bb-test-settlement",
                                    onClick: _cache[18] || (_cache[18] = ($event: any) => (settlementModalOpen.value = true)),
                                    title: "세입·세출 결산 (예산/결산/증감)"
                                  }, [
                                    _createVNode(_component_v_icon, { size: "14" }, {
                                      default: _withCtx(() => [...(_cache[147] || (_cache[147] = [
                                        _createTextVNode("mdi-table-large", -1)
                                      ]))]),
                                      _: 1
                                    }),
                                    _cache[148] || (_cache[148] = _createElementVNode("span", null, "결산", -1))
                                  ])
                                ])
                              ]),
                              (!isConfirmed.value && !closingStatus.value?.isClosed && filteredCashbookList.value.length > 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_81, [
                                    _createElementVNode("button", {
                                      type: "button",
                                      class: "sap-btn danger",
                                      "data-tour": "bb-test-delete-all",
                                      onClick: _cache[19] || (_cache[19] = ($event: any) => (deleteAllDialogOpen.value = true)),
                                      title: `모두삭제 (${filteredCashbookList.value.length}건)`
                                    }, [
                                      _createVNode(_component_v_icon, { size: "14" }, {
                                        default: _withCtx(() => [...(_cache[150] || (_cache[150] = [
                                          _createTextVNode("mdi-delete-sweep", -1)
                                        ]))]),
                                        _: 1
                                      }),
                                      _createElementVNode("span", null, "모두삭제 " + _toDisplayString(filteredCashbookList.value.length) + "건", 1)
                                    ], 8, _hoisted_82)
                                  ]))
                                : _createCommentVNode("", true)
                            ], 64))
                          : (isCollectionStep.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_83, [
                                _cache[153] || (_cache[153] = _createElementVNode("div", { class: "sap-label" }, "수납", -1)),
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "sap-btn",
                                  "data-tour": "bb-test-collection-excel",
                                  onClick: _cache[20] || (_cache[20] = ($event: any) => (collectionExcelModalOpen.value = true)),
                                  disabled: isCollectionExcelDisabled.value,
                                  title: "수납관리 엑셀업로드"
                                }, [
                                  _createVNode(_component_v_icon, { size: "14" }, {
                                    default: _withCtx(() => [...(_cache[151] || (_cache[151] = [
                                      _createTextVNode("mdi-file-excel", -1)
                                    ]))]),
                                    _: 1
                                  }),
                                  _cache[152] || (_cache[152] = _createElementVNode("span", null, "엑셀", -1))
                                ], 8, _hoisted_84)
                              ]))
                            : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", {
                    class: _normalizeClass(["sidebar-month-memo", { open: monthMemoOpen.value, filled: !!monthMemoText.value.trim() }]),
                    "data-tour": "bb-test-memo"
                  }, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "month-memo-toggle",
                      onClick: _cache[21] || (_cache[21] = ($event: any) => (monthMemoOpen.value = !monthMemoOpen.value))
                    }, [
                      _createElementVNode("span", _hoisted_85, [
                        _createVNode(_component_v_icon, { size: "14" }, {
                          default: _withCtx(() => [...(_cache[154] || (_cache[154] = [
                            _createTextVNode("mdi-notebook-outline", -1)
                          ]))]),
                          _: 1
                        }),
                        _cache[155] || (_cache[155] = _createElementVNode("span", null, "이달의 메모", -1)),
                        (monthMemoText.value.trim())
                          ? (_openBlock(), _createElementBlock("em", _hoisted_86))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("span", _hoisted_87, [
                        (monthMemoSaveState.value === 'saving')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_88, "저장중"))
                          : (monthMemoSaveState.value === 'saved')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_89, "저장됨"))
                            : (monthMemoSaveState.value === 'error')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_90, "실패"))
                              : _createCommentVNode("", true),
                        _createVNode(_component_v_icon, { size: "16" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(monthMemoOpen.value ? 'mdi-chevron-down' : 'mdi-chevron-up'), 1)
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _withDirectives(_createElementVNode("div", _hoisted_91, [
                      _withDirectives(_createElementVNode("textarea", {
                        "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((monthMemoText).value = $event)),
                        class: "month-memo-input",
                        maxlength: "1000",
                        rows: "5",
                        placeholder: "이 달 작업 메모를 남겨두세요.",
                        disabled: isMonthMemoLoading.value || closingStatus.value?.isClosed,
                        onInput: onMonthMemoInput
                      }, null, 40, _hoisted_92), [
                        [_vModelText, monthMemoText.value]
                      ]),
                      _createElementVNode("div", _hoisted_93, [
                        _createElementVNode("span", _hoisted_94, _toDisplayString(monthMemoText.value.length) + "/1000", 1),
                        _createElementVNode("button", {
                          type: "button",
                          class: "month-memo-save",
                          disabled: isMonthMemoLoading.value || monthMemoSaveState.value === 'saving' || closingStatus.value?.isClosed,
                          onClick: saveMonthMemoNow
                        }, " 저장 ", 8, _hoisted_95)
                      ])
                    ], 512), [
                      [_vShow, monthMemoOpen.value]
                    ])
                  ], 2)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("main", {
              class: _normalizeClass(["cashbook-main-content", {
          'is-panel': workSection.value === 'raw' || isCollectionStep.value || isReceiptStep.value || isAnalysisReferenceStep.value,
          'has-shared-ledger': usesSharedLedger.value,
        }])
            }, [
              (usesSharedLedger.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_96, [
                    (showStartGuide.value)
                      ? (_openBlock(), _createElementBlock("section", _hoisted_97, [
                          _createElementVNode("div", _hoisted_98, [
                            _createElementVNode("div", _hoisted_99, [
                              _createVNode(_component_v_icon, { size: "34" }, {
                                default: _withCtx(() => [...(_cache[156] || (_cache[156] = [
                                  _createTextVNode("mdi-notebook-edit-outline", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _cache[157] || (_cache[157] = _createElementVNode("p", { class: "sg-title" }, "통장내역 정리를 시작해 볼까요?", -1)),
                            _createElementVNode("p", _hoisted_100, _toDisplayString(currentYear.value) + "년 " + _toDisplayString(currentMonth.value) + "월 · 통장을 등록하고 거래내역을 올리면 시작됩니다", 1)
                          ]),
                          _cache[174] || (_cache[174] = _createStaticVNode("<div class=\"sg-desc\"><div class=\"sg-desc-row\"><span class=\"sg-desc-label\">목적</span><p>수납·영수증·마감·회계보고서의 기준이 되는 수입·지출 원장 만들기</p></div><div class=\"sg-desc-row\"><span class=\"sg-desc-label\">준비물</span><p>통장 등록 · 은행 거래내역 파일(엑셀·CSV)</p></div><div class=\"sg-desc-row\"><span class=\"sg-desc-label\">쓰이는 곳</span><p>수납(본인부담금) · 영수증 매칭 · 이 달 마감 · 회계보고서</p></div></div>", 1)),
                          _createElementVNode("ol", _hoisted_101, [
                            _createElementVNode("li", {
                              class: _normalizeClass({ done: bankList.value.length > 0, current: bankList.value.length === 0 })
                            }, [
                              _cache[163] || (_cache[163] = _createElementVNode("span", { class: "sg-step-num" }, "1", -1)),
                              _createElementVNode("div", _hoisted_102, [
                                _createVNode(_component_v_icon, { size: "26" }, {
                                  default: _withCtx(() => [...(_cache[158] || (_cache[158] = [
                                    _createTextVNode("mdi-bank-outline", -1)
                                  ]))]),
                                  _: 1
                                })
                              ]),
                              _cache[164] || (_cache[164] = _createElementVNode("strong", null, "통장 등록", -1)),
                              _cache[165] || (_cache[165] = _createElementVNode("p", null, "시설에서 사용하는 통장을 먼저 등록합니다", -1)),
                              (bankList.value.length === 0)
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    type: "button",
                                    class: "sg-btn",
                                    onClick: openBankManageDialog
                                  }, [
                                    _createVNode(_component_v_icon, { size: "15" }, {
                                      default: _withCtx(() => [...(_cache[159] || (_cache[159] = [
                                        _createTextVNode("mdi-cog-outline", -1)
                                      ]))]),
                                      _: 1
                                    }),
                                    _cache[160] || (_cache[160] = _createTextVNode(" 통장 관리 열기 ", -1))
                                  ]))
                                : (_openBlock(), _createElementBlock("span", _hoisted_103, [
                                    _createVNode(_component_v_icon, { size: "15" }, {
                                      default: _withCtx(() => [...(_cache[161] || (_cache[161] = [
                                        _createTextVNode("mdi-check-circle", -1)
                                      ]))]),
                                      _: 1
                                    }),
                                    _cache[162] || (_cache[162] = _createTextVNode(" 등록 완료 ", -1))
                                  ]))
                            ], 2),
                            _createElementVNode("li", {
                              class: _normalizeClass({ current: bankList.value.length > 0, dim: bankList.value.length === 0 })
                            }, [
                              _cache[169] || (_cache[169] = _createElementVNode("span", { class: "sg-step-num" }, "2", -1)),
                              _createElementVNode("div", _hoisted_104, [
                                _createVNode(_component_v_icon, { size: "26" }, {
                                  default: _withCtx(() => [...(_cache[166] || (_cache[166] = [
                                    _createTextVNode("mdi-upload-outline", -1)
                                  ]))]),
                                  _: 1
                                })
                              ]),
                              _cache[170] || (_cache[170] = _createElementVNode("strong", null, "통장내역 업로드", -1)),
                              _cache[171] || (_cache[171] = _createElementVNode("p", null, "은행 거래내역 엑셀·CSV를 올리거나 직접 입력합니다", -1)),
                              (bankList.value.length > 0)
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    type: "button",
                                    class: "sg-btn primary",
                                    disabled: isBankbookUploadDisabled.value,
                                    onClick: openUploadDialog
                                  }, [
                                    _createVNode(_component_v_icon, { size: "15" }, {
                                      default: _withCtx(() => [...(_cache[167] || (_cache[167] = [
                                        _createTextVNode("mdi-upload", -1)
                                      ]))]),
                                      _: 1
                                    }),
                                    _cache[168] || (_cache[168] = _createTextVNode(" 통장내역 업로드 ", -1))
                                  ], 8, _hoisted_105))
                                : _createCommentVNode("", true)
                            ], 2)
                          ]),
                          _createElementVNode("p", _hoisted_106, [
                            _createVNode(_component_v_icon, { size: "14" }, {
                              default: _withCtx(() => [...(_cache[172] || (_cache[172] = [
                                _createTextVNode("mdi-information-outline", -1)
                              ]))]),
                              _: 1
                            }),
                            _cache[173] || (_cache[173] = _createTextVNode(" 업로드가 끝나면 이어서 계정 지정 → 수납·영수증 정리 → 마감 순으로 진행됩니다 ", -1))
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _withDirectives(_createElementVNode("section", _hoisted_107, [
                      _createElementVNode("div", _hoisted_108, [
                        _createElementVNode("button", {
                          type: "button",
                          class: _normalizeClass(["sl-tab is-in", { on: ledgerListTab.value === 'in' }]),
                          onClick: _cache[23] || (_cache[23] = ($event: any) => (setLedgerListTab('in')))
                        }, [
                          _cache[175] || (_cache[175] = _createTextVNode(" 수입 ", -1)),
                          (ledgerTabInBadge.value)
                            ? (_openBlock(), _createElementBlock("em", _hoisted_109, _toDisplayString(ledgerTabInBadge.value), 1))
                            : _createCommentVNode("", true)
                        ], 2),
                        _createElementVNode("button", {
                          type: "button",
                          class: _normalizeClass(["sl-tab is-out", { on: ledgerListTab.value === 'out' }]),
                          onClick: _cache[24] || (_cache[24] = ($event: any) => (setLedgerListTab('out')))
                        }, [
                          _cache[176] || (_cache[176] = _createTextVNode(" 지출 ", -1)),
                          (ledgerTabOutBadge.value)
                            ? (_openBlock(), _createElementBlock("em", _hoisted_110, _toDisplayString(ledgerTabOutBadge.value), 1))
                            : _createCommentVNode("", true)
                        ], 2)
                      ]),
                      (sharedLedgerRows.value.length === 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_111, [
                            _createVNode(_component_v_icon, {
                              size: "40",
                              color: "#94a3b8"
                            }, {
                              default: _withCtx(() => [...(_cache[177] || (_cache[177] = [
                                _createTextVNode("mdi-inbox-outline", -1)
                              ]))]),
                              _: 1
                            }),
                            _createElementVNode("p", null, _toDisplayString(sharedLedgerEmptyMessage.value), 1)
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_112, [
                            _createElementVNode("table", _hoisted_113, [
                              _createElementVNode("thead", null, [
                                _createElementVNode("tr", null, [
                                  _createElementVNode("th", _hoisted_114, [
                                    _createElementVNode("button", {
                                      type: "button",
                                      class: _normalizeClass(["row-check header-check", {
                          on: isAllVisibleLedgerSelected.value,
                          partial: isSomeVisibleLedgerSelected.value && !isAllVisibleLedgerSelected.value,
                        }]),
                                      disabled: !selectableVisibleLedgerIds.value.length,
                                      title: isAllVisibleLedgerSelected.value ? '선택 해제' : '모두 선택',
                                      "aria-label": isAllVisibleLedgerSelected.value ? '선택 해제' : '모두 선택',
                                      onClick: _withModifiers(toggleSelectAllVisibleLedger, ["stop"])
                                    }, [
                                      _createVNode(_component_v_icon, { size: "14" }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(isAllVisibleLedgerSelected.value
                              ? 'mdi-checkbox-marked'
                              : isSomeVisibleLedgerSelected.value
                                ? 'mdi-minus-box'
                                : 'mdi-checkbox-blank-outline'), 1)
                                        ]),
                                        _: 1
                                      })
                                    ], 10, _hoisted_115)
                                  ]),
                                  _createElementVNode("th", {
                                    class: _normalizeClass(["th-date sortable", { on: sortKey.value === 'cb_order' }]),
                                    onClick: _cache[25] || (_cache[25] = ($event: any) => (toggleSort('cb_order')))
                                  }, [
                                    _cache[178] || (_cache[178] = _createTextVNode(" 날짜 ", -1)),
                                    _createVNode(_component_v_icon, {
                                      size: "14",
                                      class: "sort-icon"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(getSortIcon('cb_order')), 1)
                                      ]),
                                      _: 1
                                    })
                                  ], 2),
                                  _cache[183] || (_cache[183] = _createElementVNode("th", { class: "th-gubun" }, "구분", -1)),
                                  _createElementVNode("th", {
                                    class: _normalizeClass(["th-memo sortable", { on: sortKey.value === 'cb_memo' }]),
                                    onClick: _cache[26] || (_cache[26] = ($event: any) => (toggleSort('cb_memo')))
                                  }, [
                                    _cache[179] || (_cache[179] = _createTextVNode(" 적요 ", -1)),
                                    _createVNode(_component_v_icon, {
                                      size: "14",
                                      class: "sort-icon"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(getSortIcon('cb_memo')), 1)
                                      ]),
                                      _: 1
                                    })
                                  ], 2),
                                  _createElementVNode("th", {
                                    class: _normalizeClass(["th-price sortable", { on: sortKey.value === 'cb_price' }]),
                                    onClick: _cache[27] || (_cache[27] = ($event: any) => (toggleSort('cb_price')))
                                  }, [
                                    _cache[180] || (_cache[180] = _createTextVNode(" 금액 ", -1)),
                                    _createVNode(_component_v_icon, {
                                      size: "14",
                                      class: "sort-icon"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(getSortIcon('cb_price')), 1)
                                      ]),
                                      _: 1
                                    })
                                  ], 2),
                                  _createElementVNode("th", {
                                    class: _normalizeClass(["th-scode sortable", { on: sortKey.value === 'cb_scode' }]),
                                    onClick: _cache[28] || (_cache[28] = ($event: any) => (toggleSort('cb_scode')))
                                  }, [
                                    _cache[181] || (_cache[181] = _createTextVNode(" 계정 ", -1)),
                                    _createVNode(_component_v_icon, {
                                      size: "14",
                                      class: "sort-icon"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(getSortIcon('cb_scode')), 1)
                                      ]),
                                      _: 1
                                    })
                                  ], 2),
                                  _createElementVNode("th", {
                                    class: _normalizeClass(["th-rel-acc sortable", { on: sortKey.value === 'cb_rel_acc' }]),
                                    onClick: _cache[29] || (_cache[29] = ($event: any) => (toggleSort('cb_rel_acc')))
                                  }, [
                                    _createTextVNode(_toDisplayString(ledgerListTab.value === 'in' ? '수급자' : '상대계정') + " ", 1),
                                    _createVNode(_component_v_icon, {
                                      size: "14",
                                      class: "sort-icon"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(getSortIcon('cb_rel_acc')), 1)
                                      ]),
                                      _: 1
                                    })
                                  ], 2),
                                  _createElementVNode("th", {
                                    class: _normalizeClass(["th-funding sortable", { on: sortKey.value === 'cb_funding' }]),
                                    onClick: _cache[30] || (_cache[30] = ($event: any) => (toggleSort('cb_funding')))
                                  }, [
                                    _cache[182] || (_cache[182] = _createTextVNode(" 자금원천 ", -1)),
                                    _createVNode(_component_v_icon, {
                                      size: "14",
                                      class: "sort-icon"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(getSortIcon('cb_funding')), 1)
                                      ]),
                                      _: 1
                                    })
                                  ], 2),
                                  (selectedBankCode.value === null)
                                    ? (_openBlock(), _createElementBlock("th", _hoisted_116, "통장"))
                                    : _createCommentVNode("", true)
                                ])
                              ]),
                              _createElementVNode("tbody", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sharedLedgerRows.value, (row) => {
                                  return (_openBlock(), _createElementBlock(_Fragment, {
                                    key: row.key
                                  }, [
                                    (row.kind === 'item')
                                      ? (_openBlock(), _createElementBlock("tr", {
                                          key: 0,
                                          class: _normalizeClass({
                        'row-picked': isSharedRowPicked(row.item),
                        'row-closed': !isItemEditable(row.item),
                        'is-clickable': true,
                      }),
                                          onClick: ($event: any) => (onSharedLedgerClick(row.item))
                                        }, [
                                          _createElementVNode("td", {
                                            class: "td-check",
                                            onClick: _withModifiers(($event: any) => (onSharedLedgerClick(row.item)), ["stop"])
                                          }, [
                                            _createElementVNode("span", {
                                              class: _normalizeClass(["row-check", {
                            on: isSharedRowPicked(row.item),
                            disabled: !isItemEditable(row.item),
                          }]),
                                              "aria-hidden": "true"
                                            }, [
                                              _createVNode(_component_v_icon, { size: "14" }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(isSharedRowPicked(row.item) ? 'mdi-checkbox-marked' : 'mdi-checkbox-blank-outline'), 1)
                                                ]),
                                                _: 2
                                              }, 1024)
                                            ], 2)
                                          ], 8, _hoisted_118),
                                          _createElementVNode("td", _hoisted_119, _toDisplayString(formatDate(row.item.cb_date)), 1),
                                          _createElementVNode("td", _hoisted_120, [
                                            _createElementVNode("span", {
                                              class: _normalizeClass(["gubun-badge", row.item.cb_gubun === 'IN' ? 'income' : 'expense'])
                                            }, _toDisplayString(row.item.cb_gubun === 'IN' ? '수입' : '지출'), 3)
                                          ]),
                                          _createElementVNode("td", _hoisted_121, [
                                            _createElementVNode("div", _hoisted_122, [
                                              (row.item.cb_memo && row.item.cb_memo.trim())
                                                ? (_openBlock(), _createElementBlock("span", {
                                                    key: 0,
                                                    class: "memo-text",
                                                    title: row.item.cb_memo
                                                  }, _toDisplayString(row.item.cb_memo), 9, _hoisted_123))
                                                : (_openBlock(), _createElementBlock("span", _hoisted_124, [
                                                    _createVNode(_component_v_icon, {
                                                      size: "14",
                                                      color: "#ca8a04"
                                                    }, {
                                                      default: _withCtx(() => [...(_cache[184] || (_cache[184] = [
                                                        _createTextVNode("mdi-alert", -1)
                                                      ]))]),
                                                      _: 1
                                                    }),
                                                    _cache[185] || (_cache[185] = _createTextVNode(" 미설정 ", -1))
                                                  ]))
                                            ])
                                          ]),
                                          _createElementVNode("td", {
                                            class: _normalizeClass(["td-price", row.item.cb_gubun === 'IN' ? 'income' : 'expense'])
                                          }, _toDisplayString(formatNumber(row.item.cb_price)) + "원 ", 3),
                                          _createElementVNode("td", _hoisted_125, [
                                            (hasLedgerScode(row.item))
                                              ? (_openBlock(), _createElementBlock("span", {
                                                  key: 0,
                                                  class: _normalizeClass(["scode-name", row.item.cb_gubun === 'IN' ? 'is-in' : 'is-out'])
                                                }, _toDisplayString(ledgerScodeLabel(row.item)), 3))
                                              : (_openBlock(), _createElementBlock("span", _hoisted_126, [
                                                  _createVNode(_component_v_icon, {
                                                    size: "14",
                                                    color: "#ca8a04"
                                                  }, {
                                                    default: _withCtx(() => [...(_cache[186] || (_cache[186] = [
                                                      _createTextVNode("mdi-alert", -1)
                                                    ]))]),
                                                    _: 1
                                                  }),
                                                  _cache[187] || (_cache[187] = _createTextVNode(" 미설정 ", -1))
                                                ]))
                                          ]),
                                          _createElementVNode("td", {
                                            class: "td-rel-acc",
                                            onClick: _cache[31] || (_cache[31] = _withModifiers(() => {}, ["stop"]))
                                          }, [
                                            (row.item.cb_gubun === 'OUT')
                                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                  (hasLedgerRel(row.item))
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_127, _toDisplayString(ledgerRelLabel(row.item)), 1))
                                                    : (_openBlock(), _createElementBlock("span", _hoisted_128, [
                                                        _createVNode(_component_v_icon, {
                                                          size: "14",
                                                          color: "#ca8a04"
                                                        }, {
                                                          default: _withCtx(() => [...(_cache[188] || (_cache[188] = [
                                                            _createTextVNode("mdi-alert", -1)
                                                          ]))]),
                                                          _: 1
                                                        }),
                                                        _cache[189] || (_cache[189] = _createTextVNode(" 미설정 ", -1))
                                                      ]))
                                                ], 64))
                                              : (isCollectionTarget(row.item) && row.item.cb_idx)
                                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                    (beneficiaryMatches.value[row.item.cb_idx])
                                                      ? (_openBlock(), _createBlock(_component_v_menu, {
                                                          key: 0,
                                                          location: "bottom start",
                                                          "close-on-content-click": true
                                                        }, {
                                                          activator: _withCtx(({ props: menuProps }) => [
                                                            _createElementVNode("button", _mergeProps({ type: "button" }, { ref_for: true }, menuProps, {
                                                              class: "ben-match-link matched",
                                                              title: `${beneficiaryMatches.value[row.item.cb_idx]?.cb_name} · 수급자 옵션`
                                                            }), [
                                                              _createElementVNode("span", _hoisted_130, _toDisplayString(beneficiaryMatches.value[row.item.cb_idx]?.cb_name), 1)
                                                            ], 16, _hoisted_129)
                                                          ]),
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_v_list, {
                                                              density: "compact",
                                                              class: "ben-match-menu"
                                                            }, {
                                                              default: _withCtx(() => [
                                                                _createVNode(_component_v_list_item, {
                                                                  onClick: ($event: any) => (openCollectionForBeneficiary(beneficiaryMatches.value[row.item.cb_idx]?.cb_name || ''))
                                                                }, {
                                                                  prepend: _withCtx(() => [
                                                                    _createVNode(_component_v_icon, {
                                                                      size: "18",
                                                                      color: "#0d9488"
                                                                    }, {
                                                                      default: _withCtx(() => [...(_cache[190] || (_cache[190] = [
                                                                        _createTextVNode("mdi-cash-register", -1)
                                                                      ]))]),
                                                                      _: 1
                                                                    })
                                                                  ]),
                                                                  default: _withCtx(() => [
                                                                    _createVNode(_component_v_list_item_title, null, {
                                                                      default: _withCtx(() => [...(_cache[191] || (_cache[191] = [
                                                                        _createTextVNode("수납 탭에서 보기", -1)
                                                                      ]))]),
                                                                      _: 1
                                                                    })
                                                                  ]),
                                                                  _: 1
                                                                }, 8, ["onClick"]),
                                                                _createVNode(_component_v_list_item, {
                                                                  onClick: ($event: any) => (changeBeneficiaryMatch(row.item))
                                                                }, {
                                                                  prepend: _withCtx(() => [
                                                                    _createVNode(_component_v_icon, {
                                                                      size: "18",
                                                                      color: "#1565c0"
                                                                    }, {
                                                                      default: _withCtx(() => [...(_cache[192] || (_cache[192] = [
                                                                        _createTextVNode("mdi-account-switch", -1)
                                                                      ]))]),
                                                                      _: 1
                                                                    })
                                                                  ]),
                                                                  default: _withCtx(() => [
                                                                    _createVNode(_component_v_list_item_title, null, {
                                                                      default: _withCtx(() => [...(_cache[193] || (_cache[193] = [
                                                                        _createTextVNode("수급자 변경", -1)
                                                                      ]))]),
                                                                      _: 1
                                                                    })
                                                                  ]),
                                                                  _: 1
                                                                }, 8, ["onClick"]),
                                                                _createVNode(_component_v_list_item, {
                                                                  onClick: ($event: any) => (removeBeneficiaryMatch(row.item))
                                                                }, {
                                                                  prepend: _withCtx(() => [
                                                                    _createVNode(_component_v_icon, {
                                                                      size: "18",
                                                                      color: "#c62828"
                                                                    }, {
                                                                      default: _withCtx(() => [...(_cache[194] || (_cache[194] = [
                                                                        _createTextVNode("mdi-link-off", -1)
                                                                      ]))]),
                                                                      _: 1
                                                                    })
                                                                  ]),
                                                                  default: _withCtx(() => [
                                                                    _createVNode(_component_v_list_item_title, null, {
                                                                      default: _withCtx(() => [...(_cache[195] || (_cache[195] = [
                                                                        _createTextVNode("매칭 해제", -1)
                                                                      ]))]),
                                                                      _: 1
                                                                    })
                                                                  ]),
                                                                  _: 1
                                                                }, 8, ["onClick"])
                                                              ]),
                                                              _: 2
                                                            }, 1024)
                                                          ]),
                                                          _: 2
                                                        }, 1024))
                                                      : (_openBlock(), _createElementBlock("button", {
                                                          key: 1,
                                                          type: "button",
                                                          class: "ben-match-link need",
                                                          title: "수급자가 아직 지정되지 않았습니다. 클릭하여 지정",
                                                          onClick: ($event: any) => (openBeneficiaryMatchPopover(row.item))
                                                        }, [...(_cache[196] || (_cache[196] = [
                                                          _createElementVNode("span", { class: "ben-match-name" }, "미연결", -1)
                                                        ]))], 8, _hoisted_131))
                                                  ], 64))
                                                : (_openBlock(), _createElementBlock("span", _hoisted_132, "-"))
                                          ]),
                                          _createElementVNode("td", _hoisted_133, [
                                            (row.item.cb_funding)
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_134, _toDisplayString(getFundingName(row.item.cb_funding)), 1))
                                              : (_openBlock(), _createElementBlock("span", _hoisted_135, [
                                                  _createVNode(_component_v_icon, {
                                                    size: "14",
                                                    color: "#ca8a04"
                                                  }, {
                                                    default: _withCtx(() => [...(_cache[197] || (_cache[197] = [
                                                      _createTextVNode("mdi-alert", -1)
                                                    ]))]),
                                                    _: 1
                                                  }),
                                                  _cache[198] || (_cache[198] = _createTextVNode(" 미설정 ", -1))
                                                ]))
                                          ]),
                                          (selectedBankCode.value === null)
                                            ? (_openBlock(), _createElementBlock("td", _hoisted_136, [
                                                _createElementVNode("span", _hoisted_137, _toDisplayString(getBankAlias(row.item.cb_bank_code)), 1)
                                              ]))
                                            : _createCommentVNode("", true)
                                        ], 10, _hoisted_117))
                                      : (row.kind === 'group')
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                            _createElementVNode("tr", {
                                              class: _normalizeClass(["row-split-group is-clickable", {
                          'row-picked': isSharedGroupPicked(row.group),
                          expanded: isSplitGroupExpanded(row.group.parentIdx),
                        }]),
                                              onClick: ($event: any) => (onSharedGroupClick(row.group))
                                            }, [
                                              _createElementVNode("td", {
                                                class: "td-check",
                                                onClick: _withModifiers(($event: any) => (onSharedGroupClick(row.group)), ["stop"])
                                              }, [
                                                _createElementVNode("span", {
                                                  class: _normalizeClass(["row-check", { on: isSharedGroupPicked(row.group) }]),
                                                  "aria-hidden": "true"
                                                }, [
                                                  _createVNode(_component_v_icon, { size: "14" }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode(_toDisplayString(isSharedGroupPicked(row.group) ? 'mdi-checkbox-marked' : 'mdi-checkbox-blank-outline'), 1)
                                                    ]),
                                                    _: 2
                                                  }, 1024)
                                                ], 2)
                                              ], 8, _hoisted_139),
                                              _createElementVNode("td", _hoisted_140, [
                                                _createElementVNode("button", {
                                                  type: "button",
                                                  class: _normalizeClass(["split-expand-btn", { open: isSplitGroupExpanded(row.group.parentIdx) }]),
                                                  title: isSplitGroupExpanded(row.group.parentIdx) ? '분개 접기' : '분개 펼치기',
                                                  onClick: _withModifiers(($event: any) => (toggleSplitGroup(row.group.parentIdx)), ["stop"])
                                                }, [
                                                  _createVNode(_component_v_icon, { size: "18" }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode(_toDisplayString(isSplitGroupExpanded(row.group.parentIdx) ? 'mdi-chevron-down' : 'mdi-chevron-right'), 1)
                                                    ]),
                                                    _: 2
                                                  }, 1024),
                                                  _createElementVNode("span", _hoisted_142, " 분개 " + _toDisplayString(row.group.children.length), 1)
                                                ], 10, _hoisted_141),
                                                _createElementVNode("span", _hoisted_143, _toDisplayString(formatDate(row.group.cb_date)), 1)
                                              ]),
                                              _createElementVNode("td", _hoisted_144, [
                                                _createElementVNode("span", {
                                                  class: _normalizeClass(["gubun-badge", row.group.cb_gubun === 'IN' ? 'income' : 'expense'])
                                                }, _toDisplayString(row.group.cb_gubun === 'IN' ? '수입' : '지출'), 3)
                                              ]),
                                              _createElementVNode("td", _hoisted_145, [
                                                _createElementVNode("div", _hoisted_146, [
                                                  (row.group.cb_memo && row.group.cb_memo.trim())
                                                    ? (_openBlock(), _createElementBlock("span", {
                                                        key: 0,
                                                        class: "memo-text",
                                                        title: row.group.cb_memo
                                                      }, _toDisplayString(row.group.cb_memo), 9, _hoisted_147))
                                                    : (_openBlock(), _createElementBlock("span", _hoisted_148, [
                                                        _createVNode(_component_v_icon, {
                                                          size: "14",
                                                          color: "#ca8a04"
                                                        }, {
                                                          default: _withCtx(() => [...(_cache[199] || (_cache[199] = [
                                                            _createTextVNode("mdi-alert", -1)
                                                          ]))]),
                                                          _: 1
                                                        }),
                                                        _cache[200] || (_cache[200] = _createTextVNode(" 미설정 ", -1))
                                                      ]))
                                                ])
                                              ]),
                                              _createElementVNode("td", {
                                                class: _normalizeClass(["td-price", row.group.cb_gubun === 'IN' ? 'income' : 'expense'])
                                              }, _toDisplayString(formatNumber(row.group.cb_price)) + "원 ", 3),
                                              _createElementVNode("td", _hoisted_149, [
                                                _createElementVNode("button", {
                                                  type: "button",
                                                  class: _normalizeClass(["split-expand-link", { open: isSplitGroupExpanded(row.group.parentIdx) }]),
                                                  onClick: _withModifiers(($event: any) => (toggleSplitGroup(row.group.parentIdx)), ["stop"])
                                                }, _toDisplayString(isSplitGroupExpanded(row.group.parentIdx) ? '접기' : '펼치기'), 11, _hoisted_150)
                                              ]),
                                              _cache[203] || (_cache[203] = _createElementVNode("td", { class: "td-rel-acc" }, [
                                                _createElementVNode("span", { class: "rel-acc-na" }, "-")
                                              ], -1)),
                                              _createElementVNode("td", _hoisted_151, [
                                                (row.group.cb_funding)
                                                  ? (_openBlock(), _createElementBlock("span", _hoisted_152, _toDisplayString(getFundingName(row.group.cb_funding)), 1))
                                                  : (_openBlock(), _createElementBlock("span", _hoisted_153, [
                                                      _createVNode(_component_v_icon, {
                                                        size: "14",
                                                        color: "#ca8a04"
                                                      }, {
                                                        default: _withCtx(() => [...(_cache[201] || (_cache[201] = [
                                                          _createTextVNode("mdi-alert", -1)
                                                        ]))]),
                                                        _: 1
                                                      }),
                                                      _cache[202] || (_cache[202] = _createTextVNode(" 미설정 ", -1))
                                                    ]))
                                              ]),
                                              (selectedBankCode.value === null)
                                                ? (_openBlock(), _createElementBlock("td", _hoisted_154, [
                                                    _createElementVNode("span", _hoisted_155, _toDisplayString(getBankAlias(row.group.cb_bank_code)), 1)
                                                  ]))
                                                : _createCommentVNode("", true)
                                            ], 10, _hoisted_138),
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((isSplitGroupExpanded(row.group.parentIdx) ? row.group.children : []), (child) => {
                                              return (_openBlock(), _createElementBlock("tr", {
                                                key: `split-child-${child.cb_idx}`,
                                                class: _normalizeClass(["row-split-detail is-clickable", {
                          'row-picked': isSharedRowPicked(child),
                          'row-closed': !isItemEditable(child),
                        }]),
                                                onClick: ($event: any) => (onSharedLedgerClick(child))
                                              }, [
                                                _createElementVNode("td", {
                                                  class: "td-check",
                                                  onClick: _withModifiers(($event: any) => (onSharedLedgerClick(child)), ["stop"])
                                                }, [
                                                  _createElementVNode("span", {
                                                    class: _normalizeClass(["row-check", {
                              on: isSharedRowPicked(child),
                              disabled: !isItemEditable(child),
                            }]),
                                                    "aria-hidden": "true"
                                                  }, [
                                                    _createVNode(_component_v_icon, { size: "14" }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(isSharedRowPicked(child) ? 'mdi-checkbox-marked' : 'mdi-checkbox-blank-outline'), 1)
                                                      ]),
                                                      _: 2
                                                    }, 1024)
                                                  ], 2)
                                                ], 8, _hoisted_157),
                                                _cache[219] || (_cache[219] = _createElementVNode("td", { class: "td-date" }, [
                                                  _createElementVNode("span", { class: "detail-indent" }, "└")
                                                ], -1)),
                                                _createElementVNode("td", _hoisted_158, [
                                                  _createElementVNode("span", {
                                                    class: _normalizeClass(["gubun-badge", child.cb_gubun === 'IN' ? 'income' : 'expense'])
                                                  }, _toDisplayString(child.cb_gubun === 'IN' ? '수입' : '지출'), 3)
                                                ]),
                                                _createElementVNode("td", _hoisted_159, [
                                                  _createElementVNode("div", _hoisted_160, [
                                                    (child.cb_memo && child.cb_memo.trim())
                                                      ? (_openBlock(), _createElementBlock("span", {
                                                          key: 0,
                                                          class: "memo-text",
                                                          title: child.cb_memo
                                                        }, _toDisplayString(child.cb_memo), 9, _hoisted_161))
                                                      : (_openBlock(), _createElementBlock("span", _hoisted_162, [
                                                          _createVNode(_component_v_icon, {
                                                            size: "14",
                                                            color: "#ca8a04"
                                                          }, {
                                                            default: _withCtx(() => [...(_cache[204] || (_cache[204] = [
                                                              _createTextVNode("mdi-alert", -1)
                                                            ]))]),
                                                            _: 1
                                                          }),
                                                          _cache[205] || (_cache[205] = _createTextVNode(" 미설정 ", -1))
                                                        ]))
                                                  ])
                                                ]),
                                                _createElementVNode("td", {
                                                  class: _normalizeClass(["td-price", child.cb_gubun === 'IN' ? 'income' : 'expense'])
                                                }, _toDisplayString(formatNumber(child.cb_price)) + "원 ", 3),
                                                _createElementVNode("td", _hoisted_163, [
                                                  (hasLedgerScode(child))
                                                    ? (_openBlock(), _createElementBlock("span", {
                                                        key: 0,
                                                        class: _normalizeClass(["scode-name", child.cb_gubun === 'IN' ? 'is-in' : 'is-out'])
                                                      }, _toDisplayString(ledgerScodeLabel(child)), 3))
                                                    : (_openBlock(), _createElementBlock("span", _hoisted_164, [
                                                        _createVNode(_component_v_icon, {
                                                          size: "14",
                                                          color: "#ca8a04"
                                                        }, {
                                                          default: _withCtx(() => [...(_cache[206] || (_cache[206] = [
                                                            _createTextVNode("mdi-alert", -1)
                                                          ]))]),
                                                          _: 1
                                                        }),
                                                        _cache[207] || (_cache[207] = _createTextVNode(" 미설정 ", -1))
                                                      ]))
                                                ]),
                                                _createElementVNode("td", {
                                                  class: "td-rel-acc",
                                                  onClick: _cache[32] || (_cache[32] = _withModifiers(() => {}, ["stop"]))
                                                }, [
                                                  (child.cb_gubun === 'OUT')
                                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                        (hasLedgerRel(child))
                                                          ? (_openBlock(), _createElementBlock("span", _hoisted_165, _toDisplayString(ledgerRelLabel(child)), 1))
                                                          : (_openBlock(), _createElementBlock("span", _hoisted_166, [
                                                              _createVNode(_component_v_icon, {
                                                                size: "14",
                                                                color: "#ca8a04"
                                                              }, {
                                                                default: _withCtx(() => [...(_cache[208] || (_cache[208] = [
                                                                  _createTextVNode("mdi-alert", -1)
                                                                ]))]),
                                                                _: 1
                                                              }),
                                                              _cache[209] || (_cache[209] = _createTextVNode(" 미설정 ", -1))
                                                            ]))
                                                      ], 64))
                                                    : (isCollectionTarget(child) && child.cb_idx)
                                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                          (beneficiaryMatches.value[child.cb_idx])
                                                            ? (_openBlock(), _createBlock(_component_v_menu, {
                                                                key: 0,
                                                                location: "bottom start",
                                                                "close-on-content-click": true
                                                              }, {
                                                                activator: _withCtx(({ props: menuProps }) => [
                                                                  _createElementVNode("button", _mergeProps({ type: "button" }, { ref_for: true }, menuProps, {
                                                                    class: "ben-match-link matched",
                                                                    title: `${beneficiaryMatches.value[child.cb_idx]?.cb_name} · 수급자 옵션`
                                                                  }), [
                                                                    _createElementVNode("span", _hoisted_168, _toDisplayString(beneficiaryMatches.value[child.cb_idx]?.cb_name), 1)
                                                                  ], 16, _hoisted_167)
                                                                ]),
                                                                default: _withCtx(() => [
                                                                  _createVNode(_component_v_list, {
                                                                    density: "compact",
                                                                    class: "ben-match-menu"
                                                                  }, {
                                                                    default: _withCtx(() => [
                                                                      _createVNode(_component_v_list_item, {
                                                                        onClick: ($event: any) => (openCollectionForBeneficiary(beneficiaryMatches.value[child.cb_idx]?.cb_name || ''))
                                                                      }, {
                                                                        prepend: _withCtx(() => [
                                                                          _createVNode(_component_v_icon, {
                                                                            size: "18",
                                                                            color: "#0d9488"
                                                                          }, {
                                                                            default: _withCtx(() => [...(_cache[210] || (_cache[210] = [
                                                                              _createTextVNode("mdi-cash-register", -1)
                                                                            ]))]),
                                                                            _: 1
                                                                          })
                                                                        ]),
                                                                        default: _withCtx(() => [
                                                                          _createVNode(_component_v_list_item_title, null, {
                                                                            default: _withCtx(() => [...(_cache[211] || (_cache[211] = [
                                                                              _createTextVNode("수납 탭에서 보기", -1)
                                                                            ]))]),
                                                                            _: 1
                                                                          })
                                                                        ]),
                                                                        _: 1
                                                                      }, 8, ["onClick"]),
                                                                      _createVNode(_component_v_list_item, {
                                                                        onClick: ($event: any) => (changeBeneficiaryMatch(child))
                                                                      }, {
                                                                        prepend: _withCtx(() => [
                                                                          _createVNode(_component_v_icon, {
                                                                            size: "18",
                                                                            color: "#1565c0"
                                                                          }, {
                                                                            default: _withCtx(() => [...(_cache[212] || (_cache[212] = [
                                                                              _createTextVNode("mdi-account-switch", -1)
                                                                            ]))]),
                                                                            _: 1
                                                                          })
                                                                        ]),
                                                                        default: _withCtx(() => [
                                                                          _createVNode(_component_v_list_item_title, null, {
                                                                            default: _withCtx(() => [...(_cache[213] || (_cache[213] = [
                                                                              _createTextVNode("수급자 변경", -1)
                                                                            ]))]),
                                                                            _: 1
                                                                          })
                                                                        ]),
                                                                        _: 1
                                                                      }, 8, ["onClick"]),
                                                                      _createVNode(_component_v_list_item, {
                                                                        onClick: ($event: any) => (removeBeneficiaryMatch(child))
                                                                      }, {
                                                                        prepend: _withCtx(() => [
                                                                          _createVNode(_component_v_icon, {
                                                                            size: "18",
                                                                            color: "#c62828"
                                                                          }, {
                                                                            default: _withCtx(() => [...(_cache[214] || (_cache[214] = [
                                                                              _createTextVNode("mdi-link-off", -1)
                                                                            ]))]),
                                                                            _: 1
                                                                          })
                                                                        ]),
                                                                        default: _withCtx(() => [
                                                                          _createVNode(_component_v_list_item_title, null, {
                                                                            default: _withCtx(() => [...(_cache[215] || (_cache[215] = [
                                                                              _createTextVNode("매칭 해제", -1)
                                                                            ]))]),
                                                                            _: 1
                                                                          })
                                                                        ]),
                                                                        _: 1
                                                                      }, 8, ["onClick"])
                                                                    ]),
                                                                    _: 2
                                                                  }, 1024)
                                                                ]),
                                                                _: 2
                                                              }, 1024))
                                                            : (_openBlock(), _createElementBlock("button", {
                                                                key: 1,
                                                                type: "button",
                                                                class: "ben-match-link need",
                                                                title: "수급자가 아직 지정되지 않았습니다. 클릭하여 지정",
                                                                onClick: ($event: any) => (openBeneficiaryMatchPopover(child))
                                                              }, [...(_cache[216] || (_cache[216] = [
                                                                _createElementVNode("span", { class: "ben-match-name" }, "미연결", -1)
                                                              ]))], 8, _hoisted_169))
                                                        ], 64))
                                                      : (_openBlock(), _createElementBlock("span", _hoisted_170, "-"))
                                                ]),
                                                _createElementVNode("td", _hoisted_171, [
                                                  (child.cb_funding)
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_172, _toDisplayString(getFundingName(child.cb_funding)), 1))
                                                    : (_openBlock(), _createElementBlock("span", _hoisted_173, [
                                                        _createVNode(_component_v_icon, {
                                                          size: "14",
                                                          color: "#ca8a04"
                                                        }, {
                                                          default: _withCtx(() => [...(_cache[217] || (_cache[217] = [
                                                            _createTextVNode("mdi-alert", -1)
                                                          ]))]),
                                                          _: 1
                                                        }),
                                                        _cache[218] || (_cache[218] = _createTextVNode(" 미설정 ", -1))
                                                      ]))
                                                ]),
                                                (selectedBankCode.value === null)
                                                  ? (_openBlock(), _createElementBlock("td", _hoisted_174, [
                                                      _createElementVNode("span", _hoisted_175, _toDisplayString(getBankAlias(child.cb_bank_code)), 1)
                                                    ]))
                                                  : _createCommentVNode("", true)
                                              ], 10, _hoisted_156))
                                            }), 128))
                                          ], 64))
                                        : _createCommentVNode("", true)
                                  ], 64))
                                }), 128))
                              ])
                            ])
                          ]))
                    ], 512), [
                      [_vShow, !showStartGuide.value]
                    ]),
                    _withDirectives(_createElementVNode("aside", _hoisted_176, [
                      (singleSelectedItem.value)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: _normalizeClass(["sw-quick-edit", { open: quickEditOpen.value }]),
                            "data-tour": "bb-test-quick-edit"
                          }, [
                            _createElementVNode("button", {
                              type: "button",
                              class: "sw-quick-head",
                              "aria-expanded": quickEditOpen.value,
                              onClick: _cache[33] || (_cache[33] = ($event: any) => (quickEditOpen.value = !quickEditOpen.value))
                            }, [
                              _createElementVNode("span", _hoisted_178, [
                                _cache[220] || (_cache[220] = _createElementVNode("p", { class: "sw-quick-lbl" }, "적요 수정", -1)),
                                _createElementVNode("span", _hoisted_179, _toDisplayString(formatDate(singleSelectedItem.value.cb_date)) + " · " + _toDisplayString(singleSelectedItem.value.cb_gubun === 'IN' ? '수입' : '지출'), 1)
                              ]),
                              _createVNode(_component_v_icon, {
                                size: "18",
                                class: "sw-quick-chevron"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(quickEditOpen.value ? 'mdi-chevron-up' : 'mdi-chevron-down'), 1)
                                ]),
                                _: 1
                              })
                            ], 8, _hoisted_177),
                            _withDirectives(_createElementVNode("div", _hoisted_180, [
                              _createElementVNode("label", _hoisted_181, [
                                _cache[221] || (_cache[221] = _createElementVNode("span", null, "적요", -1)),
                                _withDirectives(_createElementVNode("input", {
                                  ref_key: "quickEditMemoRef",
                                  ref: quickEditMemoRef,
                                  "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((quickEditMemo).value = $event)),
                                  type: "text",
                                  disabled: !isItemEditable(singleSelectedItem.value) || closingStatus.value?.isClosed || isQuickEditSaving.value,
                                  onKeydown: _withKeys(_withModifiers(saveQuickEdit, ["prevent"]), ["enter"])
                                }, null, 40, _hoisted_182), [
                                  [_vModelText, quickEditMemo.value]
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_183, [
                                _cache[222] || (_cache[222] = _createElementVNode("span", null, "금액", -1)),
                                _createElementVNode("div", _hoisted_184, [
                                  _createElementVNode("div", _hoisted_185, [
                                    _createElementVNode("button", {
                                      type: "button",
                                      class: _normalizeClass({ on: quickEditGubun.value === 'IN' }),
                                      disabled: !isItemEditable(singleSelectedItem.value) || closingStatus.value?.isClosed || isQuickEditSaving.value,
                                      onClick: _cache[35] || (_cache[35] = ($event: any) => (quickEditGubun.value = 'IN'))
                                    }, "수입", 10, _hoisted_186),
                                    _createElementVNode("button", {
                                      type: "button",
                                      class: _normalizeClass({ on: quickEditGubun.value === 'OUT' }),
                                      disabled: !isItemEditable(singleSelectedItem.value) || closingStatus.value?.isClosed || isQuickEditSaving.value,
                                      onClick: _cache[36] || (_cache[36] = ($event: any) => (quickEditGubun.value = 'OUT'))
                                    }, "지출", 10, _hoisted_187)
                                  ]),
                                  _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((quickEditPriceText).value = $event)),
                                    type: "text",
                                    inputmode: "text",
                                    disabled: !isItemEditable(singleSelectedItem.value) || closingStatus.value?.isClosed || isQuickEditSaving.value,
                                    onInput: onQuickEditPriceInput,
                                    onKeydown: _withKeys(_withModifiers(saveQuickEdit, ["prevent"]), ["enter"])
                                  }, null, 40, _hoisted_188), [
                                    [_vModelText, quickEditPriceText.value]
                                  ])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_189, [
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "fd-btn primary",
                                  disabled: !isItemEditable(singleSelectedItem.value) || closingStatus.value?.isClosed || isQuickEditSaving.value || !quickEditDirty.value,
                                  onClick: saveQuickEdit
                                }, [
                                  (isQuickEditSaving.value)
                                    ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                                        key: 0,
                                        indeterminate: "",
                                        size: "14",
                                        width: "2",
                                        color: "white"
                                      }))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_191, "저장"))
                                ], 8, _hoisted_190),
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "fd-btn danger-ghost",
                                  disabled: !isItemEditable(singleSelectedItem.value) || closingStatus.value?.isClosed,
                                  onClick: _cache[38] || (_cache[38] = ($event: any) => (confirmDelete(singleSelectedItem.value)))
                                }, " 삭제 ", 8, _hoisted_192)
                              ])
                            ], 512), [
                              [_vShow, quickEditOpen.value]
                            ])
                          ], 2))
                        : (ledgerSelectedIds.value.length > 1)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_193, [
                              _cache[223] || (_cache[223] = _createElementVNode("span", null, "계정·자금원천은 아래에서 일괄 지정", -1)),
                              _createElementVNode("button", {
                                type: "button",
                                class: "sl-sel-btn danger",
                                disabled: closingStatus.value?.isClosed || !deletableSelectedCount.value,
                                onClick: confirmDeleteSelected
                              }, " 선택 삭제 ", 8, _hoisted_194)
                            ]))
                          : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_195, [
                        _createElementVNode("button", {
                          type: "button",
                          class: _normalizeClass(["sw-subtab", { on: rawWorkTab.value === 'account', done: isAccountTabDone.value }]),
                          onClick: openLedgerAccountTab
                        }, [
                          _cache[225] || (_cache[225] = _createElementVNode("span", { class: "sw-subtab-name" }, "계정", -1)),
                          (isAccountTabDone.value)
                            ? (_openBlock(), _createBlock(_component_v_icon, {
                                key: 0,
                                class: "sw-subtab-check",
                                size: "14"
                              }, {
                                default: _withCtx(() => [...(_cache[224] || (_cache[224] = [
                                  _createTextVNode("mdi-check", -1)
                                ]))]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ], 2),
                        (ledgerListTab.value === 'out')
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              type: "button",
                              class: _normalizeClass(["sw-subtab", { on: rawWorkTab.value === 'rel', done: isRelTabDone.value }]),
                              "data-tour": "bb-test-rel",
                              onClick: _cache[39] || (_cache[39] = ($event: any) => (rawWorkTab.value = 'rel'))
                            }, [
                              _cache[227] || (_cache[227] = _createElementVNode("span", { class: "sw-subtab-name" }, "상대계정", -1)),
                              (isRelTabDone.value)
                                ? (_openBlock(), _createBlock(_component_v_icon, {
                                    key: 0,
                                    class: "sw-subtab-check",
                                    size: "14"
                                  }, {
                                    default: _withCtx(() => [...(_cache[226] || (_cache[226] = [
                                      _createTextVNode("mdi-check", -1)
                                    ]))]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true)
                            ], 2))
                          : _createCommentVNode("", true),
                        _createElementVNode("button", {
                          type: "button",
                          class: _normalizeClass(["sw-subtab", { on: rawWorkTab.value === 'split', disabled: isSplitTabDisabled.value }]),
                          "data-tour": "bb-test-split",
                          disabled: isSplitTabDisabled.value,
                          title: isSplitTabDisabled.value ? '분개는 항목을 하나만 선택했을 때 사용할 수 있습니다' : '선택한 항목 분개',
                          onClick: _cache[40] || (_cache[40] = ($event: any) => (rawWorkTab.value = 'split'))
                        }, [...(_cache[228] || (_cache[228] = [
                          _createElementVNode("span", { class: "sw-subtab-name" }, "분개", -1)
                        ]))], 10, _hoisted_196),
                        _createElementVNode("button", {
                          type: "button",
                          class: _normalizeClass(["sw-subtab", { on: rawWorkTab.value === 'funding', done: isFundingTabDone.value }]),
                          "data-tour": "bb-test-funding",
                          onClick: _cache[41] || (_cache[41] = ($event: any) => (rawWorkTab.value = 'funding'))
                        }, [
                          _cache[230] || (_cache[230] = _createElementVNode("span", { class: "sw-subtab-name" }, "자금원천", -1)),
                          (isFundingTabDone.value)
                            ? (_openBlock(), _createBlock(_component_v_icon, {
                                key: 0,
                                class: "sw-subtab-check",
                                size: "14"
                              }, {
                                default: _withCtx(() => [...(_cache[229] || (_cache[229] = [
                                  _createTextVNode("mdi-check", -1)
                                ]))]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ], 2)
                      ]),
                      (rawWorkTab.value === 'account' || rawWorkTab.value === 'rel' || rawWorkTab.value === 'funding')
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 2,
                            type: "button",
                            class: "sw-adjust-btn",
                            disabled: !adjustWorkbenchRef.value?.canSubmitExpenseAdjust || closingStatus.value?.isClosed,
                            onClick: _cache[42] || (_cache[42] = ($event: any) => (adjustWorkbenchRef.value?.applyExpenseAdjust()))
                          }, "조정하기", 8, _hoisted_197))
                        : _createCommentVNode("", true),
                      _withDirectives(_createElementVNode("div", _hoisted_198, [
                        _createVNode(BankbookAdjustWorkbench, {
                          ref_key: "adjustWorkbenchRef",
                          ref: adjustWorkbenchRef,
                          "hide-list": "",
                          "adjust-focus": rawWorkTab.value === 'rel' ? 'rel' : 'account',
                          incomes: workbenchIncomes.value,
                          "pending-items": pendingAdjustList.value,
                          "done-items": doneAdjustList.value,
                          "pending-incomes": pendingIncomeList.value,
                          "done-incomes": doneIncomeList.value,
                          "selected-scode": selectedIncomeScode.value,
                          "expense-codes": adjustExpenseCodes.value.length ? adjustExpenseCodes.value : expenseCodeList.value,
                          "income-codes": incomeCodeList.value,
                          "ledger-items": selectedBankCashbookList.value,
                          "bank-names": bankNameMap.value,
                          "show-bank": selectedBankCode.value === null,
                          loading: isAdjustStateLoading.value,
                          "is-editable": isItemEditable,
                          "member-code": memberCode.value,
                          "biz-gubun": selectedBizGubun.value,
                          year: currentYear.value,
                          "is-admin": isAdmin.value,
                          onSelectIncome: onIncomeBalanceSelect,
                          onAssignBatch: onWorkbenchAssignBatch,
                          onAssignExpenseAccount: onWorkbenchAssignExpenseAccount,
                          onAssignRel: onWorkbenchAssignRel,
                          onAssignFunding: onWorkbenchAssignFunding,
                          onUnassign: onWorkbenchUnassign,
                          onAssignIncome: onWorkbenchAssignIncome,
                          onUnassignIncome: onWorkbenchUnassignIncome,
                          onSelectionChange: onAdjustSelectionChange,
                          "onUpdate:listTab": onWorkbenchListTab,
                          onOpenLearn: openDictionaryManageModal,
                          onOpenPairs: _cache[43] || (_cache[43] = ($event: any) => (accountPairModalOpen.value = true)),
                          onOpenMatch: openMatchDialog
                        }, null, 8, ["adjust-focus", "incomes", "pending-items", "done-items", "pending-incomes", "done-incomes", "selected-scode", "expense-codes", "income-codes", "ledger-items", "bank-names", "show-bank", "loading", "member-code", "biz-gubun", "year", "is-admin"])
                      ], 512), [
                        [_vShow, rawWorkTab.value === 'account' || rawWorkTab.value === 'rel']
                      ]),
                      _withDirectives(_createElementVNode("div", _hoisted_199, [
                        _createElementVNode("div", _hoisted_200, [
                          (unfundedCount.value > 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_201, [
                                _createElementVNode("strong", null, _toDisplayString(unfundedCount.value), 1),
                                _cache[231] || (_cache[231] = _createTextVNode("건 남음 ", -1)),
                                (fundingInferableCount.value > 0)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_202, "· 기준 " + _toDisplayString(fundingInferableCount.value) + "건", 1))
                                  : _createCommentVNode("", true)
                              ]))
                            : (_openBlock(), _createElementBlock("span", _hoisted_203, "미설정 없음")),
                          _createElementVNode("button", {
                            type: "button",
                            class: "wb-gear",
                            "data-tour": "bb-test-funding-settings",
                            onClick: _cache[44] || (_cache[44] = ($event: any) => (openMatchDialog('funding')))
                          }, "자동화 적용")
                        ]),
                        _createElementVNode("div", _hoisted_204, [
                          (fundingSelectedItems.value.length)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_205, [
                                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(fundingCodeList, (f) => {
                                  return _createElementVNode("button", {
                                    key: f.code,
                                    type: "button",
                                    class: _normalizeClass(["fd-mini", { on: adjustWorkbenchRef.value?.draftFunding === f.code }]),
                                    disabled: isAutoFundingProcessing.value || closingStatus.value?.isClosed,
                                    onClick: ($event: any) => (adjustWorkbenchRef.value?.pickFunding(f.code))
                                  }, _toDisplayString(f.name), 11, _hoisted_206)
                                }), 64))
                              ]))
                            : (_openBlock(), _createElementBlock("p", _hoisted_207, "표에서 항목을 고른 뒤 자금원천을 선택하세요."))
                        ])
                      ], 512), [
                        [_vShow, rawWorkTab.value === 'funding']
                      ]),
                      _withDirectives(_createElementVNode("div", _hoisted_208, [
                        (splitTargetItem.value)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createElementVNode("div", _hoisted_209, [
                                _createElementVNode("p", _hoisted_210, _toDisplayString(isSplitChildItem(splitTargetItem.value) ? '분개된 항목' : '분개 대상'), 1),
                                _createElementVNode("p", _hoisted_211, _toDisplayString(splitTargetItem.value.cb_memo || '-'), 1),
                                _createElementVNode("p", _hoisted_212, _toDisplayString(formatDate(splitTargetItem.value.cb_date)) + " · " + _toDisplayString(splitTargetItem.value.cb_gubun === 'IN' ? '수입' : '지출') + " · " + _toDisplayString(formatNumber(splitTargetItem.value.cb_price)) + "원 ", 1),
                                (hasLedgerScode(splitTargetItem.value))
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_213, " 계정 " + _toDisplayString(ledgerScodeLabel(splitTargetItem.value)), 1))
                                  : _createCommentVNode("", true)
                              ]),
                              (isSplitChildItem(splitTargetItem.value))
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createElementVNode("button", {
                                      type: "button",
                                      class: "fd-btn danger sw-full",
                                      disabled: !isItemEditable(splitTargetItem.value) || closingStatus.value?.isClosed || isMergingSplit.value,
                                      onClick: mergeSplitTarget
                                    }, [
                                      _createVNode(_component_v_icon, { size: "16" }, {
                                        default: _withCtx(() => [...(_cache[232] || (_cache[232] = [
                                          _createTextVNode("mdi-call-merge", -1)
                                        ]))]),
                                        _: 1
                                      }),
                                      _createTextVNode(" " + _toDisplayString(isMergingSplit.value ? '합치는 중…' : '분개 합치기'), 1)
                                    ], 8, _hoisted_214),
                                    _createElementVNode("button", {
                                      type: "button",
                                      class: "fd-btn primary sw-full",
                                      disabled: !isItemEditable(splitTargetItem.value) || closingStatus.value?.isClosed || isMergingSplit.value,
                                      onClick: _cache[45] || (_cache[45] = ($event: any) => (openSplitModal(splitTargetItem.value)))
                                    }, [
                                      _createVNode(_component_v_icon, { size: "16" }, {
                                        default: _withCtx(() => [...(_cache[233] || (_cache[233] = [
                                          _createTextVNode("mdi-call-split", -1)
                                        ]))]),
                                        _: 1
                                      }),
                                      _cache[234] || (_cache[234] = _createTextVNode(" 분개 수정 ", -1))
                                    ], 8, _hoisted_215),
                                    _cache[235] || (_cache[235] = _createElementVNode("p", { class: "sw-hint" }, "합치면 분개 항목이 사라지고 원본 한 건으로 돌아갑니다.", -1))
                                  ], 64))
                                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _createElementVNode("button", {
                                      type: "button",
                                      class: "fd-btn primary sw-full",
                                      disabled: !isItemEditable(splitTargetItem.value) || closingStatus.value?.isClosed,
                                      onClick: _cache[46] || (_cache[46] = ($event: any) => (openSplitModal(splitTargetItem.value)))
                                    }, [
                                      _createVNode(_component_v_icon, { size: "16" }, {
                                        default: _withCtx(() => [...(_cache[236] || (_cache[236] = [
                                          _createTextVNode("mdi-call-split", -1)
                                        ]))]),
                                        _: 1
                                      }),
                                      _cache[237] || (_cache[237] = _createTextVNode(" 분개하기 ", -1))
                                    ], 8, _hoisted_216),
                                    _cache[238] || (_cache[238] = _createElementVNode("p", { class: "sw-hint" }, "원본 금액을 여러 계정으로 나눕니다. 합계는 원본과 같아야 합니다.", -1))
                                  ], 64))
                            ], 64))
                          : (_openBlock(), _createElementBlock("p", _hoisted_217, "분개할 항목을 하나만 선택하세요."))
                      ], 512), [
                        [_vShow, rawWorkTab.value === 'split']
                      ])
                    ], 512), [
                      [_vShow, !showStartGuide.value]
                    ])
                  ]))
                : (isCollectionStep.value)
                  ? (_openBlock(), _createElementBlock("section", _hoisted_218, [
                      (showCollectionGuide.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_219, [
                            _createElementVNode("div", _hoisted_220, [
                              _createElementVNode("div", _hoisted_221, [
                                _createVNode(_component_v_icon, { size: "34" }, {
                                  default: _withCtx(() => [...(_cache[239] || (_cache[239] = [
                                    _createTextVNode("mdi-cash-register", -1)
                                  ]))]),
                                  _: 1
                                })
                              ]),
                              _cache[240] || (_cache[240] = _createElementVNode("p", { class: "sg-title" }, "수납 정리를 시작해 볼까요?", -1)),
                              _createElementVNode("p", _hoisted_222, _toDisplayString(currentYear.value) + "년 " + _toDisplayString(currentMonth.value) + "월 · 수급자별 청구와 입금을 맞추는 단계입니다", 1)
                            ]),
                            _cache[257] || (_cache[257] = _createStaticVNode("<div class=\"sg-desc\"><div class=\"sg-desc-row\"><span class=\"sg-desc-label\">목적</span><p>수급자별 받을 돈(청구)과 들어온 돈(입금)을 맞춰 미수금 관리</p></div><div class=\"sg-desc-row\"><span class=\"sg-desc-label\">준비물</span><p>수급자 등록 (엑셀 업로드 시 미등록 수급자는 자동 추가)</p></div><div class=\"sg-desc-row\"><span class=\"sg-desc-label\">쓰이는 곳</span><p>입금 자동 반영 · 미수금 이력 · 누적 미수 (전달 미수는 다음 입금에서 우선 충당)</p></div></div>", 1)),
                            _createElementVNode("p", _hoisted_223, [
                              _createVNode(_component_v_icon, { size: "14" }, {
                                default: _withCtx(() => [...(_cache[241] || (_cache[241] = [
                                  _createTextVNode("mdi-alert-outline", -1)
                                ]))]),
                                _: 1
                              }),
                              _cache[242] || (_cache[242] = _createTextVNode(" 미수금 관리는 여기서 · 통장에 입금된 돈은 통장내역에서 관리하세요 ", -1))
                            ]),
                            _createElementVNode("ol", _hoisted_224, [
                              _createElementVNode("li", _hoisted_225, [
                                _cache[246] || (_cache[246] = _createElementVNode("span", { class: "sg-step-num" }, "1", -1)),
                                _createElementVNode("div", _hoisted_226, [
                                  _createVNode(_component_v_icon, { size: "26" }, {
                                    default: _withCtx(() => [...(_cache[243] || (_cache[243] = [
                                      _createTextVNode("mdi-file-excel-outline", -1)
                                    ]))]),
                                    _: 1
                                  })
                                ]),
                                _cache[247] || (_cache[247] = _createElementVNode("strong", null, "수납관리 엑셀 업로드", -1)),
                                _cache[248] || (_cache[248] = _createElementVNode("p", null, "수급자·청구 내역을 엑셀로 한 번에 등록합니다", -1)),
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "sg-btn primary",
                                  disabled: isCollectionExcelDisabled.value,
                                  onClick: _cache[47] || (_cache[47] = ($event: any) => (collectionExcelModalOpen.value = true))
                                }, [
                                  _createVNode(_component_v_icon, { size: "15" }, {
                                    default: _withCtx(() => [...(_cache[244] || (_cache[244] = [
                                      _createTextVNode("mdi-upload", -1)
                                    ]))]),
                                    _: 1
                                  }),
                                  _cache[245] || (_cache[245] = _createTextVNode(" 엑셀 업로드 ", -1))
                                ], 8, _hoisted_227)
                              ]),
                              _createElementVNode("li", null, [
                                _cache[252] || (_cache[252] = _createElementVNode("span", { class: "sg-step-num" }, "2", -1)),
                                _createElementVNode("div", _hoisted_228, [
                                  _createVNode(_component_v_icon, { size: "26" }, {
                                    default: _withCtx(() => [...(_cache[249] || (_cache[249] = [
                                      _createTextVNode("mdi-account-link-outline", -1)
                                    ]))]),
                                    _: 1
                                  })
                                ]),
                                _cache[253] || (_cache[253] = _createElementVNode("strong", null, "통장내역에서 수급자 연결", -1)),
                                _cache[254] || (_cache[254] = _createElementVNode("p", null, "본인부담금수입(112) 항목에 수급자를 지정합니다", -1)),
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "sg-btn",
                                  onClick: _cache[48] || (_cache[48] = ($event: any) => (goStep('raw')))
                                }, [
                                  _createVNode(_component_v_icon, { size: "15" }, {
                                    default: _withCtx(() => [...(_cache[250] || (_cache[250] = [
                                      _createTextVNode("mdi-arrow-left", -1)
                                    ]))]),
                                    _: 1
                                  }),
                                  _cache[251] || (_cache[251] = _createTextVNode(" 통장내역으로 이동 ", -1))
                                ])
                              ])
                            ]),
                            _createElementVNode("p", _hoisted_229, [
                              _createVNode(_component_v_icon, { size: "14" }, {
                                default: _withCtx(() => [...(_cache[255] || (_cache[255] = [
                                  _createTextVNode("mdi-information-outline", -1)
                                ]))]),
                                _: 1
                              }),
                              _cache[256] || (_cache[256] = _createTextVNode(" 둘 중 편한 방법으로 등록하면 입금 매칭과 미수금 정리가 이어집니다 ", -1))
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      _withDirectives(_createVNode(BeneficiaryManageModal, {
                        ref_key: "beneficiaryEmbedRef",
                        ref: beneficiaryEmbedRef,
                        embedded: "",
                        "member-code": memberCode.value,
                        year: currentYear.value,
                        month: currentMonth.value,
                        "initial-search-name": beneficiaryModalSearchName.value,
                        "deposit-data": beneficiaryModalDepositData.value,
                        "biz-gubun": selectedBizGubun.value,
                        onBeneficiaryChanged: onBeneficiaryChanged,
                        onCollectionDeleted: onCollectionDeleted,
                        onChargeUpdated: onChargeUpdated
                      }, null, 8, ["member-code", "year", "month", "initial-search-name", "deposit-data", "biz-gubun"]), [
                        [_vShow, !showCollectionGuide.value]
                      ])
                    ]))
                  : (isReceiptStep.value)
                    ? (_openBlock(), _createElementBlock("section", _hoisted_230, [
                        (showReceiptGuide.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_231, [
                              _createElementVNode("div", _hoisted_232, [
                                _createElementVNode("div", _hoisted_233, [
                                  _createVNode(_component_v_icon, { size: "34" }, {
                                    default: _withCtx(() => [...(_cache[258] || (_cache[258] = [
                                      _createTextVNode("mdi-receipt-text-outline", -1)
                                    ]))]),
                                    _: 1
                                  })
                                ]),
                                _cache[259] || (_cache[259] = _createElementVNode("p", { class: "sg-title" }, "영수증 정리를 시작해 볼까요?", -1)),
                                _createElementVNode("p", _hoisted_234, _toDisplayString(currentYear.value) + "년 " + _toDisplayString(currentMonth.value) + "월 · 통장 지출과 영수증을 맞추는 단계입니다", 1)
                              ]),
                              _cache[278] || (_cache[278] = _createStaticVNode("<div class=\"sg-desc\"><div class=\"sg-desc-row\"><span class=\"sg-desc-label\">목적</span><p>지출 증빙 확보 — 회계 감사·보조금 정산 대비</p></div><div class=\"sg-desc-row\"><span class=\"sg-desc-label\">준비물</span><p>이 달 지출 정리(통장내역 탭) · 영수증 이미지 (날짜가 달라도 매칭 가능)</p></div><div class=\"sg-desc-row\"><span class=\"sg-desc-label\">쓰이는 곳</span><p>지출별 증빙 저장 · 회계보고서 · 감사 자료 (여러 장 묶음 가능)</p></div></div>", 1)),
                              (receiptExpenseCount.value === 0)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _cache[262] || (_cache[262] = _createElementVNode("p", { class: "sg-note" }, [
                                      _createTextVNode(" 이 달 지출 내역이 없어 매칭할 대상이 없습니다."),
                                      _createElementVNode("br"),
                                      _createTextVNode(" 먼저 통장내역에서 지출을 정리해 주세요. ")
                                    ], -1)),
                                    _createElementVNode("button", {
                                      type: "button",
                                      class: "sg-btn",
                                      onClick: _cache[49] || (_cache[49] = ($event: any) => (goStep('raw')))
                                    }, [
                                      _createVNode(_component_v_icon, { size: "15" }, {
                                        default: _withCtx(() => [...(_cache[260] || (_cache[260] = [
                                          _createTextVNode("mdi-arrow-left", -1)
                                        ]))]),
                                        _: 1
                                      }),
                                      _cache[261] || (_cache[261] = _createTextVNode(" 통장내역으로 이동 ", -1))
                                    ])
                                  ], 64))
                                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _createElementVNode("ol", _hoisted_235, [
                                      _createElementVNode("li", null, [
                                        _cache[264] || (_cache[264] = _createElementVNode("span", { class: "sg-step-num" }, "1", -1)),
                                        _createElementVNode("div", _hoisted_236, [
                                          _createVNode(_component_v_icon, { size: "26" }, {
                                            default: _withCtx(() => [...(_cache[263] || (_cache[263] = [
                                              _createTextVNode("mdi-camera-outline", -1)
                                            ]))]),
                                            _: 1
                                          })
                                        ]),
                                        _cache[265] || (_cache[265] = _createElementVNode("strong", null, "영수증 올리기", -1)),
                                        _cache[266] || (_cache[266] = _createElementVNode("p", null, "스캔하거나 찍은 영수증 사진을 등록합니다", -1))
                                      ]),
                                      _createElementVNode("li", null, [
                                        _cache[268] || (_cache[268] = _createElementVNode("span", { class: "sg-step-num" }, "2", -1)),
                                        _createElementVNode("div", _hoisted_237, [
                                          _createVNode(_component_v_icon, { size: "26" }, {
                                            default: _withCtx(() => [...(_cache[267] || (_cache[267] = [
                                              _createTextVNode("mdi-cursor-default-click-outline", -1)
                                            ]))]),
                                            _: 1
                                          })
                                        ]),
                                        _cache[269] || (_cache[269] = _createElementVNode("strong", null, "통장 지출 선택", -1)),
                                        _cache[270] || (_cache[270] = _createElementVNode("p", null, "맞출 지출 항목을 고릅니다. 날짜가 달라도 됩니다", -1))
                                      ]),
                                      _createElementVNode("li", null, [
                                        _cache[272] || (_cache[272] = _createElementVNode("span", { class: "sg-step-num" }, "3", -1)),
                                        _createElementVNode("div", _hoisted_238, [
                                          _createVNode(_component_v_icon, { size: "26" }, {
                                            default: _withCtx(() => [...(_cache[271] || (_cache[271] = [
                                              _createTextVNode("mdi-link-variant", -1)
                                            ]))]),
                                            _: 1
                                          })
                                        ]),
                                        _cache[273] || (_cache[273] = _createElementVNode("strong", null, "매칭", -1)),
                                        _cache[274] || (_cache[274] = _createElementVNode("p", null, "「매칭」 버튼으로 둘을 연결합니다", -1))
                                      ])
                                    ]),
                                    _createElementVNode("button", {
                                      type: "button",
                                      class: "sg-btn primary sg-start-btn",
                                      onClick: _cache[50] || (_cache[50] = ($event: any) => (receiptGuideDismissed.value = true))
                                    }, [
                                      _createVNode(_component_v_icon, { size: "15" }, {
                                        default: _withCtx(() => [...(_cache[275] || (_cache[275] = [
                                          _createTextVNode("mdi-play", -1)
                                        ]))]),
                                        _: 1
                                      }),
                                      _cache[276] || (_cache[276] = _createTextVNode(" 영수증 작업 시작하기 ", -1))
                                    ]),
                                    _createElementVNode("p", _hoisted_239, [
                                      _createVNode(_component_v_icon, { size: "14" }, {
                                        default: _withCtx(() => [...(_cache[277] || (_cache[277] = [
                                          _createTextVNode("mdi-information-outline", -1)
                                        ]))]),
                                        _: 1
                                      }),
                                      _createTextVNode(" 이 달 지출 " + _toDisplayString(receiptExpenseCount.value) + "건이 매칭 대상입니다 ", 1)
                                    ])
                                  ], 64))
                            ]))
                          : _createCommentVNode("", true),
                        _withDirectives(_createVNode(ReceiptMatchingDialog, {
                          embedded: "",
                          "cashbook-item": selectedCashbookForMatching.value,
                          "m-code": memberCode.value,
                          "biz-gubun": selectedBizGubun.value,
                          "account-codes": accountCodes.value,
                          "current-year": currentYear.value,
                          "current-month": currentMonth.value,
                          onSaved: handleMatchingSaved
                        }, null, 8, ["cashbook-item", "m-code", "biz-gubun", "account-codes", "current-year", "current-month"]), [
                          [_vShow, !showReceiptGuide.value]
                        ])
                      ]))
                    : (isAnalysisReferenceStep.value)
                      ? (_openBlock(), _createElementBlock("section", _hoisted_240, [
                          _createVNode(AccountingAnalysisReferenceEmbed, {
                            "member-code": String(memberCode.value),
                            year: currentYear.value,
                            month: currentMonth.value,
                            "biz-gubun": selectedBizGubun.value,
                            "bank-code": selectedBankCode.value
                          }, null, 8, ["member-code", "year", "month", "biz-gubun", "bank-code"])
                        ]))
                      : _createCommentVNode("", true)
            ], 2)
          ])
        ])),
    _createVNode(_component_v_snackbar, {
      modelValue: guideToast.value.show,
      "onUpdate:modelValue": _cache[51] || (_cache[51] = ($event: any) => ((guideToast.value.show) = $event)),
      timeout: 2400,
      color: guideToast.value.color,
      location: "top",
      "multi-line": ""
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(guideToast.value.message), 1)
      ]),
      _: 1
    }, 8, ["modelValue", "color"]),
    _createVNode(PgmBankbookUpload, {
      modelValue: uploadDialogOpen.value,
      "onUpdate:modelValue": _cache[52] || (_cache[52] = ($event: any) => ((uploadDialogOpen).value = $event)),
      "member-code": memberCode.value,
      "current-year": currentYear.value,
      "current-month": currentMonth.value,
      "biz-gubun": selectedBizGubun.value,
      "income-code-list": incomeCodeList.value,
      "expense-code-list": expenseCodeList.value,
      "bank-list": bankList.value,
      "selected-bank-code": selectedBankCode.value,
      onSaved: handleUploadSaved,
      onUploadComplete: handleUploadComplete
    }, null, 8, ["modelValue", "member-code", "current-year", "current-month", "biz-gubun", "income-code-list", "expense-code-list", "bank-list", "selected-bank-code"]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(uploadNotifications.value, (notification, idx) => {
      return (_openBlock(), _createBlock(_component_v_snackbar, {
        key: notification.id,
        modelValue: notification.show,
        "onUpdate:modelValue": ($event: any) => ((notification.show) = $event),
        timeout: 5000,
        color: notification.success ? 'success' : 'error',
        location: "top right",
        style: _normalizeStyle({ marginTop: `${idx * 70}px` }),
        class: "upload-notification"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_241, [
            _createVNode(_component_v_icon, {
              icon: notification.success ? 'mdi-check-circle' : 'mdi-alert-circle',
              class: "mr-2"
            }, null, 8, ["icon"]),
            _createElementVNode("div", _hoisted_242, [
              _createElementVNode("strong", null, _toDisplayString(notification.bankAlias), 1),
              (notification.success)
                ? (_openBlock(), _createElementBlock("span", _hoisted_243, _toDisplayString(notification.fileName) + " (" + _toDisplayString(notification.count) + "건 등록)", 1))
                : (_openBlock(), _createElementBlock("span", _hoisted_244, _toDisplayString(notification.message), 1))
            ])
          ])
        ]),
        _: 2
      }, 1032, ["modelValue", "onUpdate:modelValue", "color", "style"]))
    }), 128)),
    _createVNode(_component_v_dialog, {
      modelValue: deleteDialogOpen.value,
      "onUpdate:modelValue": _cache[55] || (_cache[55] = ($event: any) => ((deleteDialogOpen).value = $event)),
      "max-width": "400"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_245, [
          _createElementVNode("div", _hoisted_246, [
            _createElementVNode("div", _hoisted_247, [
              _createVNode(_component_v_icon, {
                size: "28",
                color: "white"
              }, {
                default: _withCtx(() => [...(_cache[279] || (_cache[279] = [
                  _createTextVNode("mdi-alert", -1)
                ]))]),
                _: 1
              })
            ]),
            _cache[281] || (_cache[281] = _createElementVNode("h3", null, "삭제 확인", -1)),
            _cache[282] || (_cache[282] = _createElementVNode("p", null, "이 작업은 되돌릴 수 없습니다", -1)),
            _createElementVNode("button", {
              type: "button",
              class: "modal-header-close",
              "aria-label": "닫기",
              disabled: isDeleting.value,
              onClick: _cache[53] || (_cache[53] = ($event: any) => (deleteDialogOpen.value = false))
            }, [
              _createVNode(_component_v_icon, { size: "18" }, {
                default: _withCtx(() => [...(_cache[280] || (_cache[280] = [
                  _createTextVNode("mdi-close", -1)
                ]))]),
                _: 1
              })
            ], 8, _hoisted_248)
          ]),
          _createElementVNode("div", _hoisted_249, [
            _createElementVNode("p", _hoisted_250, [
              (deleteTargets.value.length > 1)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _cache[283] || (_cache[283] = _createTextVNode(" 선택한 ", -1)),
                    _createElementVNode("strong", null, _toDisplayString(deleteTargets.value.length) + "건", 1),
                    _cache[284] || (_cache[284] = _createTextVNode("을 삭제하시겠습니까? ", -1))
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(" 선택한 현금출납 항목을 삭제하시겠습니까? ")
                  ], 64))
            ]),
            (deleteTargets.value.length === 1 && selectedItem.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_251, [
                  _createElementVNode("div", _hoisted_252, [
                    _cache[285] || (_cache[285] = _createElementVNode("span", { class: "info-label" }, "날짜", -1)),
                    _createElementVNode("span", _hoisted_253, _toDisplayString(formatDate(selectedItem.value.cb_date)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_254, [
                    _cache[286] || (_cache[286] = _createElementVNode("span", { class: "info-label" }, "구분", -1)),
                    _createElementVNode("span", {
                      class: _normalizeClass(["info-value", selectedItem.value.cb_gubun === 'IN' ? 'income' : 'expense'])
                    }, _toDisplayString(selectedItem.value.cb_gubun === 'IN' ? '수입' : '지출'), 3)
                  ]),
                  _createElementVNode("div", _hoisted_255, [
                    _cache[287] || (_cache[287] = _createElementVNode("span", { class: "info-label" }, "금액", -1)),
                    _createElementVNode("span", _hoisted_256, _toDisplayString(formatNumber(selectedItem.value.cb_price)) + "원", 1)
                  ]),
                  (selectedItem.value.cb_memo)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_257, [
                        _cache[288] || (_cache[288] = _createElementVNode("span", { class: "info-label" }, "적요", -1)),
                        _createElementVNode("span", _hoisted_258, _toDisplayString(selectedItem.value.cb_memo), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : (deleteTargets.value.length > 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_259, [
                    _createElementVNode("div", _hoisted_260, [
                      _cache[289] || (_cache[289] = _createElementVNode("span", { class: "label" }, "수입", -1)),
                      _createElementVNode("span", _hoisted_261, _toDisplayString(deleteTargets.value.filter(i => i.cb_gubun === 'IN').length) + "건", 1)
                    ]),
                    _createElementVNode("div", _hoisted_262, [
                      _cache[290] || (_cache[290] = _createElementVNode("span", { class: "label" }, "지출", -1)),
                      _createElementVNode("span", _hoisted_263, _toDisplayString(deleteTargets.value.filter(i => i.cb_gubun === 'OUT').length) + "건", 1)
                    ])
                  ]))
                : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_264, [
            _createElementVNode("button", {
              type: "button",
              class: "btn-cancel",
              onClick: _cache[54] || (_cache[54] = ($event: any) => (deleteDialogOpen.value = false))
            }, "취소"),
            _createElementVNode("button", {
              type: "button",
              class: "btn-delete",
              onClick: deleteItem,
              disabled: isDeleting.value
            }, [
              (isDeleting.value)
                ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                    key: 0,
                    indeterminate: "",
                    size: "18",
                    width: "2",
                    color: "white"
                  }))
                : (_openBlock(), _createElementBlock("span", _hoisted_266, "삭제하기"))
            ], 8, _hoisted_265)
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: deleteAllDialogOpen.value,
      "onUpdate:modelValue": _cache[58] || (_cache[58] = ($event: any) => ((deleteAllDialogOpen).value = $event)),
      "max-width": "450",
      persistent: ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_267, [
          _createElementVNode("div", _hoisted_268, [
            _createElementVNode("div", _hoisted_269, [
              _createVNode(_component_v_icon, {
                size: "28",
                color: "white"
              }, {
                default: _withCtx(() => [...(_cache[291] || (_cache[291] = [
                  _createTextVNode("mdi-delete-sweep", -1)
                ]))]),
                _: 1
              })
            ]),
            _cache[293] || (_cache[293] = _createElementVNode("h3", null, "일괄 삭제 확인", -1)),
            _cache[294] || (_cache[294] = _createElementVNode("p", null, "이 작업은 되돌릴 수 없습니다", -1)),
            _createElementVNode("button", {
              type: "button",
              class: "modal-header-close",
              "aria-label": "닫기",
              disabled: isDeleting.value,
              onClick: _cache[56] || (_cache[56] = ($event: any) => (deleteAllDialogOpen.value = false))
            }, [
              _createVNode(_component_v_icon, { size: "18" }, {
                default: _withCtx(() => [...(_cache[292] || (_cache[292] = [
                  _createTextVNode("mdi-close", -1)
                ]))]),
                _: 1
              })
            ], 8, _hoisted_270)
          ]),
          _createElementVNode("div", _hoisted_271, [
            _createElementVNode("p", _hoisted_272, [
              _cache[295] || (_cache[295] = _createTextVNode(" 현재 필터링된 ", -1)),
              _createElementVNode("strong", _hoisted_273, _toDisplayString(filteredCashbookList.value.length) + "건", 1),
              _cache[296] || (_cache[296] = _createTextVNode("의 항목을 모두 삭제하시겠습니까? ", -1))
            ]),
            _createElementVNode("div", _hoisted_274, [
              _createElementVNode("div", _hoisted_275, [
                _cache[297] || (_cache[297] = _createElementVNode("span", { class: "label" }, "수입 항목", -1)),
                _createElementVNode("span", _hoisted_276, _toDisplayString(filteredCashbookList.value.filter(i => i.cb_gubun === 'IN').length) + "건", 1)
              ]),
              _createElementVNode("div", _hoisted_277, [
                _cache[298] || (_cache[298] = _createElementVNode("span", { class: "label" }, "지출 항목", -1)),
                _createElementVNode("span", _hoisted_278, _toDisplayString(filteredCashbookList.value.filter(i => i.cb_gubun === 'OUT').length) + "건", 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_279, [
              _createVNode(_component_v_icon, {
                size: "16",
                color: "#6b7280"
              }, {
                default: _withCtx(() => [...(_cache[299] || (_cache[299] = [
                  _createTextVNode("mdi-alert-circle-outline", -1)
                ]))]),
                _: 1
              }),
              _cache[300] || (_cache[300] = _createElementVNode("span", null, "삭제 후 복구가 불가능합니다. 신중하게 결정해주세요.", -1))
            ])
          ]),
          _createElementVNode("div", _hoisted_280, [
            _createElementVNode("button", {
              type: "button",
              class: "btn-cancel",
              onClick: _cache[57] || (_cache[57] = ($event: any) => (deleteAllDialogOpen.value = false))
            }, "취소"),
            _createElementVNode("button", {
              type: "button",
              class: "btn-delete danger",
              onClick: deleteAllItems,
              disabled: isDeleting.value
            }, [
              (isDeleting.value)
                ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                    key: 0,
                    indeterminate: "",
                    size: "18",
                    width: "2",
                    color: "white"
                  }))
                : (_openBlock(), _createElementBlock("span", _hoisted_282, _toDisplayString(filteredCashbookList.value.length) + "건 모두 삭제", 1))
            ], 8, _hoisted_281)
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: closingDialogOpen.value,
      "onUpdate:modelValue": _cache[61] || (_cache[61] = ($event: any) => ((closingDialogOpen).value = $event)),
      "max-width": "500",
      persistent: ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_283, [
          _createElementVNode("div", _hoisted_284, [
            _createElementVNode("div", _hoisted_285, [
              _createVNode(_component_v_icon, {
                size: "28",
                color: "white"
              }, {
                default: _withCtx(() => [...(_cache[301] || (_cache[301] = [
                  _createTextVNode("mdi-check-decagram", -1)
                ]))]),
                _: 1
              })
            ]),
            _cache[303] || (_cache[303] = _createElementVNode("h3", null, "계정조정 마감", -1)),
            _createElementVNode("p", null, _toDisplayString(currentYear.value) + "년 " + _toDisplayString(currentMonth.value) + "월", 1),
            _createElementVNode("button", {
              type: "button",
              class: "modal-header-close",
              "aria-label": "닫기",
              disabled: isClosing.value,
              onClick: _cache[59] || (_cache[59] = ($event: any) => (closingDialogOpen.value = false))
            }, [
              _createVNode(_component_v_icon, { size: "18" }, {
                default: _withCtx(() => [...(_cache[302] || (_cache[302] = [
                  _createTextVNode("mdi-close", -1)
                ]))]),
                _: 1
              })
            ], 8, _hoisted_286)
          ]),
          _createElementVNode("div", _hoisted_287, [
            (isValidating.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_288, [
                  _createVNode(_component_v_progress_circular, {
                    indeterminate: "",
                    size: "32",
                    color: "primary"
                  }),
                  _cache[304] || (_cache[304] = _createElementVNode("p", null, "마감 가능 여부 확인 중...", -1))
                ]))
              : (validationResult.value && !validationResult.value.valid)
                ? (_openBlock(), _createElementBlock("div", _hoisted_289, [
                    _createElementVNode("div", _hoisted_290, [
                      _createVNode(_component_v_icon, {
                        size: "20",
                        color: "#dc2626"
                      }, {
                        default: _withCtx(() => [...(_cache[305] || (_cache[305] = [
                          _createTextVNode("mdi-alert-circle", -1)
                        ]))]),
                        _: 1
                      }),
                      _createElementVNode("span", null, _toDisplayString(validationResult.value.message), 1)
                    ]),
                    (validationResult.value.details && validationResult.value.details.items && validationResult.value.details.items.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_291, [
                          _cache[306] || (_cache[306] = _createElementVNode("p", { class: "items-label" }, "미조정 항목 (최대 10건 표시):", -1)),
                          _createElementVNode("ul", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((validationResult.value.details?.items || []), (item) => {
                              return (_openBlock(), _createElementBlock("li", {
                                key: item.cb_idx
                              }, [
                                _createElementVNode("span", _hoisted_292, _toDisplayString(item.date), 1),
                                _createElementVNode("span", {
                                  class: _normalizeClass(["item-gubun", item.gubun === '수입' ? 'income' : 'expense'])
                                }, _toDisplayString(item.gubun), 3),
                                _createElementVNode("span", _hoisted_293, _toDisplayString(item.memo || '-'), 1),
                                _createElementVNode("span", _hoisted_294, _toDisplayString(formatNumber(item.price)) + "원", 1)
                              ]))
                            }), 128))
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : (validationResult.value?.valid)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_295, [
                      _createElementVNode("div", _hoisted_296, [
                        _createVNode(_component_v_icon, {
                          size: "20",
                          color: "#16a34a"
                        }, {
                          default: _withCtx(() => [...(_cache[307] || (_cache[307] = [
                            _createTextVNode("mdi-check-circle", -1)
                          ]))]),
                          _: 1
                        }),
                        _cache[308] || (_cache[308] = _createElementVNode("span", null, "모든 항목의 계정조정이 완료되었습니다.", -1))
                      ]),
                      _createElementVNode("div", _hoisted_297, [
                        _createElementVNode("div", _hoisted_298, [
                          _cache[309] || (_cache[309] = _createElementVNode("span", { class: "label" }, "총 항목 수", -1)),
                          _createElementVNode("span", _hoisted_299, _toDisplayString(selectedBankCashbookList.value.length) + "건", 1)
                        ]),
                        _createElementVNode("div", _hoisted_300, [
                          _cache[310] || (_cache[310] = _createElementVNode("span", { class: "label" }, "수입", -1)),
                          _createElementVNode("span", _hoisted_301, _toDisplayString(summaryData.value.incomeCount) + "건 / " + _toDisplayString(formatNumber(summaryData.value.income)) + "원", 1)
                        ]),
                        _createElementVNode("div", _hoisted_302, [
                          _cache[311] || (_cache[311] = _createElementVNode("span", { class: "label" }, "지출", -1)),
                          _createElementVNode("span", _hoisted_303, _toDisplayString(summaryData.value.expenseCount) + "건 / " + _toDisplayString(formatNumber(summaryData.value.expense)) + "원", 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_304, [
                        _createVNode(_component_v_icon, {
                          size: "16",
                          color: "#6b7280"
                        }, {
                          default: _withCtx(() => [...(_cache[312] || (_cache[312] = [
                            _createTextVNode("mdi-information-outline", -1)
                          ]))]),
                          _: 1
                        }),
                        _cache[313] || (_cache[313] = _createElementVNode("span", null, "마감 후에는 통장내역을 수정하거나 삭제할 수 없습니다.", -1))
                      ])
                    ]))
                  : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_305, [
            _createElementVNode("button", {
              type: "button",
              class: "btn-cancel",
              onClick: _cache[60] || (_cache[60] = ($event: any) => (closingDialogOpen.value = false))
            }, "취소"),
            (validationResult.value?.valid)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  class: "btn-closing",
                  onClick: executeClosing,
                  disabled: isClosing.value
                }, [
                  (isClosing.value)
                    ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                        key: 0,
                        indeterminate: "",
                        size: "18",
                        width: "2",
                        color: "white"
                      }))
                    : (_openBlock(), _createElementBlock("span", _hoisted_307, "마감 처리"))
                ], 8, _hoisted_306))
              : (validationResult.value && !validationResult.value.valid)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    type: "button",
                    class: "btn-retry",
                    onClick: runValidation
                  }, [
                    _createVNode(_component_v_icon, { size: "16" }, {
                      default: _withCtx(() => [...(_cache[314] || (_cache[314] = [
                        _createTextVNode("mdi-refresh", -1)
                      ]))]),
                      _: 1
                    }),
                    _cache[315] || (_cache[315] = _createTextVNode(" 다시 확인 ", -1))
                  ]))
                : _createCommentVNode("", true)
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(AccountPairManageModal, {
      modelValue: accountPairModalOpen.value,
      "onUpdate:modelValue": _cache[62] || (_cache[62] = ($event: any) => ((accountPairModalOpen).value = $event)),
      year: currentYear.value,
      "income-codes": incomeCodeList.value,
      "expense-codes": expenseCodeList.value,
      onChanged: loadAdjustState
    }, null, 8, ["modelValue", "year", "income-codes", "expense-codes"]),
    _createVNode(BankbookMatchDialog, {
      modelValue: matchDialogOpen.value,
      "onUpdate:modelValue": _cache[63] || (_cache[63] = ($event: any) => ((matchDialogOpen).value = $event)),
      kind: matchKind.value,
      "member-code": memberCode.value,
      year: currentYear.value,
      month: currentMonth.value,
      "biz-gubun": selectedBizGubun.value || '',
      "bank-code": selectedBankCode.value || '',
      "closed-locked": !!closingStatus.value?.isClosed,
      "income-codes": incomeCodeList.value,
      "expense-codes": expenseCodeList.value,
      "cb-idxs": matchTargetIds.value,
      onApplied: loadCashbookData
    }, null, 8, ["modelValue", "kind", "member-code", "year", "month", "biz-gubun", "bank-code", "closed-locked", "income-codes", "expense-codes", "cb-idxs"]),
    _createVNode(LaborRatioDetailModal, {
      modelValue: laborRatioModalOpen.value,
      "onUpdate:modelValue": _cache[64] || (_cache[64] = ($event: any) => ((laborRatioModalOpen).value = $event)),
      "member-code": String(memberCode.value),
      year: currentYear.value,
      month: currentMonth.value,
      "biz-gubun": selectedBizGubun.value || undefined,
      "bank-code": selectedBankCode.value
    }, null, 8, ["modelValue", "member-code", "year", "month", "biz-gubun", "bank-code"]),
    _createVNode(ClosingSettlementModal, {
      modelValue: settlementModalOpen.value,
      "onUpdate:modelValue": _cache[65] || (_cache[65] = ($event: any) => ((settlementModalOpen).value = $event)),
      "member-code": String(memberCode.value),
      year: currentYear.value,
      month: currentMonth.value,
      "biz-gubun": selectedBizGubun.value || undefined,
      "bank-code": selectedBankCode.value
    }, null, 8, ["modelValue", "member-code", "year", "month", "biz-gubun", "bank-code"]),
    _createVNode(_component_v_dialog, {
      modelValue: dictionaryManageModalOpen.value,
      "onUpdate:modelValue": _cache[71] || (_cache[71] = ($event: any) => ((dictionaryManageModalOpen).value = $event)),
      "max-width": "720",
      persistent: ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_308, [
          _createElementVNode("div", _hoisted_309, [
            _createElementVNode("div", _hoisted_310, [
              _createVNode(_component_v_icon, {
                size: "24",
                color: "white"
              }, {
                default: _withCtx(() => [...(_cache[316] || (_cache[316] = [
                  _createTextVNode("mdi-book-search-outline", -1)
                ]))]),
                _: 1
              })
            ]),
            _cache[318] || (_cache[318] = _createElementVNode("div", { class: "header-text" }, [
              _createElementVNode("h3", null, "기억된 적요·계정"),
              _createElementVNode("p", null, "예전에 지정해 두어 추천에 쓰이는 적요와 계정입니다. 잘못된 것만 삭제하세요.")
            ], -1)),
            _createElementVNode("button", {
              class: "close-btn",
              onClick: _cache[66] || (_cache[66] = ($event: any) => (dictionaryManageModalOpen.value = false))
            }, [
              _createVNode(_component_v_icon, { size: "20" }, {
                default: _withCtx(() => [...(_cache[317] || (_cache[317] = [
                  _createTextVNode("mdi-close", -1)
                ]))]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_311, [
            _createElementVNode("div", _hoisted_312, [
              _createElementVNode("button", {
                type: "button",
                class: _normalizeClass(["pattern-tab", { on: selectedDictTable.value === 'income' }]),
                onClick: _cache[67] || (_cache[67] = ($event: any) => (selectDictTable('income')))
              }, [
                _cache[319] || (_cache[319] = _createTextVNode(" 수입 ", -1)),
                (dictionaryStats.value)
                  ? (_openBlock(), _createElementBlock("em", _hoisted_313, _toDisplayString(formatNumber(dictionaryStats.value.income)), 1))
                  : _createCommentVNode("", true)
              ], 2),
              _createElementVNode("button", {
                type: "button",
                class: _normalizeClass(["pattern-tab", { on: selectedDictTable.value === 'expense' }]),
                onClick: _cache[68] || (_cache[68] = ($event: any) => (selectDictTable('expense')))
              }, [
                _cache[320] || (_cache[320] = _createTextVNode(" 지출 ", -1)),
                (dictionaryStats.value)
                  ? (_openBlock(), _createElementBlock("em", _hoisted_314, _toDisplayString(formatNumber(dictionaryStats.value.expense)), 1))
                  : _createCommentVNode("", true)
              ], 2)
            ]),
            _createElementVNode("div", _hoisted_315, [
              _createElementVNode("label", _hoisted_316, [
                _createVNode(_component_v_icon, { size: "16" }, {
                  default: _withCtx(() => [...(_cache[321] || (_cache[321] = [
                    _createTextVNode("mdi-magnify", -1)
                  ]))]),
                  _: 1
                }),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[69] || (_cache[69] = ($event: any) => ((dictSearchQuery).value = $event)),
                  type: "search",
                  placeholder: "키워드·계정명 검색",
                  autocomplete: "off"
                }, null, 512), [
                  [
                    _vModelText,
                    dictSearchQuery.value,
                    void 0,
                    { trim: true }
                  ]
                ])
              ]),
              _createElementVNode("span", _hoisted_317, [
                (isDictDetailLoading.value)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode("불러오는 중…")
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(_toDisplayString(filteredDictDetailList.value.length) + "건", 1)
                    ], 64))
              ])
            ]),
            (isDictDetailLoading.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_318, [
                  _createVNode(_component_v_progress_circular, {
                    indeterminate: "",
                    size: "24",
                    width: "2",
                    color: "primary"
                  }),
                  _cache[322] || (_cache[322] = _createElementVNode("span", null, "목록을 불러오는 중…", -1))
                ]))
              : (filteredDictDetailList.value.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_319, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredDictDetailList.value, (item) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: item.cd_idx,
                        class: "dict-item"
                      }, [
                        _createElementVNode("span", {
                          class: "dict-keyword",
                          title: item.cd_keyword
                        }, _toDisplayString(item.cd_keyword), 9, _hoisted_320),
                        _createVNode(_component_v_icon, {
                          size: "12",
                          color: "#94a3b8"
                        }, {
                          default: _withCtx(() => [...(_cache[323] || (_cache[323] = [
                            _createTextVNode("mdi-arrow-right", -1)
                          ]))]),
                          _: 1
                        }),
                        _createElementVNode("span", {
                          class: "dict-scode",
                          title: item.ac_name || item.cd_scode
                        }, _toDisplayString(item.ac_name || item.cd_scode), 9, _hoisted_321),
                        _createElementVNode("span", _hoisted_322, _toDisplayString(item.cd_count) + "회", 1),
                        _createElementVNode("button", {
                          type: "button",
                          class: "dict-delete",
                          title: "삭제",
                          onClick: ($event: any) => (deleteDictItem(item))
                        }, [
                          _createVNode(_component_v_icon, { size: "14" }, {
                            default: _withCtx(() => [...(_cache[324] || (_cache[324] = [
                              _createTextVNode("mdi-close", -1)
                            ]))]),
                            _: 1
                          })
                        ], 8, _hoisted_323)
                      ]))
                    }), 128))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_324, [
                    _createVNode(_component_v_icon, {
                      size: "36",
                      color: "#cbd5e1"
                    }, {
                      default: _withCtx(() => [...(_cache[325] || (_cache[325] = [
                        _createTextVNode("mdi-book-search-outline", -1)
                      ]))]),
                      _: 1
                    }),
                    (dictSearchQuery.value)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_325, "검색 결과가 없습니다."))
                      : (_openBlock(), _createElementBlock("p", _hoisted_326, "아직 기억된 " + _toDisplayString(selectedDictTable.value === 'income' ? '수입' : '지출') + " 적요가 없습니다.", 1)),
                    _cache[326] || (_cache[326] = _createElementVNode("p", { class: "detail-empty-hint" }, "우측에서 계정을 지정하면 적요가 쌓입니다. (자동화 일괄 채우기는 쌓지 않습니다)", -1))
                  ]))
          ]),
          _createElementVNode("div", _hoisted_327, [
            _createElementVNode("button", {
              type: "button",
              class: "btn-cancel",
              onClick: _cache[70] || (_cache[70] = ($event: any) => (dictionaryManageModalOpen.value = false))
            }, " 닫기 ")
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: beneficiaryMatchDialogOpen.value,
      "onUpdate:modelValue": _cache[73] || (_cache[73] = ($event: any) => ((beneficiaryMatchDialogOpen).value = $event)),
      "max-width": "360"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_328, [
          _createElementVNode("div", _hoisted_329, [
            _createVNode(_component_v_icon, {
              size: "20",
              color: "#0d9488"
            }, {
              default: _withCtx(() => [...(_cache[327] || (_cache[327] = [
                _createTextVNode("mdi-account-search", -1)
              ]))]),
              _: 1
            }),
            _cache[329] || (_cache[329] = _createElementVNode("span", null, "수급자 매칭", -1)),
            _createElementVNode("button", {
              class: "close-btn",
              onClick: closeBeneficiaryMatchDialog
            }, [
              _createVNode(_component_v_icon, { size: "18" }, {
                default: _withCtx(() => [...(_cache[328] || (_cache[328] = [
                  _createTextVNode("mdi-close", -1)
                ]))]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_330, [
            (matchTargetItem.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_331, [
                  _createElementVNode("span", _hoisted_332, _toDisplayString(formatDate(matchTargetItem.value.cb_date)), 1),
                  _createElementVNode("span", _hoisted_333, _toDisplayString(matchTargetItem.value.cb_memo || '(적요 없음)'), 1),
                  _createElementVNode("span", _hoisted_334, _toDisplayString(formatNumber(matchTargetItem.value.cb_price)) + "원", 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_335, [
              _createVNode(_component_v_autocomplete, {
                modelValue: selectedBeneficiaryForMatch.value,
                "onUpdate:modelValue": _cache[72] || (_cache[72] = ($event: any) => ((selectedBeneficiaryForMatch).value = $event)),
                items: availableBeneficiaryList.value,
                "item-title": "displayName",
                "item-value": "cb_idx",
                variant: "outlined",
                density: "compact",
                "hide-details": "",
                placeholder: "수급자 검색 또는 선택",
                clearable: "",
                class: "beneficiary-search-input",
                "no-data-text": beneficiaryList.value.length === 0 ? '수납관리에 등록된 수급자가 없습니다' : '수급자가 없습니다'
              }, {
                item: _withCtx(({ item, props }) => [
                  _createVNode(_component_v_list_item, _normalizeProps(_guardReactiveProps(props)), {
                    prepend: _withCtx(() => [
                      _createVNode(_component_v_icon, {
                        size: "18",
                        color: "#0d9488"
                      }, {
                        default: _withCtx(() => [...(_cache[330] || (_cache[330] = [
                          _createTextVNode("mdi-account", -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    subtitle: _withCtx(() => [
                      _createElementVNode("span", _hoisted_336, [
                        (item.raw.cb_ltc_no)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_337, _toDisplayString(item.raw.cb_ltc_no), 1))
                          : _createCommentVNode("", true),
                        (item.raw.totalCharge)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_338, "청구합계: " + _toDisplayString(formatNumber(item.raw.totalCharge)) + "원", 1))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _: 2
                  }, 1040)
                ]),
                _: 1
              }, 8, ["modelValue", "items", "no-data-text"])
            ])
          ]),
          _createElementVNode("div", _hoisted_339, [
            _createElementVNode("button", {
              class: "btn-cancel",
              onClick: closeBeneficiaryMatchDialog
            }, "취소"),
            _createElementVNode("button", {
              class: "btn-confirm",
              onClick: saveBeneficiaryMatch,
              disabled: !selectedBeneficiaryForMatch.value
            }, " 매칭 저장 ", 8, _hoisted_340)
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(SplitModal, {
      modelValue: splitModalOpen.value,
      "onUpdate:modelValue": _cache[74] || (_cache[74] = ($event: any) => ((splitModalOpen).value = $event)),
      "cb-idx": splitTargetCbIdx.value,
      year: currentYear.value,
      "account-codes": [...incomeCodeList.value, ...expenseCodeList.value].map(c => ({ scode: c.scode, sname: c.sname, gubun: c.gubun, displayName: `${c.scode} ${c.sname}` })),
      "bank-list": bankList.value,
      onSaved: onSplitSaved
    }, null, 8, ["modelValue", "cb-idx", "year", "account-codes", "bank-list"]),
    _createVNode(CollectionExcelUploadModal, {
      modelValue: collectionExcelModalOpen.value,
      "onUpdate:modelValue": _cache[75] || (_cache[75] = ($event: any) => ((collectionExcelModalOpen).value = $event)),
      "member-code": memberCode.value,
      year: parseInt(String(currentYear.value)),
      month: parseInt(String(currentMonth.value)),
      "biz-gubun": selectedBizGubun.value,
      onUploaded: onCollectionExcelUploaded
    }, null, 8, ["modelValue", "member-code", "year", "month", "biz-gubun"]),
    _createVNode(_component_v_dialog, {
      modelValue: bankManageDialogOpen.value,
      "onUpdate:modelValue": _cache[90] || (_cache[90] = ($event: any) => ((bankManageDialogOpen).value = $event)),
      "max-width": "700",
      persistent: ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_341, [
          _createElementVNode("div", _hoisted_342, [
            _createElementVNode("div", _hoisted_343, [
              _createVNode(_component_v_icon, {
                size: "24",
                color: "white"
              }, {
                default: _withCtx(() => [...(_cache[331] || (_cache[331] = [
                  _createTextVNode("mdi-bank", -1)
                ]))]),
                _: 1
              })
            ]),
            _cache[334] || (_cache[334] = _createElementVNode("div", { class: "header-text" }, [
              _createElementVNode("h3", null, "통장 관리"),
              _createElementVNode("p", null, "시설의 통장을 등록하고 관리합니다")
            ], -1)),
            _createElementVNode("button", {
              class: "help-btn",
              onClick: _cache[76] || (_cache[76] = ($event: any) => (showBankGuide.value = !showBankGuide.value)),
              title: "통장 안내"
            }, [
              _createVNode(_component_v_icon, { size: "18" }, {
                default: _withCtx(() => [...(_cache[332] || (_cache[332] = [
                  _createTextVNode("mdi-help-circle-outline", -1)
                ]))]),
                _: 1
              })
            ]),
            _createElementVNode("button", {
              class: "close-btn",
              onClick: _cache[77] || (_cache[77] = ($event: any) => (bankManageDialogOpen.value = false))
            }, [
              _createVNode(_component_v_icon, { size: "20" }, {
                default: _withCtx(() => [...(_cache[333] || (_cache[333] = [
                  _createTextVNode("mdi-close", -1)
                ]))]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_344, [
            (showBankGuide.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_345, [
                  _createElementVNode("div", _hoisted_346, [
                    _createVNode(_component_v_icon, {
                      size: "18",
                      color: "#1565c0"
                    }, {
                      default: _withCtx(() => [...(_cache[335] || (_cache[335] = [
                        _createTextVNode("mdi-information", -1)
                      ]))]),
                      _: 1
                    }),
                    _cache[337] || (_cache[337] = _createElementVNode("span", null, "통장의 명칭과 기능", -1)),
                    _createElementVNode("button", {
                      class: "guide-close",
                      onClick: _cache[78] || (_cache[78] = ($event: any) => (showBankGuide.value = false))
                    }, [
                      _createVNode(_component_v_icon, { size: "14" }, {
                        default: _withCtx(() => [...(_cache[336] || (_cache[336] = [
                          _createTextVNode("mdi-close", -1)
                        ]))]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_347, [
                    _cache[340] || (_cache[340] = _createElementVNode("div", { class: "guide-item" }, [
                      _createElementVNode("div", { class: "guide-title" }, [
                        _createElementVNode("span", { class: "guide-number" }, "1"),
                        _createElementVNode("strong", null, "사업비")
                      ]),
                      _createElementVNode("p", null, "전체적인 운영을 위한 수입·지출 통장")
                    ], -1)),
                    _cache[341] || (_cache[341] = _createElementVNode("div", { class: "guide-item" }, [
                      _createElementVNode("div", { class: "guide-title" }, [
                        _createElementVNode("span", { class: "guide-number" }, "2"),
                        _createElementVNode("strong", null, "보조비")
                      ]),
                      _createElementVNode("p", null, "지자체나 국가기관에서 지급하는 보조금"),
                      _createElementVNode("p", { class: "guide-sub" }, "주로 생계보조비가 주이고, 각종(공기청정기, 시설보조 등) 지자체 보조금 사업으로 다양하게 이루어질 수 있습니다.")
                    ], -1)),
                    _cache[342] || (_cache[342] = _createElementVNode("div", { class: "guide-item" }, [
                      _createElementVNode("div", { class: "guide-title" }, [
                        _createElementVNode("span", { class: "guide-number" }, "3"),
                        _createElementVNode("strong", null, "후원금")
                      ]),
                      _createElementVNode("p", null, "후원금을 받는 경우 후원금 통장으로 운영")
                    ], -1)),
                    _cache[343] || (_cache[343] = _createElementVNode("div", { class: "guide-item" }, [
                      _createElementVNode("div", { class: "guide-title" }, [
                        _createElementVNode("span", { class: "guide-number" }, "4"),
                        _createElementVNode("strong", null, "비급여")
                      ]),
                      _createElementVNode("p", null, "수급자 또는 보호자들이 납부하는 본인부담금과 식재료비, 이미용비, 상급침실이용료, 기타비급여수입 별도 관리하기 위한 통장")
                    ], -1)),
                    _createElementVNode("div", _hoisted_348, [
                      _createVNode(_component_v_icon, {
                        size: "14",
                        color: "#f59e0b"
                      }, {
                        default: _withCtx(() => [...(_cache[338] || (_cache[338] = [
                          _createTextVNode("mdi-alert", -1)
                        ]))]),
                        _: 1
                      }),
                      _cache[339] || (_cache[339] = _createElementVNode("span", null, "기타 다른 용도의 통장을 만들 수 있으나, 너무 늘리는 것은 관리하기 어려워 추천하지 않습니다.", -1))
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_349, [
              _createElementVNode("div", _hoisted_350, [
                _createElementVNode("h4", null, [
                  _createVNode(_component_v_icon, { size: "16" }, {
                    default: _withCtx(() => [...(_cache[344] || (_cache[344] = [
                      _createTextVNode("mdi-format-list-bulleted", -1)
                    ]))]),
                    _: 1
                  }),
                  _createTextVNode(" 등록된 통장 (" + _toDisplayString(bankList.value.length) + "개) ", 1)
                ]),
                _createElementVNode("button", {
                  class: "btn-add-bank",
                  onClick: onAddBankClick
                }, [
                  _createVNode(_component_v_icon, { size: "14" }, {
                    default: _withCtx(() => [...(_cache[345] || (_cache[345] = [
                      _createTextVNode("mdi-plus", -1)
                    ]))]),
                    _: 1
                  }),
                  _cache[346] || (_cache[346] = _createTextVNode(" 통장 추가 ", -1))
                ])
              ]),
              (activeBankListForModal.value.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_351, [
                    _createElementVNode("div", _hoisted_352, [
                      _createVNode(_component_v_icon, {
                        size: "14",
                        color: "#059669"
                      }, {
                        default: _withCtx(() => [...(_cache[347] || (_cache[347] = [
                          _createTextVNode("mdi-check-circle", -1)
                        ]))]),
                        _: 1
                      }),
                      _createElementVNode("span", null, "사용중 (" + _toDisplayString(activeBankListForModal.value.length) + ")", 1)
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activeBankListForModal.value, (bank) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: bank.mb_idx,
                        class: "bank-item"
                      }, [
                        _createElementVNode("div", _hoisted_353, [
                          _createElementVNode("div", _hoisted_354, [
                            _createVNode(_component_v_icon, {
                              size: "20",
                              color: "#059669"
                            }, {
                              default: _withCtx(() => [...(_cache[348] || (_cache[348] = [
                                _createTextVNode("mdi-bank", -1)
                              ]))]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_355, [
                            _createElementVNode("div", _hoisted_356, [
                              _createElementVNode("span", _hoisted_357, _toDisplayString(bank.mb_alias), 1),
                              (bank.mb_biz_gubun)
                                ? (_openBlock(), _createElementBlock("span", {
                                    key: 0,
                                    class: "biz-tag",
                                    style: _normalizeStyle({ backgroundColor: getBizColor(bank.mb_biz_gubun), color: 'white' })
                                  }, _toDisplayString(bank.mb_biz_gubun), 5))
                                : _createCommentVNode("", true),
                              _cache[349] || (_cache[349] = _createElementVNode("span", { class: "status-tag using" }, "사용중", -1))
                            ]),
                            _createElementVNode("div", _hoisted_358, [
                              _createElementVNode("span", _hoisted_359, _toDisplayString(bank.mb_bank_name), 1),
                              _createElementVNode("span", _hoisted_360, _toDisplayString(formatAccountNo(bank.mb_account_no)), 1)
                            ]),
                            _createElementVNode("div", _hoisted_361, [
                              _createVNode(_component_v_icon, {
                                size: "12",
                                color: "#94a3b8"
                              }, {
                                default: _withCtx(() => [...(_cache[350] || (_cache[350] = [
                                  _createTextVNode("mdi-calendar-range", -1)
                                ]))]),
                                _: 1
                              }),
                              _createElementVNode("span", null, _toDisplayString(formatBankPeriod(bank)), 1)
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_362, [
                          _createElementVNode("button", {
                            class: "action-btn edit",
                            onClick: ($event: any) => (editBank(bank)),
                            title: "수정"
                          }, [
                            _createVNode(_component_v_icon, { size: "14" }, {
                              default: _withCtx(() => [...(_cache[351] || (_cache[351] = [
                                _createTextVNode("mdi-pencil", -1)
                              ]))]),
                              _: 1
                            })
                          ], 8, _hoisted_363),
                          _createElementVNode("button", {
                            class: "action-btn delete",
                            onClick: ($event: any) => (confirmDeleteBank(bank)),
                            title: "삭제"
                          }, [
                            _createVNode(_component_v_icon, { size: "14" }, {
                              default: _withCtx(() => [...(_cache[352] || (_cache[352] = [
                                _createTextVNode("mdi-delete", -1)
                              ]))]),
                              _: 1
                            })
                          ], 8, _hoisted_364)
                        ])
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              (inactiveBankListForModal.value.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_365, [
                    _createElementVNode("div", {
                      class: "bank-group-header inactive",
                      onClick: _cache[79] || (_cache[79] = ($event: any) => (showInactiveBanks.value = !showInactiveBanks.value))
                    }, [
                      _createVNode(_component_v_icon, {
                        size: "14",
                        color: "#94a3b8"
                      }, {
                        default: _withCtx(() => [...(_cache[353] || (_cache[353] = [
                          _createTextVNode("mdi-archive", -1)
                        ]))]),
                        _: 1
                      }),
                      _createElementVNode("span", null, "종료됨 (" + _toDisplayString(inactiveBankListForModal.value.length) + ")", 1),
                      _createVNode(_component_v_icon, {
                        size: "16",
                        class: _normalizeClass(["expand-icon", { expanded: showInactiveBanks.value }])
                      }, {
                        default: _withCtx(() => [...(_cache[354] || (_cache[354] = [
                          _createTextVNode(" mdi-chevron-down ", -1)
                        ]))]),
                        _: 1
                      }, 8, ["class"])
                    ]),
                    (showInactiveBanks.value)
                      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(inactiveBankListForModal.value, (bank) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: bank.mb_idx,
                            class: "bank-item inactive"
                          }, [
                            _createElementVNode("div", _hoisted_366, [
                              _createElementVNode("div", _hoisted_367, [
                                _createVNode(_component_v_icon, {
                                  size: "20",
                                  color: "#94a3b8"
                                }, {
                                  default: _withCtx(() => [...(_cache[355] || (_cache[355] = [
                                    _createTextVNode("mdi-bank", -1)
                                  ]))]),
                                  _: 1
                                })
                              ]),
                              _createElementVNode("div", _hoisted_368, [
                                _createElementVNode("div", _hoisted_369, [
                                  _createElementVNode("span", _hoisted_370, _toDisplayString(bank.mb_alias), 1),
                                  (bank.mb_biz_gubun)
                                    ? (_openBlock(), _createElementBlock("span", {
                                        key: 0,
                                        class: "biz-tag faded",
                                        style: _normalizeStyle({ backgroundColor: getBizColor(bank.mb_biz_gubun), opacity: 0.5 })
                                      }, _toDisplayString(bank.mb_biz_gubun), 5))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("span", _hoisted_371, _toDisplayString(getBankStatusText(bank)), 1)
                                ]),
                                _createElementVNode("div", _hoisted_372, [
                                  _createElementVNode("span", _hoisted_373, _toDisplayString(bank.mb_bank_name), 1),
                                  _createElementVNode("span", _hoisted_374, _toDisplayString(formatAccountNo(bank.mb_account_no)), 1)
                                ]),
                                _createElementVNode("div", _hoisted_375, [
                                  _createVNode(_component_v_icon, {
                                    size: "12",
                                    color: "#94a3b8"
                                  }, {
                                    default: _withCtx(() => [...(_cache[356] || (_cache[356] = [
                                      _createTextVNode("mdi-calendar-range", -1)
                                    ]))]),
                                    _: 1
                                  }),
                                  _createElementVNode("span", null, _toDisplayString(formatBankPeriod(bank)), 1)
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_376, [
                              _createElementVNode("button", {
                                class: "action-btn edit",
                                onClick: ($event: any) => (editBank(bank)),
                                title: "수정"
                              }, [
                                _createVNode(_component_v_icon, { size: "14" }, {
                                  default: _withCtx(() => [...(_cache[357] || (_cache[357] = [
                                    _createTextVNode("mdi-pencil", -1)
                                  ]))]),
                                  _: 1
                                })
                              ], 8, _hoisted_377),
                              _createElementVNode("button", {
                                class: "action-btn delete",
                                onClick: ($event: any) => (confirmDeleteBank(bank)),
                                title: "삭제"
                              }, [
                                _createVNode(_component_v_icon, { size: "14" }, {
                                  default: _withCtx(() => [...(_cache[358] || (_cache[358] = [
                                    _createTextVNode("mdi-delete", -1)
                                  ]))]),
                                  _: 1
                                })
                              ], 8, _hoisted_378)
                            ])
                          ]))
                        }), 128))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (bankList.value.length === 0 && !showBankForm.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_379, [
                    _createVNode(_component_v_icon, {
                      size: "48",
                      color: "#cbd5e1"
                    }, {
                      default: _withCtx(() => [...(_cache[359] || (_cache[359] = [
                        _createTextVNode("mdi-bank-off", -1)
                      ]))]),
                      _: 1
                    }),
                    _cache[360] || (_cache[360] = _createElementVNode("p", null, "등록된 통장이 없습니다.", -1)),
                    _cache[361] || (_cache[361] = _createElementVNode("p", { class: "sub" }, "통장 추가 버튼을 눌러 등록해주세요.", -1))
                  ]))
                : _createCommentVNode("", true)
            ]),
            (showBankForm.value)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  ref_key: "bankFormSectionRef",
                  ref: bankFormSectionRef,
                  class: "bank-form-section"
                }, [
                  _createElementVNode("div", _hoisted_380, [
                    _createElementVNode("h4", null, [
                      _createVNode(_component_v_icon, { size: "16" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(editingBank.value ? 'mdi-pencil' : 'mdi-plus'), 1)
                        ]),
                        _: 1
                      }),
                      _createTextVNode(" " + _toDisplayString(editingBank.value ? '통장 수정' : '통장 등록'), 1)
                    ]),
                    _createElementVNode("button", {
                      class: "btn-close-form",
                      onClick: _cache[80] || (_cache[80] = ($event: any) => (showBankForm.value = false))
                    }, [
                      _createVNode(_component_v_icon, { size: "14" }, {
                        default: _withCtx(() => [...(_cache[362] || (_cache[362] = [
                          _createTextVNode("mdi-close", -1)
                        ]))]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_381, [
                    _createElementVNode("div", _hoisted_382, [
                      _createElementVNode("div", _hoisted_383, [
                        _cache[363] || (_cache[363] = _createElementVNode("label", null, "통장 별칭", -1)),
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          "onUpdate:modelValue": _cache[81] || (_cache[81] = ($event: any) => ((bankFormData.value.mb_alias) = $event)),
                          placeholder: "예: 본인부담금통장, 생계비통장",
                          class: "form-input"
                        }, null, 512), [
                          [_vModelText, bankFormData.value.mb_alias]
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_384, [
                      _createElementVNode("div", _hoisted_385, [
                        _cache[364] || (_cache[364] = _createElementVNode("label", null, "은행명", -1)),
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          "onUpdate:modelValue": _cache[82] || (_cache[82] = ($event: any) => ((bankFormData.value.mb_bank_name) = $event)),
                          placeholder: "예: 국민은행, 신한은행",
                          class: "form-input"
                        }, null, 512), [
                          [_vModelText, bankFormData.value.mb_bank_name]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_386, [
                        _cache[365] || (_cache[365] = _createElementVNode("label", null, "계좌번호", -1)),
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          "onUpdate:modelValue": _cache[83] || (_cache[83] = ($event: any) => ((bankFormData.value.mb_account_no) = $event)),
                          placeholder: "계좌번호 입력",
                          class: "form-input"
                        }, null, 512), [
                          [_vModelText, bankFormData.value.mb_account_no]
                        ])
                      ])
                    ]),
                    (facilityBizGubunList.value.length > 1)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_387, [
                          _createElementVNode("div", _hoisted_388, [
                            _cache[366] || (_cache[366] = _createElementVNode("label", null, [
                              _createTextVNode("사업구분 "),
                              _createElementVNode("span", { class: "required" }, "*")
                            ], -1)),
                            _createElementVNode("div", _hoisted_389, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(facilityBizGubunList.value, (biz) => {
                                return (_openBlock(), _createElementBlock("label", {
                                  key: biz,
                                  class: _normalizeClass(["biz-radio-item", { selected: bankFormData.value.mb_biz_gubun === biz }])
                                }, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "radio",
                                    value: biz,
                                    "onUpdate:modelValue": _cache[84] || (_cache[84] = ($event: any) => ((bankFormData.value.mb_biz_gubun) = $event)),
                                    name: "bankBizGubun2"
                                  }, null, 8, _hoisted_390), [
                                    [_vModelRadio, bankFormData.value.mb_biz_gubun]
                                  ]),
                                  _createElementVNode("span", {
                                    class: "radio-label",
                                    style: _normalizeStyle({ 
                          backgroundColor: bankFormData.value.mb_biz_gubun === biz ? getBizColor(biz) : 'transparent',
                          color: bankFormData.value.mb_biz_gubun === biz ? 'white' : getBizColor(biz),
                          borderColor: getBizColor(biz)
                        })
                                  }, _toDisplayString(biz), 5)
                                ], 2))
                              }), 128))
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_391, [
                      _createElementVNode("div", _hoisted_392, [
                        _cache[367] || (_cache[367] = _createElementVNode("label", null, "용도 설명", -1)),
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          "onUpdate:modelValue": _cache[85] || (_cache[85] = ($event: any) => ((bankFormData.value.mb_purpose) = $event)),
                          placeholder: "이 통장의 용도를 간략히 설명",
                          class: "form-input"
                        }, null, 512), [
                          [_vModelText, bankFormData.value.mb_purpose]
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_393, [
                      _createElementVNode("div", _hoisted_394, [
                        _cache[368] || (_cache[368] = _createElementVNode("label", null, "사용 시작월", -1)),
                        _withDirectives(_createElementVNode("input", {
                          type: "month",
                          "onUpdate:modelValue": _cache[86] || (_cache[86] = ($event: any) => ((bankFormData.value.mb_start_date) = $event)),
                          class: "form-input"
                        }, null, 512), [
                          [_vModelText, bankFormData.value.mb_start_date]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_395, [
                        _cache[369] || (_cache[369] = _createElementVNode("label", null, "사용 종료월", -1)),
                        _withDirectives(_createElementVNode("input", {
                          type: "month",
                          "onUpdate:modelValue": _cache[87] || (_cache[87] = ($event: any) => ((bankFormData.value.mb_end_date) = $event)),
                          min: bankFormData.value.mb_start_date || undefined,
                          class: "form-input"
                        }, null, 8, _hoisted_396), [
                          [_vModelText, bankFormData.value.mb_end_date]
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_397, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn-cancel",
                        onClick: _cache[88] || (_cache[88] = ($event: any) => (showBankForm.value = false))
                      }, "취소"),
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn-save",
                        onClick: saveBank,
                        disabled: !canSaveBank.value || isSavingBank.value
                      }, [
                        (isSavingBank.value)
                          ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                              key: 0,
                              indeterminate: "",
                              size: "16",
                              width: "2",
                              color: "white"
                            }))
                          : (_openBlock(), _createElementBlock("span", _hoisted_399, _toDisplayString(editingBank.value ? '수정' : '등록'), 1))
                      ], 8, _hoisted_398)
                    ])
                  ])
                ], 512))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_400, [
            _createElementVNode("button", {
              type: "button",
              class: "btn-cancel",
              onClick: _cache[89] || (_cache[89] = ($event: any) => (bankManageDialogOpen.value = false))
            }, " 닫기 ")
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: deleteBankDialogOpen.value,
      "onUpdate:modelValue": _cache[93] || (_cache[93] = ($event: any) => ((deleteBankDialogOpen).value = $event)),
      "max-width": "400"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_401, [
          _createElementVNode("div", _hoisted_402, [
            _createElementVNode("div", _hoisted_403, [
              _createVNode(_component_v_icon, {
                size: "28",
                color: "white"
              }, {
                default: _withCtx(() => [...(_cache[370] || (_cache[370] = [
                  _createTextVNode("mdi-alert", -1)
                ]))]),
                _: 1
              })
            ]),
            _cache[372] || (_cache[372] = _createElementVNode("h3", null, "통장 삭제 확인", -1)),
            _cache[373] || (_cache[373] = _createElementVNode("p", null, "이 작업은 되돌릴 수 없습니다", -1)),
            _createElementVNode("button", {
              type: "button",
              class: "modal-header-close",
              "aria-label": "닫기",
              disabled: isDeletingBank.value,
              onClick: _cache[91] || (_cache[91] = ($event: any) => (deleteBankDialogOpen.value = false))
            }, [
              _createVNode(_component_v_icon, { size: "18" }, {
                default: _withCtx(() => [...(_cache[371] || (_cache[371] = [
                  _createTextVNode("mdi-close", -1)
                ]))]),
                _: 1
              })
            ], 8, _hoisted_404)
          ]),
          _createElementVNode("div", _hoisted_405, [
            _cache[377] || (_cache[377] = _createElementVNode("p", { class: "delete-message" }, "선택한 통장을 삭제하시겠습니까?", -1)),
            (bankToDelete.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_406, [
                  _createElementVNode("div", _hoisted_407, [
                    _cache[374] || (_cache[374] = _createElementVNode("span", { class: "info-label" }, "통장 별칭", -1)),
                    _createElementVNode("span", _hoisted_408, _toDisplayString(bankToDelete.value.mb_alias), 1)
                  ]),
                  _createElementVNode("div", _hoisted_409, [
                    _cache[375] || (_cache[375] = _createElementVNode("span", { class: "info-label" }, "은행", -1)),
                    _createElementVNode("span", _hoisted_410, _toDisplayString(bankToDelete.value.mb_bank_name), 1)
                  ]),
                  _createElementVNode("div", _hoisted_411, [
                    _cache[376] || (_cache[376] = _createElementVNode("span", { class: "info-label" }, "계좌번호", -1)),
                    _createElementVNode("span", _hoisted_412, _toDisplayString(formatAccountNo(bankToDelete.value.mb_account_no)), 1)
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_413, [
            _createElementVNode("button", {
              type: "button",
              class: "btn-cancel",
              onClick: _cache[92] || (_cache[92] = ($event: any) => (deleteBankDialogOpen.value = false))
            }, "취소"),
            _createElementVNode("button", {
              type: "button",
              class: "btn-delete",
              onClick: deleteBank,
              disabled: isDeletingBank.value
            }, [
              (isDeletingBank.value)
                ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                    key: 0,
                    indeterminate: "",
                    size: "18",
                    width: "2",
                    color: "white"
                  }))
                : (_openBlock(), _createElementBlock("span", _hoisted_415, "삭제하기"))
            ], 8, _hoisted_414)
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})